export const GRI_STANDARDS = [
  { id: "gri1-foundation-2021", label: "GRI 1 : Foundation 2021" },
  { id: "gri2-general-disclosure", label: "GRI 2 : General Disclosure" },
  { id: "gri1-foundation-2021-2", label: "GRI 1: Foundation 2021" },
  {
    id: "gri2-general-disclosures-2021",
    label: "GRI 2: General Disclosures 2021",
  },
  { id: "gri3-material-topics-2021", label: "GRI 3: Material Topics 2021" },
  { id: "gri11-oil-gas-sector-2021", label: "GRI 11: Oil and Gas Sector 2021" },
  { id: "gri12-coal-sector-2022", label: "GRI 12: Coal Sector 2022" },
  {
    id: "gri13-agriculture-aquaculture-fishing-2022",
    label: "GRI 13: Agriculture, Aquaculture and Fishing Sectors 2022",
  },
  { id: "gri14-mining-sector-2024", label: "GRI 14: Mining Sector 2024" },
  { id: "gri101-biodiversity-2024", label: "GRI 101: Biodiversity 2024" },
  {
    id: "gri201-economic-performance-2016",
    label: "GRI 201: Economic Performance 2016",
  },
  { id: "gri202-market-presence-2016", label: "GRI 202: Market Presence 2016" },
  {
    id: "gri203-indirect-economic-impacts-2016",
    label: "GRI 203: Indirect Economic Impacts 2016",
  },
  {
    id: "gri204-procurement-practices-2016",
    label: "GRI 204: Procurement Practices 2016",
  },
  { id: "gri205-anti-corruption-2016", label: "GRI 205: Anti-corruption 2016" },
  {
    id: "gri206-anti-competitive-behavior-2016",
    label: "GRI 206: Anti-competitive Behavior 2016",
  },
  { id: "gri207-tax-2019", label: "GRI 207: Tax 2019" },
  { id: "gri301-materials-2016", label: "GRI 301: Materials 2016" },
  { id: "gri302-energy-2016", label: "GRI 302: Energy 2016" },
  {
    id: "gri303-water-effluents-2018",
    label: "GRI 303: Water and Effluents 2018",
  },
  { id: "gri304-biodiversity-2016", label: "GRI 304: Biodiversity 2016" },
  { id: "gri305-emissions-2016", label: "GRI 305: Emissions 2016" },
  {
    id: "gri306-effluents-waste-2016",
    label: "GRI 306: Effluents and Waste 2016",
  },
  { id: "gri306-waste-2020", label: "GRI 306: Waste 2020" },
  {
    id: "gri308-supplier-environmental-2016",
    label: "GRI 308: Supplier Environmental Assessment 2016",
  },
  { id: "gri401-employment-2016", label: "GRI 401: Employment 2016" },
  {
    id: "gri402-labor-management-2016",
    label: "GRI 402: Labor/Management Relations 2016",
  },
  {
    id: "gri403-occupational-health-safety-2018",
    label: "GRI 403: Occupational Health and Safety 2018",
  },
  {
    id: "gri404-training-education-2016",
    label: "GRI 404: Training and Education 2016",
  },
  {
    id: "gri405-diversity-equality-2016",
    label: "GRI 405: Diversity and Equal Opportunity 2016",
  },
  {
    id: "gri406-non-discrimination-2016",
    label: "GRI 406: Non-discrimination 2016",
  },
  {
    id: "gri407-freedom-association-2016",
    label: "GRI 407: Freedom of Association and Collective Bargaining 2016",
  },
  { id: "gri408-child-labor-2016", label: "GRI 408: Child Labor 2016" },
  {
    id: "gri409-forced-labor-2016",
    label: "GRI 409: Forced or Compulsory Labor 2016",
  },
  {
    id: "gri410-security-practices-2016",
    label: "GRI 410: Security Practices 2016",
  },
  {
    id: "gri411-rights-indigenous-2016",
    label: "GRI 411: Rights of Indigenous Peoples 2016",
  },
  {
    id: "gri413-local-communities-2016",
    label: "GRI 413: Local Communities 2016",
  },
  {
    id: "gri414-supplier-social-2016",
    label: "GRI 414: Supplier Social Assessment 2016",
  },
  { id: "gri415-public-policy-2016", label: "GRI 415: Public Policy 2016" },
  {
    id: "gri416-customer-health-safety-2016",
    label: "GRI 416: Customer Health and Safety 2016",
  },
  {
    id: "gri417-marketing-labeling-2016",
    label: "GRI 417: Marketing and Labeling 2016",
  },
  {
    id: "gri418-customer-privacy-2016",
    label: "GRI 418: Customer Privacy 2016",
  },
  { id: "others", label: "Others" },
];
export const MATERIAL_BY_ESG_TOPICS = [
  {
    heading: "Environmental",
    items: [
      { id: "biodiversity", label: "Biodiversity" },
      { id: "energy-efficiency", label: "Energy Efficiency" },
      { id: "climate-change-mitigation", label: "Climate Change Mitigation" },
      { id: "sustainable-materials", label: "Sustainable Materials" },
      { id: "circular-economy", label: "Circular Economy" },
      { id: "air-quality", label: "Air Quality" },
      { id: "land-use", label: "Land Use" },
      { id: "deforestation", label: "Deforestation" },
      { id: "renewable-energy", label: "Renewable Energy" },
      { id: "carbon-footprint", label: "Carbon Footprint" },
      { id: "chemical-management", label: "Chemical Management" },
      { id: "waste", label: "Waste" },
      { id: "emissions", label: "Emissions (GHG Scope 1, 2, 3)" },
      { id: "noise-pollution", label: "Noise Pollution" },
      { id: "water-discharge-quality", label: "Water Discharge & Quality" },
      { id: "soil-contamination", label: "Soil Contamination" },
      { id: "spill-prevention", label: "Spill Prevention" },
    ],
  },
  {
    heading: "Social",
    items: [
      {
        id: "occupational-health-safety",
        label: "Occupational Health & Safety",
      },
      { id: "community-development", label: "Community Development" },
      { id: "human-rights-due-diligence", label: "Human Rights Due Diligence" },
      { id: "customer-health-safety", label: "Customer Health & Safety" },
      { id: "labor-practices", label: "Labor Practices" },
      { id: "gender-equality", label: "Gender Equality" },
      { id: "diversity-inclusion", label: "Diversity & Inclusion" },
      { id: "training-development", label: "Training & Development" },
      { id: "indigenous-rights", label: "Indigenous Rights" },
      { id: "fair-wages", label: "Fair Wages" },
      { id: "freedom-of-association", label: "Freedom of Association" },
      { id: "child-labor", label: "Child Labor" },
      { id: "forced-labor", label: "Forced or Compulsory Labor" },
      { id: "migrant-workers-rights", label: "Rights of Migrant Workers" },
      { id: "grievance-mechanisms", label: "Grievance Mechanisms" },
      {
        id: "accessibility-inclusion",
        label: "Accessibility & Inclusion (Disability rights)",
      },
      { id: "local-hiring", label: "Local Hiring" },
    ],
  },
  {
    heading: "Governance",
    items: [
      { id: "anti-corruption", label: "Anti-Corruption" },
      { id: "data-privacy-security", label: "Data Privacy & Security" },
      { id: "tax-transparency", label: "Tax Transparency" },
      { id: "board-diversity", label: "Board Diversity" },
      { id: "supply-chain-ethics", label: "Supply Chain Ethics" },
      { id: "whistleblower-protection", label: "Whistleblower Protection" },
      { id: "esg-risk-management", label: "ESG Risk Management" },
      { id: "policy-advocacy", label: "Policy Advocacy" },
      { id: "executive-compensation", label: "Executive Compensation" },
      { id: "stakeholder-engagement", label: "Stakeholder Engagement" },
      { id: "business-ethics", label: "Business Ethics" },
      {
        id: "lobbying-political-contributions",
        label: "Lobbying & Political Contributions",
      },
      { id: "third-party-audits", label: "Third-party Audits" },
    ],
  },
  {
    heading: null,
    items: [{ id: "others", label: "Others" }],
  },
];
export const INDUSTRY_SASB_DISCLOSURES = [
  {
    heading: "1). Consumer Goods",
    items: [
      {
        id: "apparel-accessories-footwear",
        label: "Apparel, Accessories & Footwear",
      },
      { id: "appliance-manufacturing", label: "Appliance Manufacturing" },
      {
        id: "building-products-furnishings",
        label: "Building Products & Furnishings",
      },
      { id: "e-commerce", label: "E-commerce" },
      {
        id: "household-personal-products",
        label: "Household & Personal Products",
      },
      {
        id: "multiline-specialty-retail",
        label: "Multiline and Specialty Retailers & Distributors",
      },
      { id: "toys-sporting-goods", label: "Toys & Sporting Goods" },
    ],
  },
  {
    heading: "2). Extractives & Minerals Processing",
    items: [
      { id: "coal-operations", label: "Coal Operations" },
      { id: "construction-materials", label: "Construction Materials" },
      { id: "iron-steel-producers", label: "Iron & Steel Producers" },
      { id: "metals-mining", label: "Metals & Mining" },
      {
        id: "oil-gas-exploration-production",
        label: "Oil & Gas – Exploration & Production",
      },
      { id: "oil-gas-midstream", label: "Oil & Gas – Midstream" },
      {
        id: "oil-gas-refining-marketing",
        label: "Oil & Gas – Refining & Marketing",
      },
      { id: "oil-gas-services", label: "Oil & Gas – Services" },
    ],
  },
  {
    heading: "3). Financials",
    items: [
      {
        id: "asset-management-custody",
        label: "Asset Management & Custody Activities",
      },
      { id: "commercial-banks", label: "Commercial Banks" },
      { id: "consumer-finance", label: "Consumer Finance" },
      { id: "insurance", label: "Insurance" },
      {
        id: "investment-banking-brokerage",
        label: "Investment Banking & Brokerage",
      },
      { id: "mortgage-finance", label: "Mortgage Finance" },
      {
        id: "security-commodity-exchanges",
        label: "Security & Commodity Exchanges",
      },
    ],
  },
  {
    heading: "4). Food & Beverage",
    items: [
      { id: "agricultural-products", label: "Agricultural Products" },
      { id: "alcoholic-beverages", label: "Alcoholic Beverages" },
      {
        id: "food-retailers-distributors",
        label: "Food Retailers & Distributors",
      },
      { id: "meat-poultry-dairy", label: "Meat, Poultry & Dairy" },
      { id: "non-alcoholic-beverages", label: "Non-Alcoholic Beverages" },
      { id: "processed-foods", label: "Processed Foods" },
      { id: "restaurants", label: "Restaurants" },
      { id: "tobacco", label: "Tobacco" },
    ],
  },
  {
    heading: "5). Health Care",
    items: [
      {
        id: "biotechnology-pharmaceuticals",
        label: "Biotechnology & Pharmaceuticals",
      },
      { id: "drug-retailers", label: "Drug Retailers" },
      { id: "health-care-delivery", label: "Health Care Delivery" },
      { id: "health-care-distributors", label: "Health Care Distributors" },
      { id: "managed-care", label: "Managed Care" },
      {
        id: "medical-equipment-supplies",
        label: "Medical Equipment & Supplies",
      },
    ],
  },
  {
    heading: "6). Infrastructure",
    items: [
      {
        id: "electric-utilities-power-generators",
        label: "Electric Utilities & Power Generators",
      },
      {
        id: "engineering-construction-services",
        label: "Engineering & Construction Services",
      },
      {
        id: "gas-utilities-distributors",
        label: "Gas Utilities & Distributors",
      },
      { id: "home-builders", label: "Home Builders" },
      { id: "real-estate", label: "Real Estate" },
      { id: "real-estate-services", label: "Real Estate Services" },
      { id: "waste-management", label: "Waste Management" },
      { id: "water-utilities-services", label: "Water Utilities & Services" },
    ],
  },
  {
    heading: "7). Renewable Resources & Alternative Energy",
    items: [
      { id: "biofuels", label: "Biofuels" },
      { id: "forestry-management", label: "Forestry Management" },
      {
        id: "fuel-cells-industrial-batteries",
        label: "Fuel Cells & Industrial Batteries",
      },
      { id: "pulp-paper-products", label: "Pulp & Paper Products" },
      { id: "solar-technology", label: "Solar Technology & Project Developer" },
      { id: "wind-technology", label: "Wind Technology & Project Developers" },
    ],
  },
  {
    heading: "8). Resource Transformation",
    items: [
      { id: "aerospace-defense", label: "Aerospace & Defense" },
      { id: "chemicals", label: "Chemicals" },
      { id: "containers-packaging", label: "Containers & Packaging" },
      {
        id: "electrical-electronic-equipment",
        label: "Electrical & Electronic Equipment",
      },
      {
        id: "industrial-machinery-goods",
        label: "Industrial Machinery & Goods",
      },
    ],
  },
  {
    heading: "9). Services",
    items: [
      { id: "advertising-marketing", label: "Advertising & Marketing" },
      { id: "casinos-gaming", label: "Casinos & Gaming" },
      { id: "education", label: "Education" },
      { id: "hotels-lodging", label: "Hotels & Lodging" },
      { id: "leisure-facilities", label: "Leisure Facilities" },
      { id: "media-entertainment", label: "Media & Entertainment" },
      {
        id: "professional-commercial-services",
        label: "Professional & Commercial Services",
      },
    ],
  },
  {
    heading: "10). Technology & Communications",
    items: [
      {
        id: "electronic-manufacturing-services",
        label:
          "Electronic Manufacturing Services & Original Design Manufacturing",
      },
      { id: "hardware", label: "Hardware" },
      { id: "internet-media-services", label: "Internet Media & Services" },
      { id: "semiconductors", label: "Semiconductors" },
      { id: "software-it-services", label: "Software & IT Services" },
      { id: "telecommunication-services", label: "Telecommunication Services" },
    ],
  },
  {
    heading: "11). Transportation",
    items: [
      { id: "air-freight-logistics", label: "Air Freight & Logistics" },
      { id: "airlines", label: "Airlines" },
      { id: "auto-parts", label: "Auto Parts" },
      { id: "automobiles", label: "Automobiles" },
      { id: "car-rental-leasing", label: "Car Rental & Leasing" },
      { id: "cruise-lines", label: "Cruise Lines" },
      { id: "marine-transportation", label: "Marine Transportation" },
      { id: "rail-transportation", label: "Rail Transportation" },
      { id: "road-transportation", label: "Road Transportation" },
    ],
  },
  {
    heading: "Others",
    items: [{ id: "others", label: "Others" }],
  },
];
export const INDUSTRY_SPECIFIC_DISCLOSURE_CATEOGRY = [
  // Consumer Goods
  {
    id: "apparel-accessories-footwear",
    label: "Apparel, Accessories & Footwear",
  },
  { id: "appliance-manufacturing", label: "Appliance Manufacturing" },
  {
    id: "building-products-furnishings",
    label: "Building Products & Furnishings",
  },
  { id: "e-commerce", label: "E-commerce" },
  { id: "household-personal-products", label: "Household & Personal Products" },
  {
    id: "multiline-specialty-retailers-distributors",
    label: "Multiline and Specialty Retailers & Distributors",
  },
  { id: "toys-sporting-goods", label: "Toys & Sporting Goods" },

  // Extractives & Minerals Processing
  { id: "coal-operations", label: "Coal Operations" },
  { id: "construction-materials", label: "Construction Materials" },
  { id: "iron-steel-producers", label: "Iron & Steel Producers" },
  { id: "metals-mining", label: "Metals & Mining" },
  {
    id: "oil-gas-exploration-production",
    label: "Oil & Gas – Exploration & Production",
  },
  { id: "oil-gas-midstream", label: "Oil & Gas – Midstream" },
  {
    id: "oil-gas-refining-marketing",
    label: "Oil & Gas – Refining & Marketing",
  },
  { id: "oil-gas-services", label: "Oil & Gas – Services" },

  // Financials
  {
    id: "asset-management-custody",
    label: "Asset Management & Custody Activities",
  },
  { id: "commercial-banks", label: "Commercial Banks" },
  { id: "consumer-finance", label: "Consumer Finance" },
  { id: "insurance", label: "Insurance" },
  {
    id: "investment-banking-brokerage",
    label: "Investment Banking & Brokerage",
  },
  { id: "mortgage-finance", label: "Mortgage Finance" },
  {
    id: "security-commodity-exchanges",
    label: "Security & Commodity Exchanges",
  },

  // Food & Beverage
  { id: "agricultural-products", label: "Agricultural Products" },
  { id: "alcoholic-beverages", label: "Alcoholic Beverages" },
  { id: "food-retailers-distributors", label: "Food Retailers & Distributors" },
  { id: "meat-poultry-dairy", label: "Meat, Poultry & Dairy" },
  { id: "non-alcoholic-beverages", label: "Non-Alcoholic Beverages" },
  { id: "processed-foods", label: "Processed Foods" },
  { id: "restaurants", label: "Restaurants" },
  { id: "tobacco", label: "Tobacco" },

  // Health Care
  {
    id: "biotechnology-pharmaceuticals",
    label: "Biotechnology & Pharmaceuticals",
  },
  { id: "drug-retailers", label: "Drug Retailers" },
  { id: "health-care-delivery", label: "Health Care Delivery" },
  { id: "health-care-distributors", label: "Health Care Distributors" },
  { id: "managed-care", label: "Managed Care" },
  { id: "medical-equipment-supplies", label: "Medical Equipment & Supplies" },

  // Infrastructure
  {
    id: "electric-utilities-power-generators",
    label: "Electric Utilities & Power Generators",
  },
  {
    id: "engineering-construction-services",
    label: "Engineering & Construction Services",
  },
  { id: "gas-utilities-distributors", label: "Gas Utilities & Distributors" },
  { id: "home-builders", label: "Home Builders" },
  { id: "real-estate", label: "Real Estate" },
  { id: "real-estate-services", label: "Real Estate Services" },
  { id: "waste-management", label: "Waste Management" },
  { id: "water-utilities-services", label: "Water Utilities & Services" },

  // Renewable Resources & Alternative Energy
  { id: "biofuels", label: "Biofuels" },
  { id: "forestry-management", label: "Forestry Management" },
  {
    id: "fuel-cells-industrial-batteries",
    label: "Fuel Cells & Industrial Batteries",
  },
  { id: "pulp-paper-products", label: "Pulp & Paper Products" },
  {
    id: "solar-tech-project-developer",
    label: "Solar Technology & Project Developer",
  },
  {
    id: "wind-tech-project-developers",
    label: "Wind Technology & Project Developers",
  },

  // Resource Transformation
  { id: "aerospace-defense", label: "Aerospace & Defense" },
  { id: "chemicals", label: "Chemicals" },
  { id: "containers-packaging", label: "Containers & Packaging" },
  {
    id: "electrical-electronic-equipment",
    label: "Electrical & Electronic Equipment",
  },
  { id: "industrial-machinery-goods", label: "Industrial Machinery & Goods" },

  // Services
  { id: "advertising-marketing", label: "Advertising & Marketing" },
  { id: "casinos-gaming", label: "Casinos & Gaming" },
  { id: "education", label: "Education" },
  { id: "hotels-lodging", label: "Hotels & Lodging" },
  { id: "leisure-facilities", label: "Leisure Facilities" },
  { id: "media-entertainment", label: "Media & Entertainment" },
  {
    id: "professional-commercial-services",
    label: "Professional & Commercial Services",
  },

  // Technology & Communications
  {
    id: "electronic-manufacturing-services-odm",
    label: "Electronic Manufacturing Services & Original Design Manufacturing",
  },
  { id: "hardware", label: "Hardware" },
  { id: "internet-media-services", label: "Internet Media & Services" },
  { id: "semiconductors", label: "Semiconductors" },
  { id: "software-it-services", label: "Software & IT Services" },
  { id: "telecommunication-services", label: "Telecommunication Services" },

  // Transportation
  { id: "air-freight-logistics", label: "Air Freight & Logistics" },
  { id: "airlines", label: "Airlines" },
  { id: "auto-parts", label: "Auto Parts" },
  { id: "automobiles", label: "Automobiles" },
  { id: "car-rental-leasing", label: "Car Rental & Leasing" },
  { id: "cruise-lines", label: "Cruise Lines" },
  { id: "marine-transportation", label: "Marine Transportation" },
  { id: "rail-transportation", label: "Rail Transportation" },
  { id: "road-transportation", label: "Road Transportation" },

  // Others
  { id: "others", label: "Others" },
];
export const SASB_DISCLOSURE_CATEOGRY = [
  {
    heading: "Environment",
    items: [
      { id: "ghg-emissions", label: "GHG Emissions" },
      { id: "air-quality", label: "Air Quality" },
      { id: "noise-quality", label: "Noise Quality" },
      { id: "energy-management", label: "Energy Management" },
      {
        id: "water-wastewater-management",
        label: "Water & Wastewater Management",
      },
      {
        id: "waste-hazardous-materials-management",
        label: "Waste & Hazardous Materials Management",
      },
      { id: "ecological-impacts", label: "Ecological Impacts" },
    ],
  },
  {
    heading: "Social Capital",
    items: [
      {
        id: "human-rights-community-relations",
        label: "Human Rights & Community Relations",
      },
      { id: "customer-privacy", label: "Customer Privacy" },
      { id: "data-security", label: "Data Security" },
      { id: "access-affordability", label: "Access & Affordability" },
      { id: "product-quality-safety", label: "Product Quality & Safety" },
      { id: "customer-welfare", label: "Customer Welfare" },
      {
        id: "selling-practices-product-labeling",
        label: "Selling Practices & Product Labeling",
      },
    ],
  },
  {
    heading: "Human Capital",
    items: [
      { id: "labor-practices", label: "Labor Practices" },
      { id: "employee-health-safety", label: "Employee Health & Safety" },
      {
        id: "employee-engagement-diversity-inclusion",
        label: "Employee Engagement, Diversity & Inclusion",
      },
    ],
  },
  {
    heading: "Business Model & Innovation",
    items: [
      {
        id: "product-design-lifecycle-management",
        label: "Product Design & Lifecycle Management",
      },
      { id: "business-model-resilience", label: "Business Model Resilience" },
      { id: "supply-chain-management", label: "Supply Chain Management" },
      {
        id: "materials-sourcing-efficiency",
        label: "Materials Sourcing & Efficiency",
      },
      {
        id: "physical-impacts-climate-change",
        label: "Physical Impacts of Climate Change",
      },
    ],
  },
  {
    heading: "Leadership & Governance",
    items: [
      { id: "business-ethics", label: "Business Ethics" },
      { id: "competitive-behavior", label: "Competitive Behavior" },
      {
        id: "legal-regulatory-environment",
        label: "Management of the Legal & Regulatory Environment",
      },
      {
        id: "critical-incident-risk-management",
        label: "Critical Incident Risk Management",
      },
      { id: "systemic-risk-management", label: "Systemic Risk Management" },
    ],
  },
  {
    heading: null,
    items: [{ id: "others", label: "Others" }],
  },
];
export const TCFD_DISCLOSURE_CATEGORY = [
  {
    heading: "1. Governance",
    items: [
      { id: "board-oversight", label: "Board Oversight" },
      { id: "management-role", label: "Management's Role" },
      {
        id: "climate-governance-structure",
        label: "Climate Governance Structure",
      },
      { id: "sustainability-committees", label: "Sustainability Committees" },
      { id: "reporting-lines", label: "Reporting Lines to the Board" },
      {
        id: "climate-in-compensation",
        label: "Climate Integration in Executive Compensation",
      },
      {
        id: "org-structure-climate",
        label: "Organizational Structure for Climate Governance",
      },
      {
        id: "board-sustainability-committees",
        label: "Board-level Sustainability Committees",
      },
      {
        id: "climate-accountability",
        label: "Climate Accountability at Management Level",
      },
      { id: "audit-review-cycles", label: "Internal Audit and Review Cycles" },
      {
        id: "senior-climate-decisions",
        label: "Senior-Level Decision-Making on Climate",
      },
    ],
  },
  {
    heading: "2. Strategy",
    items: [
      {
        id: "climate-risks-opportunities",
        label: "Climate-related Risks and Opportunities",
      },
      { id: "time-horizons", label: "Short, Medium, Long-Term Horizon" },
      { id: "scenario-analysis", label: "Scenario Analysis" },
      { id: "strategic-resilience", label: "Strategic Resilience" },
      { id: "financial-planning", label: "Financial Planning Impacts" },
      {
        id: "sector-geography-exposure",
        label: "Sectoral and Geographical Exposure",
      },
      { id: "transition-risks", label: "Transition Risks" },
      { id: "physical-risks", label: "Physical Risks" },
      { id: "climate-opportunities", label: "Climate-related Opportunities" },
      { id: "net-zero-alignment", label: "Net Zero Alignment" },
      { id: "resilience-planning", label: "Climate Resilience Planning" },
      { id: "business-vulnerability", label: "Business Model Vulnerability" },
      {
        id: "regulatory-tech-market-reputation",
        label: "Regulatory, Technology, Market, Reputation Risks",
      },
      {
        id: "climate-based-decisions",
        label: "Strategic Decisions Based on Climate Projections",
      },
      { id: "sector-risk-mapping", label: "Sector/Geographic Risk Mapping" },
      { id: "public-incentives", label: "Use of Public-Sector Incentives" },
      { id: "low-carbon-investment", label: "Low-Carbon Investment and R&D" },
      { id: "adaptation-strategies", label: "Adaptation Strategies" },
    ],
  },
  {
    heading: "3. Risk Management",
    items: [
      {
        id: "risk-identification",
        label: "Risk Identification and Assessment",
      },
      { id: "emerging-risks", label: "Emerging Risks" },
      { id: "principal-risks", label: "Principal Risks" },
      { id: "risk-management-process", label: "Risk Management Processes" },
      {
        id: "risk-in-erm",
        label: "Risk Integration into Enterprise Risk Management (ERM)",
      },
      { id: "transition-vs-physical", label: "Transition vs Physical Risks" },
      { id: "risk-registers", label: "Risk Registers" },
      { id: "exposure-assessments", label: "Exposure Assessments" },
      { id: "climate-risk-governance", label: "Climate Risk Governance" },
      {
        id: "monitoring-response",
        label: "Monitoring and Response Mechanisms",
      },
      { id: "stress-testing", label: "Stress Testing" },
      { id: "risk-heatmap", label: "Risk Heat Mapping" },
      {
        id: "risk-categorization",
        label: "Emerging vs Principal Risk Categorization",
      },
      {
        id: "operational-risk-climate",
        label: "Climate Risks in Operational Risk",
      },
      { id: "scenario-risk-eval", label: "Scenario-Based Risk Evaluation" },
      { id: "risk-ownership", label: "Risk Ownership Roles" },
      {
        id: "insurance-coverage",
        label: "Insurance Coverage for Climate Events",
      },
    ],
  },
  {
    heading: "3.1. Physical Risks",
    subheading: "Acute Physical Risks",
    description: "Short-term, event-driven:",
    items: [
      { id: "hurricanes", label: "Hurricanes" },
      { id: "cyclones", label: "Cyclones" },
      { id: "floods", label: "Floods (Coastal, River, Flash)" },
      { id: "wildfires", label: "Wildfires" },
      { id: "heatwaves", label: "Extreme Heatwaves" },
      { id: "landslides", label: "Landslides" },
    ],
  },
  {
    heading: null,
    subheading: "Chronic Physical Risks",
    description: "Long-term climate shifts:",
    items: [
      { id: "sea-level-rise", label: "Rising Sea Levels" },
      { id: "droughts", label: "Droughts" },
      { id: "desertification", label: "Desertification" },
      { id: "water-stress", label: "Water Stress" },
      {
        id: "agriculture-decline",
        label: "Decreased Agricultural Productivity",
      },
      { id: "glacier-melt", label: "Glacier Melt" },
      { id: "extreme-temp", label: "Extreme Temperature" },
    ],
  },
  {
    heading: "3.2. Transition Risks",
    subheading: "Policy & Legal Risks",
    items: [
      { id: "carbon-pricing", label: "Carbon Pricing (Taxes, Cap-and-Trade)" },
      { id: "regulatory-compliance", label: "Regulatory Compliance" },
      { id: "disclosure-laws", label: "Mandatory Climate Disclosure Laws" },
      {
        id: "climate-litigation",
        label: "Legal Liability and Climate Litigation",
      },
      { id: "climate-tax-policy", label: "Taxation Policies" },
      { id: "climate-trade-restrictions", label: "Trade Restrictions" },
    ],
  },
  {
    heading: null,
    subheading: "Technology Risks",
    items: [
      { id: "tech-disruption", label: "Disruption by Low-Emission Tech" },
      { id: "tech-obsolescence", label: "Obsolescence of High-Carbon Tech" },
      { id: "rd-cost", label: "High Cost of R&D in Climate Adaptation" },
    ],
  },
  {
    heading: null,
    subheading: "Market Risks",
    items: [
      {
        id: "consumer-preference-shifts",
        label: "Shifts in Consumer Preferences",
      },
      {
        id: "low-demand-carbon-products",
        label: "Drop in Demand for Carbon-Intensive Products",
      },
      { id: "commodity-volatility", label: "Volatility in Commodity Prices" },
    ],
  },
  {
    heading: null,
    subheading: "Reputation Risks",
    items: [
      { id: "esg-damage", label: "ESG Reputation Damage" },
      { id: "stakeholder-pressure", label: "Stakeholder Pressure" },
      { id: "investor-divestment", label: "Investor Divestment" },
      { id: "brand-trust-loss", label: "Loss of Brand Trust" },
      { id: "social-license", label: "Social License to Operate" },
    ],
  },
  {
    heading: "4. Metrics & Targets",
    items: [
      { id: "scope-emissions", label: "GHG Emissions (Scope 1, 2, 3)" },
      {
        id: "performance-metrics",
        label: "Climate-Related Performance Metrics",
      },
      { id: "financial-metrics", label: "Climate-Related Financial Metrics" },
      { id: "climate-targets", label: "Climate Targets" },
      { id: "ghg-reduction-targets", label: "GHG Reduction Targets" },
      { id: "decarbonization-roadmap", label: "Decarbonization Roadmap" },
      { id: "emission-ratios", label: "Emission Intensity Ratios" },
      { id: "transition-plan-kpi", label: "Transition Plan Indicators" },
      { id: "carbon-pricing-assumptions", label: "Carbon Pricing Assumptions" },
      { id: "internal-carbon-price", label: "Internal Carbon Price" },
      { id: "baseline-target-year", label: "Baseline Year and Target Year" },
      { id: "energy-kpi", label: "KPI for Emissions and Energy" },
      {
        id: "disaggregated-emissions",
        label: "Emissions Disaggregated by Business Unit",
      },
      { id: "renewable-energy-usage", label: "Renewable Energy Usage %" },
      { id: "carbon-offsets", label: "Carbon Offsets and Credits" },
      { id: "esg-incentives", label: "ESG-linked Incentives" },
      {
        id: "absolute-vs-intensity",
        label: "Absolute vs Intensity-Based Targets",
      },
      { id: "progress-charts", label: "Progress Tracking Charts" },
      { id: "third-party-assurance", label: "Third-Party Assurance of Data" },
      { id: "standards-alignment", label: "Alignment with Other Standards" },
    ],
  },
  {
    heading: null,
    items: [{ id: "others", label: "Others" }],
  },
];
export const IFRS_S1 = [
  {
    heading: "1. Sustainability-related Risks and Opportunities",
    items: [
      { id: "risk-identification", label: "Risk Identification" },
      { id: "opportunity-identification", label: "Opportunity Identification" },
      {
        id: "financial-effects",
        label: "Financial Effects (Short, Medium, Long Term)",
      },
      { id: "anticipated-impact", label: "Anticipated Impact" },
      { id: "strategic-response", label: "Strategic Response" },
      { id: "trade-offs", label: "Trade-offs" },
    ],
  },
  {
    heading: "2. Governance",
    items: [
      { id: "board-oversight", label: "Board Oversight" },
      { id: "governance-roles", label: "Governance Roles & Responsibilities" },
      { id: "management-responsibility", label: "Management Responsibility" },
      { id: "sustainability-committee", label: "Sustainability Committee" },
      { id: "strategy-integration", label: "Integration into Strategy" },
      {
        id: "remuneration-metrics",
        label: "Remuneration and Sustainability Metrics",
      },
      { id: "target-oversight", label: "Oversight of Target Setting" },
      { id: "review-frequency", label: "Review Frequency" },
    ],
  },
  {
    heading: "3. Strategy",
    items: [
      { id: "business-model-impact", label: "Business Model Impact" },
      { id: "value-chain-exposure", label: "Value Chain Exposure" },
      { id: "scenario-analysis", label: "Scenario Analysis" },
      { id: "resilience-assessment", label: "Resilience Assessment" },
      { id: "materiality-assessment", label: "Materiality Assessment" },
      {
        id: "strategic-planning-integration",
        label: "Strategic Planning Integration",
      },
      {
        id: "financial-performance-effect",
        label: "Effect on Financial Performance",
      },
      { id: "strategic-alignment", label: "Strategic Alignment" },
      { id: "investment-strategy", label: "Investment and Funding Strategy" },
    ],
  },
  {
    heading: "4. Risk Management",
    items: [
      {
        id: "risk-identification-processes",
        label: "Risk Identification Processes",
      },
      { id: "risk-prioritization", label: "Risk Prioritization" },
      { id: "monitoring-mechanisms", label: "Monitoring Mechanisms" },
      {
        id: "erm-integration",
        label: "Integration into Enterprise Risk Management",
      },
      {
        id: "scenario-risk-assessment",
        label: "Scenario Use in Risk Assessment",
      },
      { id: "risk-heat-mapping", label: "Risk Heat Mapping" },
      { id: "risk-process-changes", label: "Changes in Risk Process" },
      {
        id: "qualitative-vs-quantitative",
        label: "Qualitative vs Quantitative Assessments",
      },
    ],
  },
  {
    heading: "5. Metrics & Targets",
    items: [
      { id: "kpi-risk-opportunity", label: "KPIs by Risk/Opportunity" },
      { id: "industry-metrics", label: "Industry-specific Metrics" },
      { id: "custom-metrics", label: "Custom-developed Metrics" },
      { id: "regulatory-targets", label: "Regulatory-required Targets" },
      { id: "progress-tracking", label: "Progress Tracking" },
      { id: "base-year-milestones", label: "Base Year and Milestone Setting" },
      { id: "performance-trends", label: "Performance Trends" },
      { id: "internal-controls", label: "Internal Controls & Audit" },
      { id: "metrics-source", label: "Source of Metrics (IFRS/SASB/Other)" },
      {
        id: "third-party-assurance",
        label: "Validation/Third-Party Assurance",
      },
    ],
  },
  {
    heading: "6. Materiality & Presentation",
    items: [
      { id: "materiality-threshold", label: "Materiality Threshold" },
      { id: "judgements-assumptions", label: "Judgements & Assumptions" },
      { id: "measurement-uncertainty", label: "Measurement Uncertainty" },
      { id: "restatements-corrections", label: "Restatements & Corrections" },
      { id: "reporting-comparability", label: "Reporting Comparability" },
      { id: "connected-disclosures", label: "Connected Disclosures" },
      {
        id: "narrative-vs-quantitative",
        label: "Narrative vs Quantitative Balance",
      },
      { id: "cross-referencing", label: "Cross-referencing Policies" },
    ],
  },
  {
    heading: null, // No heading for this group as per your previous examples
    items: [{ id: "others", label: "Others" }],
  },
];
export const IFRS_S2 = [
  {
    heading: "General & Structural",
    items: [
      {
        id: "climate-disclosures",
        label: "Climate-related Financial Disclosures",
      },
      {
        id: "climate-risks-opportunities",
        label: "Climate-related Risks and Opportunities",
      },
      { id: "time-horizons", label: "Short, Medium, Long-term Horizons" },
      { id: "value-chain", label: "Value Chain" },
      { id: "business-model-impact", label: "Business Model Impact" },
      { id: "cross-industry-metrics", label: "Cross-industry Metrics" },
      { id: "industry-metrics", label: "Industry-based Metrics" },
      { id: "materiality", label: "Materiality" },
      {
        id: "general-purpose-report",
        label: "General Purpose Financial Report",
      },
    ],
  },
  {
    heading: "Governance",
    items: [
      { id: "board-oversight", label: "Board Oversight" },
      {
        id: "climate-governance-body",
        label: "Climate-related Governance Body",
      },
      {
        id: "management-role",
        label: "Management’s Role and Responsibilities",
      },
      {
        id: "remuneration-climate-metrics",
        label: "Remuneration and Climate Metrics",
      },
      { id: "oversight-skillset", label: "Oversight Frequency and Skillset" },
      { id: "policy-integration", label: "Policy Integration" },
    ],
  },
  {
    heading: "Strategy",
    items: [
      { id: "scenario-analysis", label: "Climate-related Scenario Analysis" },
      { id: "transition-plan", label: "Transition Plan" },
      { id: "adaptation-mitigation", label: "Adaptation and Mitigation" },
      { id: "strategic-impact", label: "Strategic Planning Impact" },
      { id: "financial-impact", label: "Financial Performance Impact" },
      { id: "capital-allocation", label: "Capital Allocation" },
      { id: "climate-resilience", label: "Resilience to Climate Change" },
      { id: "carbon-operations", label: "Carbon-intensive Operations" },
      { id: "dependencies-assumptions", label: "Dependencies and Assumptions" },
      {
        id: "climate-products-services",
        label: "Climate-aligned Products & Services",
      },
    ],
  },
  {
    heading: "Risk Management",
    items: [
      {
        id: "risk-identification-prioritization",
        label: "Risk Identification and Prioritization",
      },
      { id: "physical-risks", label: "Climate-related Physical Risks" },
      { id: "transition-risks", label: "Climate-related Transition Risks" },
      { id: "integrated-risk-management", label: "Integrated Risk Management" },
      { id: "risk-monitoring", label: "Risk Monitoring Processes" },
      { id: "risk-inputs-parameters", label: "Inputs and Parameters" },
      { id: "scenario-risk-id", label: "Scenario-based Risk Identification" },
      { id: "risk-process-changes", label: "Change in Risk Processes" },
    ],
  },
  {
    heading: "Metrics & Targets",
    items: [
      { id: "scope-emissions", label: "Scope 1, Scope 2, Scope 3 Emissions" },
      { id: "internal-carbon-price", label: "Internal Carbon Price" },
      { id: "gross-vs-net", label: "Gross vs Net Emissions" },
      { id: "climate-targets", label: "Climate-related Targets" },
      {
        id: "climate-capital-deployment",
        label: "Capital Deployment for Climate",
      },
      { id: "financed-emissions", label: "Financed Emissions" },
      { id: "absolute-vs-intensity", label: "Absolute vs Intensity Targets" },
      {
        id: "exec-remuneration-linkage",
        label: "Executive Remuneration Linkage",
      },
    ],
  },
  {
    heading: "Scenario Analysis & Resilience",
    items: [
      { id: "climate-scenario", label: "Climate-related Scenario" },
      {
        id: "quant-qual-scenarios",
        label: "Quantitative and Qualitative Scenarios",
      },
      { id: "resilience-assessment", label: "Climate Resilience Assessment" },
      {
        id: "key-assumptions",
        label: "Key Assumptions (Policy, Energy Mix, Macro Trends)",
      },
      {
        id: "analytical-approach",
        label: "Analytical Approach (Narrative vs Modelling)",
      },
    ],
  },
  {
    heading: "Scope 3 Emissions",
    items: [
      { id: "purchased-goods", label: "Purchased Goods and Services" },
      { id: "capital-goods", label: "Capital Goods" },
      {
        id: "transport-distribution",
        label: "Transportation and Distribution",
      },
      { id: "waste-treatment", label: "Waste and End-of-life Treatment" },
      { id: "business-travel", label: "Business Travel and Commuting" },
      { id: "franchises-investments", label: "Franchises and Investments" },
      { id: "data-verification", label: "Data Verification and Estimation" },
    ],
  },
  {
    heading: null, // No heading for this group as per your previous examples
    items: [{ id: "others", label: "Others" }],
  },
];
export const UNGC_COMPLIANCE_CUSTOMIZE = [
  {
    heading: "Human Rights - P-1: Support and Respect for Human Rights",
    items: [
      {
        id: "international-standards",
        label: "International Standards Proclaimed Human Rights",
      },
      { id: "universal-rights", label: "Universal Rights" },
      { id: "un-guiding-principles", label: "UN Guiding Principles" },
      { id: "worker-rights", label: "Worker Rights" },
      { id: "equal-treatment", label: "Equal Treatment" },
      { id: "dignity", label: "Dignity" },
      { id: "social-justice", label: "Social Justice" },
    ],
  },
  {
    heading: "Human Rights - P-2: Avoid Complicity in Human Rights Abuses",
    items: [
      { id: "human-rights-due-diligence", label: "Human Rights Due Diligence" },
      { id: "indirect-violations", label: "Indirect Violations" },
      { id: "third-party-abuse", label: "Third-party Abuse" },
      { id: "silent-complicity", label: "Silent Complicity" },
      {
        id: "responsible-business-conduct",
        label: "Responsible Business Conduct",
      },
      { id: "accountability", label: "Accountability" },
    ],
  },
  {
    heading: "Labor - P-3: Freedom of Association and Collective Bargaining",
    items: [
      { id: "trade-unions", label: "Trade Unions" },
      { id: "employee-representation", label: "Employee Representation" },
      { id: "collective-agreements", label: "Collective Agreements" },
      { id: "industrial-relations", label: "Industrial Relations" },
      { id: "social-dialogue", label: "Social Dialogue" },
    ],
  },
  {
    heading: "Labor - P-4: Elimination of Forced and Compulsory Labor",
    items: [
      { id: "forced-labour", label: "Forced Labour" },
      { id: "bonded-labour", label: "Bonded Labour" },
      { id: "modern-slavery", label: "Modern Slavery" },
      { id: "coerced-work", label: "Coerced Work" },
      { id: "human-trafficking", label: "Human Trafficking" },
    ],
  },
  {
    heading: "Labor - P-5: Abolition of Child Labor",
    items: [
      { id: "underage-workers", label: "Underage Workers" },
      { id: "youth-protection", label: "Youth Protection" },
      { id: "minimum-age", label: "Minimum Age" },
      { id: "exploitation", label: "Exploitation" },
      { id: "ilo-convention-138-182", label: "ILO Convention 138 & 182" },
    ],
  },
  {
    heading:
      "Labor - P-6: Elimination of Discrimination in Employment and Occupation",
    items: [
      { id: "gender-equality", label: "Gender Equality" },
      { id: "inclusion", label: "Inclusion" },
      { id: "equal-opportunity", label: "Equal Opportunity" },
      { id: "workplace-diversity", label: "Workplace Diversity" },
      { id: "non-discrimination", label: "Non-discrimination" },
      { id: "pay-equity", label: "Pay Equity" },
    ],
  },
  {
    heading:
      "Environment - P-7: Precautionary Approach to Environmental Challenges",
    items: [
      { id: "environmental-risk", label: "Environmental Risk" },
      {
        id: "environmental-impact-assessment",
        label: "Environmental Impact Assessment",
      },
      { id: "climate-risk", label: "Climate Risk" },
      { id: "biodiversity-protection", label: "Biodiversity Protection" },
      { id: "sustainable-development", label: "Sustainable Development" },
    ],
  },
  {
    heading:
      "Environment - P-8: Promotion of Greater Environmental Responsibility",
    items: [
      {
        id: "environmental-management-systems",
        label: "Environmental Management Systems (EMS)",
      },
      { id: "green-policies", label: "Green Policies" },
      { id: "eco-efficiency", label: "Eco-efficiency" },
      { id: "sustainable-operations", label: "Sustainable Operations" },
      { id: "environmental-training", label: "Environmental Training" },
    ],
  },
  {
    heading:
      "Environment - P-9: Diffusion of Environmentally Friendly Technologies",
    items: [
      { id: "clean-technology", label: "Clean Technology" },
      { id: "innovation", label: "Innovation" },
      { id: "renewable-energy", label: "Renewable Energy" },
      { id: "emission-reduction", label: "Emission Reduction" },
      { id: "circular-economy", label: "Circular Economy" },
      { id: "low-carbon-tech", label: "Low-carbon Tech" },
    ],
  },
  {
    heading: "Anti-Corruption - P-10: Work Against Corruption in All Its Forms",
    items: [
      { id: "bribery", label: "Bribery" },
      { id: "extortion", label: "Extortion" },
      { id: "transparency", label: "Transparency" },
      { id: "whistleblower-protection", label: "Whistleblower Protection" },
      { id: "ethics-and-compliance", label: "Ethics and Compliance" },
      { id: "aml", label: "AML (Anti-Money Laundering)" },
      { id: "political-donations", label: "Political Donations" },
      { id: "conflict-of-interest", label: "Conflict of Interest" },
    ],
  },
  {
    heading: null, // No heading for this group as per your previous examples
    items: [{ id: "others", label: "Others" }],
  },
];
export const SDG_GOALS_COMPLIANCE_TOPICS = [
  {
    heading: "1. No Poverty",
    items: [
      { id: "poverty-eradication", label: "Poverty Eradication" },
      { id: "income-inequality", label: "Income Inequality" },
      { id: "social-protection", label: "Social Protection" },
      { id: "basic-services", label: "Basic Services" },
      { id: "financial-inclusion", label: "Financial Inclusion" },
      { id: "vulnerable-groups", label: "Vulnerable Groups" },
    ],
  },
  {
    heading: "2. Zero Hunger",
    items: [
      { id: "food-security", label: "Food Security" },
      { id: "sustainable-agriculture", label: "Sustainable Agriculture" },
      { id: "nutrition", label: "Nutrition" },
      { id: "hunger-eradication", label: "Hunger Eradication" },
      { id: "crop-resilience", label: "Crop Resilience" },
      { id: "smallholder-farmers", label: "Smallholder Farmers" },
    ],
  },
  {
    heading: "3. Good Health and Well-being",
    items: [
      { id: "public-health", label: "Public Health" },
      { id: "healthcare-access", label: "Healthcare Access" },
      { id: "mental-health", label: "Mental Health" },
      { id: "occupational-safety", label: "Occupational Safety" },
      { id: "disease-prevention", label: "Disease Prevention" },
      { id: "health-systems", label: "Health Systems" },
    ],
  },
  {
    heading: "4. Quality Education",
    items: [
      { id: "inclusive-education", label: "Inclusive Education" },
      { id: "equal-access-to-education", label: "Equal Access to Education" },
      { id: "skills-development", label: "Skills Development" },
      { id: "digital-literacy", label: "Digital Literacy" },
      { id: "lifelong-learning", label: "Lifelong Learning" },
      { id: "girls-education", label: "Girls’ Education" },
    ],
  },
  {
    heading: "5. Gender Equality",
    items: [
      { id: "gender-equity", label: "Gender Equity" },
      { id: "women-empowerment", label: "Women Empowerment" },
      { id: "equal-pay", label: "Equal Pay" },
      { id: "non-discrimination", label: "Non-discrimination" },
      { id: "gender-based-violence", label: "Gender-based Violence" },
      { id: "women-in-leadership", label: "Women in Leadership" },
    ],
  },
  {
    heading: "6. Clean Water and Sanitation",
    items: [
      { id: "safe-drinking-water", label: "Safe Drinking Water" },
      { id: "sanitation-and-hygiene", label: "Sanitation and Hygiene" },
      { id: "wastewater-management", label: "Wastewater Management" },
      { id: "water-efficiency", label: "Water Efficiency" },
      { id: "wash", label: "WASH (Water, Sanitation and Hygiene)" },
      { id: "clean-water-access", label: "Clean Water Access" },
    ],
  },
  {
    heading: "7. Affordable and Clean Energy",
    items: [
      { id: "renewable-energy", label: "Renewable Energy" },
      { id: "energy-efficiency", label: "Energy Efficiency" },
      { id: "energy-access", label: "Energy Access" },
      { id: "clean-technologies", label: "Clean Technologies" },
      { id: "sustainable-power", label: "Sustainable Power" },
    ],
  },
  {
    heading: "8. Decent Work and Economic Growth",
    items: [
      { id: "fair-wages", label: "Fair Wages" },
      { id: "labor-rights", label: "Labor Rights" },
      { id: "youth-employment", label: "Youth Employment" },
      { id: "inclusive-growth", label: "Inclusive Growth" },
      { id: "safe-working-conditions", label: "Safe Working Conditions" },
      { id: "entrepreneurship", label: "Entrepreneurship" },
    ],
  },
  {
    heading: "9. Industry, Innovation and Infrastructure",
    items: [
      { id: "infrastructure-development", label: "Infrastructure Development" },
      {
        id: "sustainable-industrialization",
        label: "Sustainable Industrialization",
      },
      { id: "innovation", label: "Innovation" },
      { id: "research-and-development", label: "Research and Development" },
      { id: "resilient-systems", label: "Resilient Systems" },
      { id: "smart-technology", label: "Smart Technology" },
    ],
  },
  {
    heading: "10. Reduced Inequalities",
    items: [
      { id: "social-inclusion", label: "Social Inclusion" },
      { id: "equal-opportunity", label: "Equal Opportunity" },
      { id: "migration-and-mobility", label: "Migration and Mobility" },
      { id: "income-equity", label: "Income Equity" },
      {
        id: "rights-of-marginalized-groups",
        label: "Rights of Marginalized Groups",
      },
      { id: "accessible-services", label: "Accessible Services" },
    ],
  },
  {
    heading: "11. Sustainable Cities and Communities",
    items: [
      { id: "urban-planning", label: "Urban Planning" },
      { id: "affordable-housing", label: "Affordable Housing" },
      { id: "sustainable-transport", label: "Sustainable Transport" },
      { id: "disaster-resilience", label: "Disaster Resilience" },
      { id: "green-infrastructure", label: "Green Infrastructure" },
      { id: "smart-cities", label: "Smart Cities" },
    ],
  },
  {
    heading: "12. Responsible Consumption and Production",
    items: [
      { id: "circular-economy", label: "Circular Economy" },
      { id: "waste-reduction", label: "Waste Reduction" },
      { id: "sustainable-consumption", label: "Sustainable Consumption" },
      { id: "eco-labeling", label: "Eco-labeling" },
      { id: "resource-efficiency", label: "Resource Efficiency" },
      { id: "sustainable-procurement", label: "Sustainable Procurement" },
    ],
  },
  {
    heading: "13. Climate Action",
    items: [
      { id: "climate-change-mitigation", label: "Climate Change Mitigation" },
      { id: "ghg-emissions", label: "GHG Emissions" },
      { id: "net-zero-targets", label: "Net-zero Targets" },
      { id: "carbon-neutrality", label: "Carbon Neutrality" },
      { id: "adaptation-strategies", label: "Adaptation Strategies" },
      { id: "climate-resilience", label: "Climate Resilience" },
    ],
  },
  {
    heading: "14. Life Below Water",
    items: [
      { id: "ocean-conservation", label: "Ocean Conservation" },
      { id: "marine-biodiversity", label: "Marine Biodiversity" },
      { id: "overfishing", label: "Overfishing" },
      { id: "marine-pollution", label: "Marine Pollution" },
      { id: "coral-reef-protection", label: "Coral Reef Protection" },
      { id: "blue-economy", label: "Blue Economy" },
    ],
  },
  {
    heading: "15. Life on Land",
    items: [
      { id: "forest-conservation", label: "Forest Conservation" },
      { id: "biodiversity-protection", label: "Biodiversity Protection" },
      { id: "land-degradation", label: "Land Degradation" },
      { id: "ecosystem-restoration", label: "Ecosystem Restoration" },
      { id: "wildlife-protection", label: "Wildlife Protection" },
      {
        id: "deforestation-free-sourcing",
        label: "Deforestation-free Sourcing",
      },
    ],
  },
  {
    heading: "16. Peace, Justice and Strong Institutions",
    items: [
      { id: "governance", label: "Governance" },
      { id: "rule-of-law", label: "Rule of Law" },
      { id: "anti-corruption", label: "Anti-corruption" },
      { id: "human-rights", label: "Human Rights" },
      { id: "justice-access", label: "Justice Access" },
      { id: "transparency", label: "Transparency" },
    ],
  },
  {
    heading: "17. Partnerships for the Goals",
    items: [
      { id: "global-partnerships", label: "Global Partnerships" },
      {
        id: "multi-stakeholder-collaboration",
        label: "Multi-stakeholder Collaboration",
      },
      { id: "development-financing", label: "Development Financing" },
      { id: "knowledge-sharing", label: "Knowledge Sharing" },
      { id: "capacity-building", label: "Capacity Building" },
      {
        id: "data-and-reporting-cooperation",
        label: "Data and Reporting Cooperation",
      },
    ],
  },
  {
    heading: null, // No heading for this group as per your previous examples
    items: [{ id: "others", label: "Others" }],
  },
];
export const Annexure_1 = [
  {
    heading: "ESRS 1 – General Requirements",
    items: [
      { id: "double-materiality", label: "Double Materiality" },
      { id: "materiality-assessment", label: "Materiality Assessment" },
      { id: "materiality-of-information", label: "Materiality of Information" },
      { id: "sustainability-matters", label: "Sustainability Matters" },
      { id: "financial-materiality", label: "Financial Materiality" },
      { id: "impact-materiality", label: "Impact Materiality" },
      {
        id: "reporting-boundary",
        label: "Reporting Boundary / Level of Disaggregation",
      },
      { id: "value-chain", label: "Value Chain" },
      { id: "sustainability-statement", label: "Sustainability Statement" },
      {
        id: "connectivity-of-information",
        label: "Connectivity of Information",
      },
      { id: "time-horizons", label: "Time Horizons (Short, Medium, Long)" },
      {
        id: "forward-looking-information",
        label: "Forward-looking Information",
      },
      { id: "due-diligence", label: "Due Diligence" },
      { id: "stakeholder-engagement", label: "Stakeholder Engagement" },
      {
        id: "sector-standards",
        label: "Sector-agnostic / Sector-specific Standards",
      },
      { id: "assurance-readiness", label: "Assurance Readiness" },
      { id: "interoperability", label: "Interoperability" },
      { id: "data-completeness", label: "Data Completeness and Estimation" },
      {
        id: "reporting-principles",
        label:
          "Reporting Principles (Comparative, Sources of Estimation, Outcome Uncertainty, Consolidated Reporting)",
      },
      {
        id: "qualitative-vs-quantitative-data",
        label: "Qualitative vs Quantitative Data",
      },
    ],
  },
  {
    heading: "ESRS 2 – General Disclosures",
    items: [
      {
        id: "governance-of-sustainability",
        label: "Governance of Sustainability Matters",
      },
      {
        id: "strategy-and-business-model",
        label: "Strategy and Business Model",
      },
      {
        id: "impacts-risks-opportunities",
        label: "Impacts, Risks, and Opportunities (IROs)",
      },
      { id: "policies-and-action-plans", label: "Policies and Action Plans" },
      { id: "targets-and-progress", label: "Targets and Progress Tracking" },
      { id: "roles-and-responsibilities", label: "Roles and Responsibilities" },
      {
        id: "integration-in-incentive-schemes",
        label: "Integration in Incentive Schemes",
      },
      {
        id: "sustainability-due-diligence",
        label: "Statement of Sustainability Due Diligence",
      },
      {
        id: "materiality-determination",
        label: "Materiality Determination Process",
      },
      { id: "risk-management-systems", label: "Risk Management Systems" },
      { id: "monitoring-procedures", label: "Monitoring Procedures" },
      { id: "resources-and-capabilities", label: "Resources and Capabilities" },
      { id: "stakeholder-consultation", label: "Stakeholder Consultation" },
      { id: "explanation-of-omissions", label: "Explanation of Omissions" },
    ],
  },
  {
    heading: "ESRS 2 – Disclosure Requirements",
    items: [
      {
        id: "bp-1",
        label: "BP-1 General Basis for Preparation of Sustainability Statement",
      },
      {
        id: "bp-2",
        label: "BP-2 Disclosure in Relation to Specific Circumstances",
      },
      {
        id: "gov-1",
        label:
          "GOV-1: The Role of Administrative, Management and Supervisory Bodies",
      },
      {
        id: "gov-2",
        label:
          "GOV-2: Information on Sustainability Matters to Administrative, Management and Supervisory Bodies",
      },
      {
        id: "gov-3",
        label:
          "GOV-3: Integration of Sustainability-related Performance in Incentive Schemes",
      },
      { id: "gov-4", label: "GOV-4: Statement on Due Diligence" },
      {
        id: "gov-5",
        label:
          "GOV-5: Risk Management and Internal Control over Sustainability Reporting Strategy",
      },
      { id: "sbm-1", label: "SBM-1: Strategy, Business Model and Value Chain" },
      { id: "sbm-2", label: "SBM-2: Interest and Views of Stakeholders" },
      {
        id: "sbm-3",
        label:
          "SBM-3: Material Impact, Risks and Opportunity and Their Interaction with Strategy and Business Model",
      },
      {
        id: "iro-1",
        label:
          "IRO-1: Description of Process to Identify and Assess Material Impacts, Risks and Opportunity",
      },
      {
        id: "iro-2",
        label:
          "IRO-2: Disclosure Requirements in ESRS Covered by the Undertaking’s Sustainability Statement",
      },
      {
        id: "mdr-p",
        label:
          "MDR-P: Policies Adopted to Manage Material Sustainability Matters",
      },
      {
        id: "mdr-a",
        label:
          "MDR-A: Actions and Resources in Relation to Material Sustainability Matters",
      },
      {
        id: "mdr-m",
        label: "MDR-M: Metrics in Relation to Material Sustainability Matters",
      },
      {
        id: "mdr-t",
        label:
          "MDR-T: Tracking Effectiveness of Policies and Action Through Targets",
      },
    ],
  },
  {
    heading: "ESRS E1 – Climate Change",
    items: [
      { id: "ghg-emissions", label: "GHG Emissions (Scope 1, 2, 3)" },
      { id: "emissions-intensity", label: "Emissions Intensity" },
      { id: "land-use-change", label: "Land-use Change" },
      { id: "decarbonisation-targets", label: "Decarbonisation Targets" },
      { id: "climate-transition-plan", label: "Climate Transition Plan" },
      { id: "energy-consumption-and-mix", label: "Energy Consumption and Mix" },
      {
        id: "carbon-removal-and-offsetting",
        label: "Carbon Removal and Offsetting",
      },
      { id: "scenario-analysis", label: "Scenario Analysis" },
      {
        id: "financial-effects-climate-risks",
        label: "Financial Effects of Climate Risks",
      },
      {
        id: "climate-adaptation-and-mitigation",
        label: "Climate Adaptation and Mitigation",
      },
      { id: "internal-carbon-pricing", label: "Internal Carbon Pricing" },
      {
        id: "climate-related-opportunities",
        label: "Climate-related Opportunities",
      },
      {
        id: "e1-1",
        label: "E1-1: Transition Plan for Climate Change Mitigation",
      },
      {
        id: "e1-2",
        label:
          "E1-2: Policies Related to Climate Change Mitigation and Adaptation",
      },
      {
        id: "e1-3",
        label:
          "E1-3: Actions and Resources in Relation to Climate Change Policies",
      },
      {
        id: "e1-4",
        label:
          "E1-4: Targets Related to Climate Change Mitigation and Adaptation",
      },
      { id: "e1-5", label: "E1-5: Energy Consumption and Mix" },
      {
        id: "e1-6",
        label:
          "E1-6: Gross Scope 1, 2, 3 and Total GHG Emissions (Including CO2, CH4, N2O, HFCs, PFCs, SF6, and NF3)",
      },
      {
        id: "e1-7",
        label:
          "E1-7: GHG Removals and GHG Mitigation Project Financed Through Carbon Credits",
      },
      { id: "e1-8", label: "E1-8: Internal Carbon Pricing" },
      {
        id: "e1-9",
        label:
          "E1-9: Financial Effects from Climate-related Risks and Opportunities",
      },
    ],
  },
  {
    heading: "ESRS E2 – Pollution",
    items: [
      { id: "air-pollutants", label: "Air Pollutants (e.g., NOx, SOx, VOCs)" },
      { id: "water-pollution", label: "Water Pollution" },
      { id: "soil-pollution", label: "Soil Pollution" },
      { id: "noise-pollution", label: "Noise Pollution" },
      { id: "light-pollution", label: "Light Pollution" },
      { id: "hazardous-substances", label: "Use of Hazardous Substances" },
      { id: "pollution-prevention", label: "Pollution Prevention Measures" },
      {
        id: "pollutant-discharge-thresholds",
        label: "Pollutant Discharge Thresholds",
      },
      { id: "remediation-and-liability", label: "Remediation and Liability" },
      { id: "e2-1", label: "E2-1: Policies Related to Pollution" },
      { id: "e2-2", label: "E2-2: Actions and Resources Related to Pollution" },
      { id: "e2-3", label: "E2-3: Target Related to Pollution" },
      { id: "e2-4", label: "E2-4: Pollutants of Air, Water and Soil" },
      {
        id: "e2-5",
        label:
          "E2-5: Substances of Concern and Substances of Very High Concern",
      },
      {
        id: "e2-6",
        label:
          "E2-6: Anticipated Financial Effects from Pollution-related Impacts, Risks and Opportunities",
      },
    ],
  },
  {
    heading: "ESRS E3 – Water and Marine Resources",
    items: [
      { id: "water-withdrawal", label: "Water Withdrawal" },
      { id: "water-consumption", label: "Water Consumption" },
      { id: "water-discharge", label: "Water Discharge Quality and Quantity" },
      { id: "water-reuse", label: "Water Reuse" },
      { id: "marine-ecosystem-impact", label: "Marine Ecosystem Impact" },
      {
        id: "climate-change-physical-risks",
        label: "Climate Change Physical Risks",
      },
      { id: "waste-management", label: "Waste Management Including Plastic" },
      { id: "watershed-dependency", label: "Watershed Dependency" },
      { id: "impact-on-marine-resources", label: "Impact on Marine Resources" },
      {
        id: "impact-on-aquatic-biodiversity",
        label: "Impact on Aquatic Biodiversity",
      },
      { id: "ecological-threshold", label: "Ecological Threshold" },
      {
        id: "financial-effects-water-marine",
        label:
          "Financial Effects due to Material Risks from Water and Marine Resources-related Impacts and Dependencies",
      },
      { id: "e3-1", label: "E3-1: Policies Related to Water and Marine" },
      {
        id: "e3-2",
        label:
          "E3-2: Actions and Resources Related to Water and Marine Resources",
      },
      {
        id: "e3-3",
        label: "E3-3: Target Related to Water and Marine Resources",
      },
      { id: "e3-4", label: "E3-4: Water Consumption and Discharge" },
      {
        id: "e3-5",
        label:
          "E3-5: Financial Effects from Water and Marine Resources-related Impacts, Risks and Opportunities",
      },
    ],
  },
  {
    heading: "ESRS E4 – Biodiversity and Ecosystems",
    items: [
      { id: "ecosystem-services", label: "Ecosystem Services" },
      { id: "biological-diversity", label: "Biological Diversity" },
      {
        id: "biodiversity-estimation",
        label: "Biodiversity-related Estimation (Model-based Approaches)",
      },
      { id: "biodiversity-loss-drivers", label: "Biodiversity Loss Drivers" },
      { id: "ecosystem-restoration", label: "Ecosystem Restoration" },
      {
        id: "material-impacts-biodiversity",
        label:
          "Material Impacts and Dependencies on Biodiversity and Ecosystem",
      },
      { id: "habitat-degradation", label: "Habitat Degradation" },
      { id: "land-use-change", label: "Land Use Change" },
      {
        id: "biodiversity-sensitive-areas",
        label: "Biodiversity-sensitive Areas",
      },
      {
        id: "deforestation-free-supply-chain",
        label: "Deforestation-free Supply Chain",
      },
      { id: "species-conservation", label: "Species Conservation" },
      { id: "invasive-alien-species", label: "Invasive Alien Species" },
      { id: "threatened-species", label: "Threatened Species" },
      { id: "nature-positive-transition", label: "Nature-positive Transition" },
      {
        id: "targets-biodiversity-ecosystem",
        label: "Targets Related to Biodiversity and Ecosystem",
      },
      {
        id: "ecosystem-risks",
        label: "Ecosystem Related Physical, Transition and Systemic Risks",
      },
      { id: "biodiversity-offsets", label: "Biodiversity Offsets" },
      { id: "ecological-threshold", label: "Ecological Threshold" },
      {
        id: "e4-1",
        label:
          "E4-1: Transition Plan and Consideration of Biodiversity and Ecosystem in Strategy and Business Model",
      },
      {
        id: "e4-2",
        label: "E4-2: Policies Related to Biodiversity and Ecosystems",
      },
      {
        id: "e4-3",
        label:
          "E4-3: Actions and Resources Related to Biodiversity and Ecosystems",
      },
      {
        id: "e4-4",
        label: "E4-4: Targets Related to Biodiversity and Ecosystems",
      },
      {
        id: "e4-5",
        label:
          "E4-5: Impact Metrics Related to Biodiversity and Ecosystems Change",
      },
      {
        id: "e4-6",
        label:
          "E4-6: Financial Effects from Biodiversity and Ecosystem-related Risks and Opportunities",
      },
    ],
  },
  {
    heading: "ESRS E5 – Resource Use and Circular Economy",
    items: [
      { id: "resource-inflow-outflow", label: "Resource Inflow and Outflow" },
      { id: "material-use-efficiency", label: "Material Use Efficiency" },
      {
        id: "waste-generation-management",
        label: "Waste Generation and Management",
      },
      { id: "circular-product-design", label: "Circular Product Design" },
      { id: "secondary-raw-materials", label: "Secondary Raw Materials" },
      { id: "recycling-rate", label: "Recycling Rate" },
      {
        id: "product-lifecycle-assessment",
        label: "Product Lifecycle Assessment",
      },
      {
        id: "resource-efficiency-resilience",
        label: "Resource Efficiency and Resilience",
      },
      { id: "packaging-sustainability", label: "Packaging Sustainability" },
      {
        id: "financial-effects-resource-use",
        label:
          "Financial Effects of Material Risks and Opportunities on Dependencies on Resource Use",
      },
      {
        id: "e5-1",
        label: "E5-1: Policies Related to Resource Use and Circular Economy",
      },
      {
        id: "e5-2",
        label:
          "E5-2: Actions and Resources Related to Resource Use and Circular Economy",
      },
      {
        id: "e5-3",
        label: "E5-3: Targets Related to Resource Use and Circular Economy",
      },
      { id: "e5-4", label: "E5-4: Resource Inflows" },
      { id: "e5-5", label: "E5-5: Resource Outflows" },
      {
        id: "e5-6",
        label:
          "E5-6: Financial Effects from Resource Use and Circular Economy-related Impacts, Risks and Opportunities",
      },
    ],
  },
  {
    heading: "ESRS S1 – Own Workforce",
    items: [
      { id: "workforce-composition", label: "Workforce Composition" },
      { id: "working-conditions", label: "Working Conditions" },
      { id: "working-hours", label: "Working Hours" },
      { id: "child-forced-labor", label: "Child Labor and Forced Labor" },
      {
        id: "workers-contracts",
        label: "Workers Contracts and Implementation",
      },
      { id: "workers-code-of-conduct", label: "Workers Code of Conduct" },
      { id: "pay-equity", label: "Pay Equity (Gender Pay Gap)" },
      { id: "collective-bargaining", label: "Collective Bargaining" },
      { id: "diversity-and-inclusion", label: "Diversity and Inclusion" },
      { id: "social-protection", label: "Social Protection" },
      { id: "training-and-development", label: "Training and Development" },
      {
        id: "health-safety-metrics",
        label: "Health and Safety Metrics & Indicators",
      },
      { id: "work-related-incidents", label: "Work-related Incidents" },
      { id: "turnover-absenteeism", label: "Turnover and Absenteeism" },
      { id: "work-life-balance", label: "Work-life Balance" },
      { id: "non-discrimination", label: "Non-discrimination" },
      {
        id: "workers-grievance-mechanism",
        label: "Workers Grievance Mechanism",
      },
      { id: "workers-trainings", label: "Workers Trainings" },
      { id: "s1-1", label: "S1-1: Policies Related to Own Workforce" },
      { id: "s1-2", label: "S1-2: Processes for Engaging with Own Workforce" },
      {
        id: "s1-3",
        label:
          "S1-3: Process to Remediate Negative Impacts and Channels for Own Workforce to Raise Concerns",
      },
      {
        id: "s1-4",
        label:
          "S1-4: Action on Material Impacts on Own Workforce and Approaches to Managing Material Risks and Opportunities and Action Effectiveness",
      },
      {
        id: "s1-5",
        label:
          "S1-5: Targets Related to Managing Material Negative Impacts, Advancing Positive Impacts and Managing Risks and Opportunities",
      },
      {
        id: "s1-6",
        label: "S1-6: Characteristics of the Undertaking’s Employees",
      },
      {
        id: "s1-7",
        label:
          "S1-7: Characteristics of Non-employees in the Undertaking’s Own Workforce",
      },
      {
        id: "s1-8",
        label: "S1-8: Collective Bargaining Coverage and Social Dialogue",
      },
      { id: "s1-9", label: "S1-9: Diversity Metrics" },
      { id: "s1-10", label: "S1-10: Adequate Wages" },
      { id: "s1-11", label: "S1-11: Social Protection" },
      { id: "s1-12", label: "S1-12: Persons with Disabilities" },
      { id: "s1-13", label: "S1-13: Trainings and Skills Development" },
      { id: "s1-14", label: "S1-14: Health and Safety Metrics" },
      { id: "s1-15", label: "S1-15: Work-life Balance Metrics" },
      {
        id: "s1-16",
        label: "S1-16: Remuneration Metrics (Pay Gap and Total Remuneration)",
      },
      {
        id: "s1-17",
        label: "S1-17: Incidents, Complaints and Severe Human Rights Impacts",
      },
    ],
  },
  {
    heading: "ESRS S2 – Workers in the Value Chain",
    items: [
      {
        id: "labor-practices-supply-chain",
        label: "Labor Practices in Supply Chain",
      },
      { id: "forced-child-labor-risks", label: "Forced and Child Labor Risks" },
      { id: "fair-wages-working-hours", label: "Fair Wages and Working Hours" },
      {
        id: "health-safety-value-chain",
        label: "Health and Safety in the Value Chain",
      },
      { id: "grievance-mechanisms", label: "Grievance Mechanisms" },
      {
        id: "supplier-monitoring-audits",
        label: "Supplier Monitoring and Audits",
      },
      { id: "freedom-of-association", label: "Freedom of Association" },
      { id: "discrimination", label: "Discrimination" },
      { id: "capacity-building", label: "Capacity Building" },
      { id: "incident-management", label: "Incident Management" },
      { id: "s2-1", label: "S2-1: Policies Related to Value Chain Workers" },
      {
        id: "s2-2",
        label:
          "S2-2: Processes for Engaging with Value Chain Workers about Impacts",
      },
      {
        id: "s2-3",
        label:
          "S2-3: Processes to Remediate Negative Impacts and Channels for Value Chain Workers to Raise Concerns",
      },
      {
        id: "s2-4",
        label:
          "S2-4: Action on Material Impacts on Value Chain Workers, and Approaches to Managing Material Risks",
      },
      {
        id: "s2-5",
        label:
          "S2-5: Targets Related to Managing Material Negative Impacts, Advancing Positive Impacts and Managing Material Risks and Opportunities",
      },
    ],
  },
  {
    heading: "ESRS S3 – Affected Communities",
    items: [
      { id: "community-engagement", label: "Community Engagement" },
      { id: "land-resource-rights", label: "Land and Resource Rights" },
      { id: "indigenous-peoples-rights", label: "Indigenous Peoples' Rights" },
      {
        id: "access-to-water-services",
        label: "Access to Water and Basic Services",
      },
      { id: "social-license-to-operate", label: "Social License to Operate" },
      {
        id: "community-impact-assessments",
        label: "Community Impact Assessments",
      },
      {
        id: "resettlement-displacement",
        label: "Resettlement or Displacement",
      },
      {
        id: "grievance-redress-mechanism",
        label: "Grievance Redress Mechanism for External Parties",
      },
      {
        id: "capacity-building-communities",
        label: "Capacity Building of Affected Communities",
      },
      {
        id: "opportunities-communities",
        label: "Opportunities for Affected Communities",
      },
      { id: "s3-1", label: "S3-1: Policies Related to Affected Communities" },
      {
        id: "s3-2",
        label:
          "S3-2: Processes for Engagement with Affected Communities about Impacts",
      },
      {
        id: "s3-3",
        label:
          "S3-3: Process to Remediate Negative Impacts and Channels for Affected Communities to Raise Concerns",
      },
      {
        id: "s3-4",
        label:
          "S3-4: Action on Material Impacts on Affected Communities, and Approaches to Managing Material Risks and Opportunities",
      },
      {
        id: "s3-5",
        label:
          "S3-5: Targets Related to Managing Material Negative Impacts, Advancing Positive Impacts, and Managing Material Risks and Opportunities",
      },
    ],
  },
  {
    heading: "ESRS S4 – Consumers and End-Users",
    items: [
      { id: "product-safety-quality", label: "Product Safety and Quality" },
      { id: "data-protection-privacy", label: "Data Protection and Privacy" },
      { id: "ethical-marketing", label: "Ethical Marketing" },
      { id: "accessibility-usability", label: "Accessibility and Usability" },
      {
        id: "consumer-feedback-grievance",
        label: "Consumer Feedback and Grievance Handling",
      },
      { id: "end-user-wellbeing", label: "End-user Wellbeing" },
      {
        id: "vulnerable-consumer-protection",
        label: "Vulnerable Consumer Protection",
      },
      {
        id: "s4-1",
        label: "S4-1: Policies Related to Consumers and End-users",
      },
      {
        id: "s4-2",
        label:
          "S4-2: Processes for Engaging with Consumers and End-users about Impacts",
      },
      {
        id: "s4-3",
        label:
          "S4-3: Processes to Remediate Negative Impacts and Channels for Consumers and End-users to Raise Concerns",
      },
      {
        id: "s4-4",
        label:
          "S4-4: Action on Material Impacts on Consumers and End-users, and Approaches to Managing Material Risks and Opportunities",
      },
      {
        id: "s4-5",
        label:
          "S4-5: Targets Related to Managing Material Negative Impacts, Advancing Positive Impacts and Managing Risks and Opportunities",
      },
    ],
  },
  {
    heading: "ESRS G1 – Business Conduct",
    items: [
      { id: "governance-structure", label: "Governance Structure" },
      { id: "anti-corruption-bribery", label: "Anti-corruption and Bribery" },
      { id: "code-of-conduct", label: "Code of Conduct" },
      { id: "whistleblower-mechanisms", label: "Whistleblower Mechanisms" },
      {
        id: "political-engagement-lobbying",
        label: "Political Engagement and Lobbying",
      },
      { id: "human-rights-commitments", label: "Human Rights Commitments" },
      {
        id: "conflict-of-interest-policies",
        label: "Conflict of Interest Policies",
      },
      { id: "business-ethics", label: "Business Ethics" },
      { id: "regulatory-compliance", label: "Regulatory Compliance" },
      { id: "supplier-code-of-conduct", label: "Supplier Code of Conduct" },
      {
        id: "g1-1",
        label: "G1-1: Business Conduct Policies and Corporate Culture",
      },
      { id: "g1-2", label: "G1-2: Management of Relationships with Supplier" },
      {
        id: "g1-3",
        label: "G1-3: Prevention and Detection of Corruption and Bribery",
      },
      { id: "g1-4", label: "G1-4: Incidents of Corruption or Bribery" },
      {
        id: "g1-5",
        label: "G1-5: Political Influence and Lobbying Activities",
      },
      { id: "g1-6", label: "G1-6: Payment Practices" },
    ],
  },
  {
    heading: null,
    items: [{ id: "others", label: "Others" }],
  },
];
export const Annexure_2 = [
  {
    heading: "SDG Goal 1: No Poverty",
    items: [
      { id: "sdg1-1", label: "Target 1.1 – Eradicate extreme poverty" },
      { id: "sdg1-2", label: "Target 1.2 – Reduce poverty by half" },
      {
        id: "sdg1-3",
        label: "Target 1.3 – Implement social protection systems",
      },
      {
        id: "sdg1-4",
        label:
          "Target 1.4 – Ensure equal rights to economic resources and basic services",
      },
      {
        id: "sdg1-5",
        label: "Target 1.5 – Build resilience to climate and economic shocks",
      },
      { id: "sdg1-a", label: "Target 1.a – Mobilize resources to end poverty" },
      {
        id: "sdg1-b",
        label:
          "Target 1.b – Create pro-poor and gender-sensitive policy frameworks",
      },
    ],
  },
  {
    heading: "SDG Goal 2: Zero Hunger",
    items: [
      {
        id: "sdg2-1",
        label:
          "Target 2.1 – End hunger and ensure access to safe, nutritious food",
      },
      { id: "sdg2-2", label: "Target 2.2 – End all forms of malnutrition" },
      {
        id: "sdg2-3",
        label:
          "Target 2.3 – Double agricultural productivity and incomes of small-scale producers",
      },
      {
        id: "sdg2-4",
        label: "Target 2.4 – Ensure sustainable food production systems",
      },
      {
        id: "sdg2-5",
        label:
          "Target 2.5 – Maintain genetic diversity of seeds, plants, and animals",
      },
      {
        id: "sdg2-a",
        label:
          "Target 2.a – Increase investment in agriculture and rural infrastructure",
      },
      {
        id: "sdg2-b",
        label:
          "Target 2.b – Correct and prevent trade restrictions and distortions",
      },
      {
        id: "sdg2-c",
        label:
          "Target 2.c – Ensure proper functioning of food commodity markets",
      },
    ],
  },
  {
    heading: "SDG Goal 3: Good Health and Well-being",
    items: [
      { id: "sdg3-1", label: "Target 3.1 – Reduce maternal mortality" },
      {
        id: "sdg3-2",
        label:
          "Target 3.2 – End preventable deaths of newborns and children under 5",
      },
      {
        id: "sdg3-3",
        label:
          "Target 3.3 – End epidemics of AIDS, tuberculosis, malaria, and other communicable diseases",
      },
      {
        id: "sdg3-4",
        label:
          "Target 3.4 – Reduce one third mortality from non-communicable diseases and promote mental health",
      },
      { id: "sdg3-5", label: "Target 3.5 – Prevent and treat substance abuse" },
      {
        id: "sdg3-6",
        label: "Target 3.6 – Halve road traffic deaths and injuries",
      },
      {
        id: "sdg3-7",
        label:
          "Target 3.7 – Ensure access to sexual and reproductive health care",
      },
      { id: "sdg3-8", label: "Target 3.8 – Achieve universal health coverage" },
      {
        id: "sdg3-9",
        label:
          "Target 3.9 – Reduce deaths from hazardous chemicals and pollution",
      },
      {
        id: "sdg3-a",
        label:
          "Target 3.a – Implement the WHO Framework Convention on Tobacco Control",
      },
      {
        id: "sdg3-b",
        label:
          "Target 3.b – Support research and development of vaccines and medicines",
      },
      {
        id: "sdg3-c",
        label:
          "Target 3.c – Increase health financing and health workforce development",
      },
      {
        id: "sdg3-d",
        label:
          "Target 3.d – Strengthen capacity for early warning and risk reduction",
      },
    ],
  },
  {
    heading: "SDG Goal 4: Quality Education",
    items: [
      {
        id: "sdg4-1",
        label:
          "Target 4.1 – Ensure completion of primary and secondary education",
      },
      {
        id: "sdg4-2",
        label:
          "Target 4.2 – Ensure access to early childhood development and pre-primary education",
      },
      {
        id: "sdg4-3",
        label:
          "Target 4.3 – Ensure equal access to technical, vocational, and tertiary education",
      },
      {
        id: "sdg4-4",
        label:
          "Target 4.4 – Increase skills for employment and entrepreneurship",
      },
      {
        id: "sdg4-5",
        label: "Target 4.5 – Eliminate gender disparities in education",
      },
      {
        id: "sdg4-6",
        label:
          "Target 4.6 – Ensure youth and adults achieve literacy and numeracy",
      },
      {
        id: "sdg4-7",
        label:
          "Target 4.7 – Ensure learners acquire knowledge for sustainable development",
      },
      {
        id: "sdg4-a",
        label:
          "Target 4.a – Build and upgrade inclusive and safe education facilities",
      },
      {
        id: "sdg4-b",
        label: "Target 4.b – Expand scholarships for developing countries",
      },
      {
        id: "sdg4-c",
        label: "Target 4.c – Increase the supply of qualified teachers",
      },
    ],
  },
  {
    heading: "SDG Goal 5: Gender Equality",
    items: [
      {
        id: "sdg5-1",
        label:
          "Target 5.1 – End all forms of discrimination against women and girls",
      },
      {
        id: "sdg5-2",
        label: "Target 5.2 – Eliminate violence against women and girls",
      },
      {
        id: "sdg5-3",
        label:
          "Target 5.3 – Eliminate harmful practices (e.g., child, early, and forced marriage)",
      },
      {
        id: "sdg5-4",
        label: "Target 5.4 – Recognize and value unpaid care and domestic work",
      },
      {
        id: "sdg5-5",
        label:
          "Target 5.5 – Ensure full participation and equal leadership opportunities",
      },
      {
        id: "sdg5-6",
        label:
          "Target 5.6 – Ensure universal access to sexual and reproductive health and rights",
      },
      {
        id: "sdg5-a",
        label:
          "Target 5.a – Ensure equal rights to economic resources and property",
      },
      {
        id: "sdg5-b",
        label:
          "Target 5.b – Enhance the use of enabling technology to empower women",
      },
      {
        id: "sdg5-c",
        label:
          "Target 5.c – Adopt and strengthen gender equality policies and enforceable legislation",
      },
    ],
  },
  {
    heading: "SDG Goal 6: Clean Water and Sanitation",
    items: [
      {
        id: "sdg6-1",
        label:
          "Target 6.1 – Achieve universal and equitable access to safe and affordable drinking water",
      },
      {
        id: "sdg6-2",
        label:
          "Target 6.2 – Achieve access to adequate and equitable sanitation and hygiene",
      },
      {
        id: "sdg6-3",
        label:
          "Target 6.3 – Improve water quality by reducing pollution and minimizing release of hazardous chemicals",
      },
      {
        id: "sdg6-4",
        label:
          "Target 6.4 – Increase water-use efficiency and ensure sustainable withdrawals",
      },
      {
        id: "sdg6-5",
        label: "Target 6.5 – Implement integrated water resources management",
      },
      {
        id: "sdg6-6",
        label: "Target 6.6 – Protect and restore water-related ecosystems",
      },
      {
        id: "sdg6-a",
        label:
          "Target 6.a – Expand international cooperation for water and sanitation-related activities",
      },
      {
        id: "sdg6-b",
        label:
          "Target 6.b – Support participation of local communities in water and sanitation management",
      },
    ],
  },
  {
    heading: "SDG Goal 7: Affordable and Clean Energy",
    items: [
      {
        id: "sdg7-1",
        label:
          "Target 7.1 – Ensure universal access to affordable, reliable, and modern energy services",
      },
      {
        id: "sdg7-2",
        label:
          "Target 7.2 – Increase the share of renewable energy in the global energy mix",
      },
      {
        id: "sdg7-3",
        label:
          "Target 7.3 – Double the global rate of improvement in energy efficiency",
      },
      {
        id: "sdg7-a",
        label:
          "Target 7.a – Enhance international cooperation to facilitate access to clean energy research and technology",
      },
      {
        id: "sdg7-b",
        label:
          "Target 7.b – Expand infrastructure and upgrade technology for supplying modern and sustainable energy",
      },
    ],
  },
  {
    heading: "SDG Goal 8: Decent Work and Economic Growth",
    items: [
      {
        id: "sdg8-1",
        label: "Target 8.1 – Sustain per capita economic growth",
      },
      {
        id: "sdg8-2",
        label: "Target 8.2 – Achieve higher levels of economic productivity",
      },
      {
        id: "sdg8-3",
        label:
          "Target 8.3 – Promote development-oriented policies for productive employment",
      },
      {
        id: "sdg8-4",
        label:
          "Target 8.4 – Improve resource efficiency and decouple economic growth from environmental degradation",
      },
      {
        id: "sdg8-5",
        label:
          "Target 8.5 – Achieve full and productive employment and equal pay for work of equal value",
      },
      {
        id: "sdg8-6",
        label:
          "Target 8.6 – Substantially reduce the proportion of youth not in employment, education, or training",
      },
      {
        id: "sdg8-7",
        label:
          "Target 8.7 – Eradicate forced labour, end modern slavery and human trafficking, and eliminate child labour",
      },
      {
        id: "sdg8-8",
        label:
          "Target 8.8 – Protect labour rights and promote safe and secure working environments",
      },
      {
        id: "sdg8-9",
        label:
          "Target 8.9 – Promote sustainable tourism that creates jobs and promotes local culture and products",
      },
      {
        id: "sdg8-10",
        label:
          "Target 8.10 – Strengthen the capacity of domestic financial institutions to encourage access to banking, insurance, and financial services",
      },
      {
        id: "sdg8-a",
        label:
          "Target 8.a – Increase Aid for Trade support for developing countries",
      },
      {
        id: "sdg8-b",
        label:
          "Target 8.b – Develop and operationalize a global strategy for youth employment",
      },
    ],
  },
  {
    heading: "SDG Goal 9: Industry, Innovation and Infrastructure",
    items: [
      {
        id: "sdg9-1",
        label:
          "Target 9.1 – Develop quality, reliable, sustainable, and resilient infrastructure",
      },
      {
        id: "sdg9-2",
        label:
          "Target 9.2 – Promote inclusive and sustainable industrialization",
      },
      {
        id: "sdg9-3",
        label:
          "Target 9.3 – Increase the access of small-scale industries to financial services and integration into value chains",
      },
      {
        id: "sdg9-4",
        label:
          "Target 9.4 – Upgrade infrastructure and retrofit industries to make them sustainable",
      },
      {
        id: "sdg9-5",
        label:
          "Target 9.5 – Enhance scientific research and upgrade technological capabilities of industrial sectors",
      },
      {
        id: "sdg9-a",
        label:
          "Target 9.a – Facilitate sustainable and resilient infrastructure development in developing countries",
      },
      {
        id: "sdg9-b",
        label:
          "Target 9.b – Support domestic technology development, research, and innovation",
      },
      {
        id: "sdg9-c",
        label:
          "Target 9.c – Significantly increase access to information and communications technology",
      },
    ],
  },
  {
    heading: "SDG Goal 10: Reduced Inequalities",
    items: [
      { id: "sdg10-1", label: "Target 10.1 – Reduce income inequality" },
      {
        id: "sdg10-2",
        label: "Target 10.2 – Promote social, economic and political inclusion",
      },
      {
        id: "sdg10-3",
        label:
          "Target 10.3 – Ensure equal opportunity and reduce outcome inequalities",
      },
      {
        id: "sdg10-4",
        label: "Target 10.4 – Adopt policies for greater equality",
      },
      {
        id: "sdg10-5",
        label:
          "Target 10.5 – Improve regulation and monitoring of global financial markets and institutions",
      },
      {
        id: "sdg10-6",
        label:
          "Target 10.6 – Enhance representation for developing countries in decision-making in global institutions",
      },
      {
        id: "sdg10-7",
        label:
          "Target 10.7 – Facilitate safe, regular and responsible migration and mobility",
      },
      {
        id: "sdg10-a",
        label:
          "Target 10.a – Implement special and differential treatment for developing countries",
      },
      {
        id: "sdg10-b",
        label:
          "Target 10.b – Encourage official development assistance and financial flows to states most in need",
      },
      {
        id: "sdg10-c",
        label:
          "Target 10.c – Reduce the transaction costs of migrant remittances",
      },
    ],
  },
  {
    heading: "SDG Goal 11: Sustainable Cities and Communities",
    items: [
      {
        id: "sdg11-1",
        label:
          "Target 11.1 – Ensure access to adequate, safe and affordable housing",
      },
      {
        id: "sdg11-2",
        label:
          "Target 11.2 – Provide access to safe, affordable, accessible and sustainable transport systems",
      },
      {
        id: "sdg11-3",
        label:
          "Target 11.3 – Enhance inclusive and sustainable urbanization and participatory planning",
      },
      {
        id: "sdg11-4",
        label:
          "Target 11.4 – Strengthen efforts to protect the world’s cultural and natural heritage",
      },
      {
        id: "sdg11-5",
        label:
          "Target 11.5 – Reduce the number of people affected by disasters",
      },
      {
        id: "sdg11-6",
        label:
          "Target 11.6 – Reduce environmental impact of cities, including air quality and waste management",
      },
      {
        id: "sdg11-7",
        label:
          "Target 11.7 – Provide universal access to safe, inclusive and accessible green and public spaces",
      },
      {
        id: "sdg11-a",
        label:
          "Target 11.a – Support positive economic, social and environmental links between urban, peri-urban and rural areas",
      },
      {
        id: "sdg11-b",
        label:
          "Target 11.b – Increase the number of cities implementing integrated policies for inclusion, resource efficiency and climate change resilience",
      },
      {
        id: "sdg11-c",
        label:
          "Target 11.c – Support least developed countries in building sustainable and resilient buildings",
      },
    ],
  },
  {
    heading: "SDG Goal 12: Responsible Consumption and Production",
    items: [
      {
        id: "sdg12-1",
        label:
          "Target 12.1 – Implement the 10-Year Framework of Programmes on sustainable consumption and production",
      },
      {
        id: "sdg12-2",
        label:
          "Target 12.2 – Achieve sustainable management and efficient use of natural resources",
      },
      {
        id: "sdg12-3",
        label: "Target 12.3 – Halve per capita global food waste",
      },
      {
        id: "sdg12-4",
        label:
          "Target 12.4 – Ensure environmentally sound management of chemicals and waste",
      },
      {
        id: "sdg12-5",
        label:
          "Target 12.5 – Substantially reduce waste generation through prevention, reduction, recycling, and reuse",
      },
      {
        id: "sdg12-6",
        label:
          "Target 12.6 – Encourage companies to adopt sustainable practices and sustainability reporting",
      },
      {
        id: "sdg12-7",
        label: "Target 12.7 – Promote sustainable public procurement practices",
      },
      {
        id: "sdg12-8",
        label:
          "Target 12.8 – Ensure that people everywhere have relevant information for sustainable development",
      },
      {
        id: "sdg12-a",
        label:
          "Target 12.a – Support developing countries to strengthen their scientific and technological capacity",
      },
      {
        id: "sdg12-b",
        label:
          "Target 12.b – Develop tools to monitor sustainable development impacts for sustainable tourism",
      },
      {
        id: "sdg12-c",
        label: "Target 12.c – Rationalize inefficient fossil-fuel subsidies",
      },
    ],
  },
  {
    heading: "SDG Goal 13: Climate Action",
    items: [
      {
        id: "sdg13-1",
        label:
          "Target 13.1 – Strengthen resilience and adaptive capacity to climate-related hazards and natural disasters",
      },
      {
        id: "sdg13-2",
        label:
          "Target 13.2 – Integrate climate change measures into national policies, strategies, and planning",
      },
      {
        id: "sdg13-3",
        label:
          "Target 13.3 – Improve education, awareness, and human and institutional capacity on climate change mitigation, adaptation, impact reduction, and early warning",
      },
      {
        id: "sdg13-a",
        label:
          "Target 13.a – Implement the commitment to mobilize $100 billion annually to support developing countries in climate action",
      },
      {
        id: "sdg13-b",
        label:
          "Target 13.b – Promote mechanisms to raise capacity for effective climate change-related planning and management in least developed countries and small island developing States",
      },
    ],
  },
  {
    heading: "SDG Goal 14: Life Below Water",
    items: [
      { id: "sdg14-1", label: "Target 14.1 – Reduce marine pollution" },
      {
        id: "sdg14-2",
        label:
          "Target 14.2 – Sustainably manage and protect marine and coastal ecosystems",
      },
      {
        id: "sdg14-3",
        label: "Target 14.3 – Minimize and address ocean acidification",
      },
      {
        id: "sdg14-4",
        label: "Target 14.4 – Regulate harvesting and end overfishing",
      },
      {
        id: "sdg14-5",
        label:
          "Target 14.5 – Conserve at least 10% of coastal and marine areas",
      },
      {
        id: "sdg14-6",
        label: "Target 14.6 – Prohibit certain forms of fisheries subsidies",
      },
      {
        id: "sdg14-7",
        label:
          "Target 14.7 – Increase the economic benefits from sustainable use of marine resources",
      },
      {
        id: "sdg14-a",
        label:
          "Target 14.a – Increase scientific knowledge, research and technology for ocean health",
      },
      {
        id: "sdg14-b",
        label:
          "Target 14.b – Provide access for small-scale artisanal fishers to marine resources and markets",
      },
      {
        id: "sdg14-c",
        label:
          "Target 14.c – Enhance conservation and sustainable use of oceans through international law",
      },
    ],
  },
  {
    heading: "SDG Goal 15: Life on Land",
    items: [
      {
        id: "sdg15-1",
        label:
          "Target 15.1 – Ensure conservation of terrestrial and inland freshwater ecosystems",
      },
      {
        id: "sdg15-2",
        label:
          "Target 15.2 – Promote sustainable management of forests and reforestation",
      },
      {
        id: "sdg15-3",
        label: "Target 15.3 – Combat desertification and restore degraded land",
      },
      {
        id: "sdg15-4",
        label: "Target 15.4 – Ensure conservation of mountain ecosystems",
      },
      {
        id: "sdg15-5",
        label:
          "Target 15.5 – Take urgent action to reduce degradation of natural habitats and halt biodiversity loss",
      },
      {
        id: "sdg15-6",
        label:
          "Target 15.6 – Promote fair and equitable sharing of genetic resources",
      },
      {
        id: "sdg15-7",
        label:
          "Target 15.7 – End poaching and trafficking of protected species",
      },
      {
        id: "sdg15-8",
        label:
          "Target 15.8 – Prevent the introduction of invasive alien species",
      },
      {
        id: "sdg15-9",
        label:
          "Target 15.9 – Integrate ecosystem and biodiversity values into national and local planning",
      },
      {
        id: "sdg15-a",
        label:
          "Target 15.a – Mobilize resources to finance sustainable forest management",
      },
      {
        id: "sdg15-b",
        label:
          "Target 15.b – Mobilize funding to conserve and sustainably use biodiversity and ecosystems",
      },
      {
        id: "sdg15-c",
        label:
          "Target 15.c – Enhance global support for combating poaching and trafficking of protected species",
      },
    ],
  },
  {
    heading: "SDG Goal 16: Peace, Justice and Strong Institutions",
    items: [
      {
        id: "sdg16-1",
        label:
          "Target 16.1 – Reduce all forms of violence and related death rates",
      },
      {
        id: "sdg16-2",
        label:
          "Target 16.2 – End abuse, exploitation, trafficking and all forms of violence against children",
      },
      {
        id: "sdg16-3",
        label:
          "Target 16.3 – Promote the rule of law and ensure equal access to justice",
      },
      {
        id: "sdg16-4",
        label: "Target 16.4 – Reduce illicit financial and arms flows",
      },
      {
        id: "sdg16-5",
        label: "Target 16.5 – Substantially reduce corruption and bribery",
      },
      {
        id: "sdg16-6",
        label:
          "Target 16.6 – Develop effective, accountable and transparent institutions",
      },
      {
        id: "sdg16-7",
        label:
          "Target 16.7 – Ensure responsive, inclusive and representative decision-making",
      },
      {
        id: "sdg16-8",
        label:
          "Target 16.8 – Broaden and strengthen participation of developing countries in global governance",
      },
      {
        id: "sdg16-9",
        label:
          "Target 16.9 – Provide legal identity for all, including birth registration",
      },
      {
        id: "sdg16-10",
        label:
          "Target 16.10 – Ensure public access to information and protect fundamental freedoms",
      },
      {
        id: "sdg16-a",
        label:
          "Target 16.a – Strengthen institutions to prevent violence and combat crime and terrorism",
      },
      {
        id: "sdg16-b",
        label:
          "Target 16.b – Promote and enforce non-discriminatory laws and policies",
      },
    ],
  },
  {
    heading: "SDG Goal 17: Partnerships for the Goals",
    items: [
      {
        id: "sdg17-1",
        label: "Target 17.1 – Strengthen domestic resource mobilization",
      },
      {
        id: "sdg17-2",
        label: "Target 17.2 – Implement all development assistance commitments",
      },
      {
        id: "sdg17-3",
        label:
          "Target 17.3 – Mobilize additional financial resources for developing countries",
      },
      {
        id: "sdg17-4",
        label:
          "Target 17.4 – Assist in attaining long-term debt sustainability",
      },
      {
        id: "sdg17-5",
        label:
          "Target 17.5 – Adopt investment promotion regimes for least developed countries",
      },
      {
        id: "sdg17-6",
        label:
          "Target 17.6 – Enhance cooperation on science, technology, and innovation",
      },
      {
        id: "sdg17-7",
        label:
          "Target 17.7 – Promote development and transfer of environmentally sound technologies",
      },
      {
        id: "sdg17-8",
        label:
          "Target 17.8 – Fully operationalize the technology bank for least developed countries",
      },
      {
        id: "sdg17-9",
        label:
          "Target 17.9 – Enhance international support for implementing capacity-building",
      },
      {
        id: "sdg17-10",
        label:
          "Target 17.10 – Promote a universal, rules-based, open and equitable trading system",
      },
      {
        id: "sdg17-11",
        label:
          "Target 17.11 – Significantly increase exports of developing countries",
      },
      {
        id: "sdg17-12",
        label:
          "Target 17.12 – Realize timely implementation of duty-free and quota-free market access",
      },
      {
        id: "sdg17-13",
        label: "Target 17.13 – Enhance global macroeconomic stability",
      },
      {
        id: "sdg17-14",
        label:
          "Target 17.14 – Enhance policy coherence for sustainable development",
      },
      {
        id: "sdg17-15",
        label:
          "Target 17.15 – Respect each country's policy space for poverty eradication",
      },
      {
        id: "sdg17-16",
        label:
          "Target 17.16 – Enhance global partnerships for sustainable development",
      },
      {
        id: "sdg17-17",
        label:
          "Target 17.17 – Encourage effective public, public-private and civil society partnerships",
      },
      {
        id: "sdg17-18",
        label:
          "Target 17.18 – Enhance capacity-building to increase availability of high-quality, timely data",
      },
      {
        id: "sdg17-19",
        label:
          "Target 17.19 – Build on existing initiatives to develop sustainable development indicators",
      },
    ],
  },
];
export const CDP_COMPLIANCE_CUSTOM = [
  {
    heading: "CDP – Climate Change Disclosure",
    items: [
      {
        id: "board-oversight",
        label: "Board-level oversight of climate-related issues",
      },
      {
        id: "management-responsibilities",
        label: "Climate-related management responsibilities",
      },
      { id: "governance-structure", label: "Climate governance structure" },
      { id: "ghg-inventory", label: "GHG emissions inventory (Scope 1, 2, 3)" },
      {
        id: "third-party-verification",
        label: "Third-party verification of GHG data",
      },
      {
        id: "emission-reduction",
        label: "Emission reduction initiatives and targets",
      },
      {
        id: "energy-consumption",
        label: "Energy consumption (renewable vs non-renewable)",
      },
      { id: "carbon-pricing", label: "Internal carbon pricing" },
      {
        id: "climate-scenario-analysis",
        label: "Climate scenario analysis (e.g., IEA, IPCC pathways)",
      },
      {
        id: "physical-risks",
        label: "Physical risks (floods, heatwaves, sea-level rise)",
      },
      {
        id: "transition-risks",
        label: "Transition risks (policy, technology, market shifts)",
      },
      {
        id: "financial-planning",
        label: "Financial planning impacted by climate risk",
      },
      {
        id: "climate-opportunities",
        label: "Climate opportunities (low-carbon tech, efficiency)",
      },
      { id: "sbti", label: "Science-Based Targets (SBTi)" },
      { id: "net-zero", label: "Net-zero commitment" },
      {
        id: "policy-engagement",
        label: "Policy engagement on climate regulation",
      },
      { id: "environmental-kpis", label: "Environmental KPIs" },
      { id: "cdp-scoring", label: "CDP scoring" },
    ],
  },
  {
    heading: "CDP – Water Security Disclosure",
    items: [
      { id: "water-withdrawal", label: "Water withdrawal volume and sources" },
      { id: "water-recycling", label: "Water consumption and recycling rates" },
      { id: "water-stress", label: "Water stress mapping (basin-level risk)" },
      {
        id: "water-risk-assessment",
        label: "Water-related risk assessment and response plans",
      },
      { id: "efficiency-targets", label: "Water use efficiency targets" },
      {
        id: "pollution-discharge",
        label: "Water pollution and discharge practices",
      },
      {
        id: "wastewater-strategy",
        label: "Wastewater treatment and reuse strategy",
      },
      {
        id: "supply-chain-water-risk",
        label: "Supply chain water risk identification",
      },
      {
        id: "strategy-integration",
        label: "Integration of water risks into strategy",
      },
      { id: "ecosystem-impact", label: "Impact on water-dependent ecosystems" },
      { id: "stewardship-collab", label: "Water stewardship collaborations" },
      {
        id: "regulatory-compliance-water",
        label: "Regulatory compliance (water use, quality)",
      },
    ],
  },
  {
    heading: "CDP – Forests Disclosure",
    items: [
      {
        id: "forest-commodities",
        label:
          "Forest-risk commodities used (i.e. palm oil, soy, timber, cattle)",
      },
      {
        id: "supply-traceability",
        label: "Supply chain traceability (volume and origin)",
      },
      { id: "deforestation-free", label: "Deforestation-free commitments" },
      {
        id: "certification-schemes",
        label: "Certification schemes (i.e. FSC, RSPO, RTRS)",
      },
      { id: "land-monitoring", label: "Monitoring of land use change" },
      {
        id: "illegal-deforestation",
        label: "Policy to eliminate illegal deforestation",
      },
      {
        id: "certified-sources",
        label: "Volume purchased/produced from certified sources",
      },
      {
        id: "supplier-engagement",
        label: "Engagement with suppliers on forest risk reduction",
      },
      {
        id: "sourcing-policies",
        label:
          "Sourcing policies and NDPE (No Deforestation, No Peat, No Exploitation)",
      },
      {
        id: "regional-compliance",
        label: "Compliance with regional deforestation regulations",
      },
    ],
  },
  {
    heading: "CDP – Supply Chain Key Disclosure",
    items: [
      {
        id: "supplier-ghg",
        label: "Supplier GHG emissions (Scope 3 – upstream)",
      },
      {
        id: "supplier-sbti",
        label: "Science-based target adoption by suppliers",
      },
      {
        id: "supplier-disclosure",
        label: "Supplier climate risk disclosure to CDP",
      },
      {
        id: "spend-based-emissions",
        label: "Spend-based emissions calculations",
      },
      {
        id: "emissions-factors",
        label: "Supplier-specific vs industry-based emissions factors",
      },
      {
        id: "procurement-policies",
        label: "Procurement policies linked to sustainability criteria",
      },
      {
        id: "sourcing-programs",
        label: "Responsible sourcing and training programs",
      },
      {
        id: "supplier-incentives",
        label: "Supplier incentives for emissions reduction",
      },
      {
        id: "progress-monitoring",
        label: "Monitoring of supplier progress against climate targets",
      },
      {
        id: "contract-risk",
        label: "Climate risk incorporated into contract requirements",
      },
    ],
  },
];
export const WB_COMPLIANCE_CUSTOM = [
  {
    heading: "ESS1 – Environmental & Social Assessment",
    items: [
      { id: "esia", label: "ESIA" },
      { id: "esmp", label: "ESMP" },
      { id: "environmental-risk-rating", label: "Environmental risk rating" },
      { id: "social-risk-rating", label: "Social risk rating" },
      { id: "mitigation-measures", label: "Mitigation measures" },
      {
        id: "cumulative-impact-assessment",
        label: "Cumulative impact assessment",
      },
    ],
  },
  {
    heading: "ESS2 – Labor & Working Conditions",
    items: [
      { id: "lmp", label: "LMP (Labor Management Procedures)" },
      { id: "ohs-plan", label: "OHS plan" },
      { id: "worker-grievance-mechanism", label: "Worker grievance mechanism" },
      { id: "code-of-conduct", label: "Code of conduct" },
      {
        id: "gbv-prevention-measures",
        label: "Gender-based violence (GBV) prevention measures",
      },
      {
        id: "child-labor-forced-labor-risk",
        label: "Child labor and forced labor risk",
      },
      {
        id: "non-discrimination-in-employment",
        label: "Non-discrimination in employment",
      },
      {
        id: "worker-accommodation-standards",
        label: "Worker accommodation standards",
      },
      {
        id: "employment-terms-conditions",
        label: "Employment Terms and conditions",
      },
    ],
  },
  {
    heading: "ESS3 – Resource Efficiency & Pollution",
    items: [
      { id: "ghg-emissions", label: "GHG emissions" },
      { id: "energy-efficiency", label: "Energy efficiency" },
      { id: "water-use-conservation", label: "Water use and conservation" },
      { id: "hazardous-waste", label: "Hazardous waste" },
      {
        id: "waste-generation-management",
        label: "Waste generation and management",
      },
      { id: "pollution-prevention", label: "Pollution prevention" },
      {
        id: "climate-resilience-features",
        label: "Climate resilience features",
      },
    ],
  },
  {
    heading: "ESS4 – Community Health & Safety",
    items: [
      { id: "road-safety", label: "Road safety" },
      { id: "emergency-preparedness", label: "Emergency preparedness" },
      {
        id: "community-grievance-redress",
        label: "Community grievance redress",
      },
      {
        id: "community-health-safety-management",
        label: "Community Health and Safety Management",
      },
    ],
  },
  {
    heading: "ESS5 – Land Acquisition and Involuntary Resettlement",
    items: [
      { id: "rap", label: "RAP (Resettlement Action Plan)" },
      {
        id: "compensation-payment-tracking",
        label: "Compensation payment tracking",
      },
      { id: "livelihood-restoration", label: "Livelihood restoration" },
    ],
  },
  {
    heading: "ESS6 – Biodiversity",
    items: [
      { id: "critical-habitat", label: "Critical habitat" },
      { id: "protected-area-mapping", label: "Protected area mapping" },
      { id: "biodiversity-offset", label: "Biodiversity offset" },
      {
        id: "ecosystem-services-analysis",
        label: "Ecosystem services analysis",
      },
      {
        id: "alien-invasive-species-control",
        label: "Alien/invasive species control",
      },
      {
        id: "no-net-loss-net-gain-strategy",
        label: "No Net Loss/Net Gain strategy",
      },
      {
        id: "forestry-fisheries-resource-sustainability",
        label: "Forestry, fisheries, and resource sustainability measures",
      },
      { id: "monitoring-flora-fauna", label: "Monitoring of flora/fauna" },
    ],
  },
  {
    heading: "ESS7 – Indigenous Peoples",
    items: [
      { id: "fpic", label: "FPIC (Free, Prior and Informed Consent)" },
      {
        id: "indigenous-consultation-logs",
        label: "Indigenous consultation logs",
      },
      { id: "indigenous-peoples-plan", label: "Indigenous Peoples Plan (IPP)" },
    ],
  },
  {
    heading: "ESS8 – Cultural Heritage",
    items: [
      {
        id: "cultural-heritage-management-plan",
        label: "Cultural Heritage Management Plan",
      },
      { id: "chance-finds-procedure", label: "Chance finds procedure" },
      { id: "archaeological-assessment", label: "Archaeological assessment" },
    ],
  },
  {
    heading: "ESS9 – Financial Intermediaries",
    items: [
      {
        id: "es-risk-screening-fi-subprojects",
        label: "E&S risk screening for FI subprojects",
      },
      { id: "capacity-assessment", label: "Capacity assessment" },
      {
        id: "environmental-social-risk-categorization",
        label: "Environmental and social risk categorization",
      },
      {
        id: "monitoring-system-subprojects",
        label: "Monitoring system for subprojects",
      },
      {
        id: "grievance-mechanisms-fi-clients",
        label: "Grievance mechanisms for FI clients",
      },
    ],
  },
  {
    heading: "ESS10 – Stakeholder Engagement",
    items: [
      { id: "sep", label: "SEP (Stakeholder Engagement Plan)" },
      { id: "public-disclosure", label: "Public disclosure" },
      { id: "consultation-logs", label: "Consultation logs" },
      { id: "grievance-redress-log", label: "Grievance redress log" },
      {
        id: "stakeholder-mapping-analysis",
        label: "Stakeholder mapping and analysis",
      },
    ],
  },
];
export const IFC_COMPLIANCE_CUSTOM = [
  {
    heading:
      "PS1 – Assessment and Management of Environmental and Social Risks and Impacts",
    items: [
      {
        id: "esms",
        label: "Environmental and Social Management System (ESMS)",
      },
      { id: "esia-esmp", label: "ESIA / ESMP" },
      {
        id: "impact-mitigation-hierarchy",
        label: "Impact mitigation hierarchy",
      },
      { id: "esap", label: "ESAP (Action Plan)" },
      { id: "monitoring-evaluation", label: "Monitoring and evaluation" },
      { id: "stakeholder-engagement", label: "Stakeholder engagement" },
    ],
  },
  {
    heading: "PS2 – Labor and Working Conditions",
    items: [
      { id: "lmp", label: "Labor Management Plan (LMP)" },
      { id: "ohs", label: "Occupational Health & Safety (OHS)" },
      { id: "child-forced-labor-risk", label: "Child/forced labor risk" },
      {
        id: "grievance-redress-workers",
        label: "Grievance redress for workers",
      },
      { id: "workforce-demographics", label: "Workforce demographics" },
    ],
  },
  {
    heading: "PS3 – Resource Efficiency and Pollution Prevention",
    items: [
      { id: "ghg-emissions", label: "GHG emissions" },
      { id: "water-energy-use", label: "Water and energy use" },
      { id: "waste-reduction", label: "Waste reduction" },
      {
        id: "hazardous-material-handling",
        label: "Hazardous material handling",
      },
      { id: "pollution-abatement", label: "Pollution abatement" },
    ],
  },
  {
    heading: "PS4 – Community Health, Safety, and Security",
    items: [
      {
        id: "security-personnel-protocol",
        label: "Security personnel protocol",
      },
      { id: "road-safety", label: "Road safety" },
      { id: "infrastructure-safety", label: "Infrastructure safety" },
      { id: "emergency-preparedness", label: "Emergency preparedness" },
      {
        id: "communicable-disease-control",
        label: "Communicable disease control",
      },
    ],
  },
  {
    heading: "PS5 – Land Acquisition and Involuntary Resettlement",
    items: [
      { id: "rap", label: "RAP (Resettlement Action Plan)" },
      { id: "livelihood-restoration", label: "Livelihood restoration" },
      { id: "displacement-metrics", label: "Displacement metrics" },
      {
        id: "vulnerable-groups-assessment",
        label: "Vulnerable groups assessment",
      },
      { id: "compensation-framework", label: "Compensation framework" },
    ],
  },
  {
    heading:
      "PS6 – Biodiversity Conservation and Sustainable Management of Living Natural Resources",
    items: [
      { id: "critical-habitat", label: "Critical habitat" },
      { id: "no-net-loss", label: "No Net Loss/Net Gain" },
      { id: "ecosystem-services", label: "Ecosystem services" },
      { id: "species-at-risk", label: "Species at risk" },
      { id: "biodiversity-monitoring", label: "Biodiversity monitoring" },
    ],
  },
  {
    heading: "PS7 – Indigenous Peoples",
    items: [
      { id: "fpic", label: "FPIC (Free, Prior, and Informed Consent)" },
      { id: "ipp", label: "Indigenous Peoples Plan (IPP)" },
      { id: "customary-land-rights", label: "Customary land rights" },
      {
        id: "cultural-identity-protection",
        label: "Cultural identity protection",
      },
    ],
  },
  {
    heading: "PS8 – Cultural Heritage",
    items: [
      { id: "chmp", label: "CHMP (Cultural Heritage Management Plan)" },
      { id: "archaeological-finds", label: "Archaeological finds" },
      { id: "sacred-sites", label: "Sacred sites" },
      {
        id: "cultural-property-risk",
        label: "Cultural property risk management",
      },
    ],
  },
];
export const EP_COMPLIANCE_ENHANCED = [
  {
    heading: "EP1: Review and Categorisation",
    items: [
      {
        id: "project-risk-classification",
        label: "Project risk classification (A / B / C)",
      },
      {
        id: "environmental-social-categorization",
        label: "Environmental & Social categorization",
      },
      { id: "sector-risk-profile", label: "Sector risk profile" },
      { id: "country-risk", label: "Country risk" },
      {
        id: "project-finance-eligibility",
        label: "Project finance eligibility",
      },
      { id: "early-screening", label: "Early screening" },
    ],
  },
  {
    heading: "EP2: Environmental and Social Assessment",
    items: [
      { id: "esia", label: "Environmental & Social Impact Assessment (ESIA)" },
      { id: "esmp", label: "ESMP (Environmental & Social Management Plan)" },
      { id: "esdd", label: "Environmental & Social Due Diligence (ESDD)" },
      { id: "baseline-conditions", label: "Baseline conditions" },
      { id: "impact-evaluation", label: "Impact evaluation" },
      { id: "alternatives-analysis", label: "Alternatives analysis" },
      {
        id: "social-environmental-context",
        label: "Social and environmental context",
      },
      {
        id: "project-risks-impacts",
        label: "Project-related risks and impacts",
      },
      {
        id: "impact-mitigation-hierarchy",
        label: "Impact mitigation hierarchy",
      },
    ],
  },
  {
    heading: "EP3: Applicable Environmental and Social Standards",
    items: [
      { id: "ifc-ps", label: "IFC Performance Standards" },
      { id: "world-bank-ehs", label: "World Bank EHS Guideline" },
      { id: "host-country-regulations", label: "Host country regulations" },
      {
        id: "international-best-practices",
        label: "International best practices",
      },
      { id: "legal-compliance", label: "Legal compliance" },
      { id: "standards-harmonization", label: "Harmonization of standards" },
    ],
  },
  {
    heading: "EP4: ESMS and Equator Principles Action Plan (EPAP)",
    items: [
      { id: "esms", label: "Environmental & Social Management System (ESMS)" },
      { id: "epap", label: "EP Action Plan (EPAP)" },
      { id: "esap", label: "ESAP (Action Plan)" },
      { id: "risk-mitigation-measures", label: "Risk mitigation measures" },
      { id: "implementation-timeline", label: "Implementation timeline" },
      { id: "monitoring-evaluation", label: "Monitoring and evaluation" },
      { id: "borrower-accountability", label: "Borrower accountability" },
    ],
  },
  {
    heading: "EP5: Stakeholder Engagement",
    items: [
      { id: "sep", label: "Stakeholder Engagement Plan (SEP)" },
      { id: "meaningful-consultation", label: "Meaningful consultation" },
      { id: "public-disclosure", label: "Public disclosure" },
      { id: "community-participation", label: "Community participation" },
      { id: "vulnerable-groups", label: "Vulnerable groups" },
      { id: "indigenous-peoples", label: "Indigenous Peoples" },
      { id: "fpic", label: "FPIC (Free, Prior and Informed Consent)" },
      { id: "stakeholder-engagement", label: "Stakeholder engagement" },
    ],
  },
  {
    heading: "EP6: Grievance Mechanism",
    items: [
      { id: "grievance-mechanism", label: "Grievance Redress Mechanism (GRM)" },
      { id: "complaint-resolution", label: "Complaint resolution process" },
      { id: "community-grievance-log", label: "Community grievance log" },
      {
        id: "accessibility-transparency",
        label: "Accessibility and transparency",
      },
      { id: "worker-grievances", label: "Worker grievances" },
      {
        id: "grievance-redress-workers",
        label: "Grievance redress for workers",
      },
    ],
  },
  {
    heading: "EP7: Independent Review",
    items: [
      { id: "independent-consultant", label: "Independent E&S consultant" },
      { id: "third-party-review", label: "Third-party ESIA review" },
      {
        id: "risk-categorization-verification",
        label: "Verification of risk categorization",
      },
      { id: "site-inspections", label: "Monitoring and site inspections" },
      { id: "advisory-opinion", label: "Advisory opinion" },
      { id: "mitigation-evaluation", label: "Risk mitigation evaluation" },
    ],
  },
  {
    heading: "EP8: Covenants",
    items: [
      { id: "es-covenants", label: "Environmental and social covenants" },
      { id: "epap-compliance", label: "EPAP compliance as loan condition" },
      { id: "legal-clauses-es", label: "Legal clauses for E&S performance" },
      { id: "non-compliance-triggers", label: "Non-compliance triggers" },
      { id: "lender-rights", label: "Lender rights enforcement" },
    ],
  },
  {
    heading: "EP9: Independent Monitoring and Reporting",
    items: [
      { id: "monitoring-reports", label: "Monitoring reports" },
      { id: "independent-audit", label: "Independent environmental audit" },
      { id: "es-kpis", label: "E&S KPIs" },
      { id: "corrective-action-tracking", label: "Corrective action tracking" },
    ],
  },
  {
    heading: "EP10: Reporting and Transparency",
    items: [
      { id: "public-disclosure-ep", label: "Public EP disclosure" },
      { id: "reporting-epfis", label: "Reporting to EPFIs" },
      {
        id: "annual-reporting",
        label: "Annual reporting by financial institutions",
      },
    ],
  },
];
export const ISO_COMPLIANCE_CUSTOMIZATION = [
  {
    heading: "ISO 14001: Environmental Management",
    items: [
      {
        id: "environmental-aspects-impacts",
        label: "Environmental aspects and impacts",
      },
      { id: "objectives-targets", label: "Objectives and measurable targets" },
      { id: "ems", label: "Environmental Management System (EMS)" },
      {
        id: "operational-controls",
        label: "Operational controls and maintenance",
      },
      {
        id: "compliance-obligations",
        label: "Compliance obligations (legal and voluntary)",
      },
      {
        id: "environmental-performance",
        label: "Environmental performance evaluation",
      },
      { id: "emergency-response", label: "Emergency environmental response" },
      {
        id: "lifecycle-perspective",
        label: "Lifecycle perspective integration",
      },
      { id: "environmental-policy", label: "Environmental policy statement" },
      {
        id: "environmental-audits",
        label: "Internal and external environmental audits",
      },
      {
        id: "continual-improvement",
        label: "Continual environmental improvement",
      },
      { id: "resource-conservation", label: "Resource use and conservation" },
    ],
  },
  {
    heading: "ISO 45001: Occupational Health & Safety",
    items: [
      {
        id: "ohsms",
        label: "Occupational Health & Safety Management System (OHSMS)",
      },
      {
        id: "risk-hazard-assessment",
        label: "Risk and hazard identification and assessment",
      },
      {
        id: "worker-participation",
        label: "Worker and contractor consultation and participation",
      },
      {
        id: "incident-response",
        label: "Workplace incident and accident response",
      },
      {
        id: "hse-compliance",
        label: "Legal and regulatory compliance (labor, health)",
      },
      {
        id: "emergency-preparedness",
        label: "Emergency preparedness and drills",
      },
      {
        id: "performance-indicators",
        label: "H&S performance indicators (LTIFR, TRIR)",
      },
      {
        id: "roles-responsibilities",
        label: "Roles, responsibilities, and competencies",
      },
      {
        id: "injury-health-logs",
        label: "Work-related injuries and ill health logs",
      },
      {
        id: "hse-objectives",
        label: "Health and safety objectives and programs",
      },
      { id: "control-hierarchy", label: "Hierarchy of control implementation" },
      {
        id: "training-programs",
        label: "Safety training and induction programs",
      },
    ],
  },
  {
    heading: "ISO 9001: Quality Management",
    items: [
      { id: "qms", label: "Quality Management System (QMS)" },
      {
        id: "customer-satisfaction",
        label: "Customer satisfaction and complaint resolution",
      },
      {
        id: "document-control",
        label: "Documented procedures and records control",
      },
      { id: "capa", label: "Corrective and preventive action (CAPA)" },
      { id: "quality-audits", label: "Internal and external audits" },
      {
        id: "management-review",
        label: "Management review and continuous improvement",
      },
      {
        id: "performance-monitoring",
        label: "Process performance and monitoring",
      },
      { id: "product-conformity", label: "Product conformity and inspection" },
      { id: "supplier-assurance", label: "Supplier quality assurance" },
      {
        id: "nonconformity-control",
        label: "Nonconformity reporting and control",
      },
      { id: "risk-based-thinking", label: "Risk-based thinking in processes" },
      {
        id: "quality-objectives",
        label: "Quality objectives at relevant functions",
      },
    ],
  },
  {
    heading: "ISO 50001: Energy Management",
    items: [
      { id: "enpis", label: "Energy performance indicators (EnPIs)" },
      { id: "energy-baseline", label: "Energy baseline and benchmarking" },
      {
        id: "efficiency-improvements",
        label: "Energy efficiency improvements",
      },
      {
        id: "energy-review",
        label: "Energy review and significant uses (SEUs)",
      },
      { id: "monitoring-metering", label: "Monitoring and metering plans" },
      { id: "energy-data", label: "Energy data collection and analysis" },
      { id: "energy-objectives", label: "Energy objectives and action plans" },
      {
        id: "equipment-optimization",
        label: "Equipment optimization and upgrades",
      },
      { id: "energy-procurement", label: "Energy-aware procurement" },
      { id: "energy-audits", label: "Internal audits of energy management" },
      { id: "ecms", label: "Energy conservation measures (ECMs)" },
      {
        id: "energy-legal",
        label: "Legal and other energy-related requirements",
      },
    ],
  },
  {
    heading: "ISO 26000: Social Responsibility",
    items: [
      { id: "human-rights", label: "Human rights due diligence" },
      { id: "labor-practices", label: "Labor practices and fair treatment" },
      {
        id: "fair-operating-practices",
        label: "Fair operating practices and transparency",
      },
      {
        id: "community-development",
        label: "Community involvement and local development",
      },
      {
        id: "consumer-rights",
        label: "Consumer rights and responsible communication",
      },
      {
        id: "governance-ethics",
        label: "Organizational governance and ethical behavior",
      },
      {
        id: "env-responsibility",
        label: "Environmental responsibility within SR",
      },
      {
        id: "gender-equality",
        label: "Gender equality and non-discrimination",
      },
      { id: "supply-chain-impact", label: "Supply chain social impact" },
      { id: "volunteerism", label: "Volunteerism and community engagement" },
      { id: "social-impact-assessment", label: "Social impact assessments" },
      {
        id: "anti-discrimination",
        label: "Anti-discrimination in recruitment",
      },
    ],
  },
  {
    heading: "ISO 14064: GHG Accounting",
    items: [
      { id: "scope-emissions", label: "Scope 1 / 2 / 3 emissions accounting" },
      {
        id: "ghg-quantification",
        label: "GHG quantification and emission factors",
      },
      {
        id: "third-party-verification",
        label: "Verification and validation by third parties",
      },
      { id: "emission-targets", label: "Emission reduction target setting" },
      {
        id: "base-year-recalculation",
        label: "Base year emissions recalculation",
      },
      {
        id: "ghg-boundaries",
        label: "Organizational and operational boundaries",
      },
      {
        id: "intensity-ratios",
        label: "Emission intensity ratios (e.g., tCO₂e/unit)",
      },
      { id: "ghg-inventory", label: "GHG inventory management plan" },
      {
        id: "emission-sources",
        label: "Direct and indirect emissions sources",
      },
      { id: "carbon-credits", label: "Carbon credits and offsets tracking" },
      {
        id: "ghg-reporting",
        label: "GHG reporting for internal and external stakeholders",
      },
      { id: "ghg-protocol-alignment", label: "Alignment with GHG Protocol" },
    ],
  },
  {
    heading: "ISO 20400: Sustainable Procurement",
    items: [
      { id: "supplier-criteria", label: "Supplier sustainability criteria" },
      {
        id: "procurement-integration",
        label: "Procurement process integration",
      },
      {
        id: "supply-chain-risk",
        label: "Supply chain environmental and social risk",
      },
      {
        id: "sourcing-policies",
        label: "Sustainable sourcing policies and code of conduct",
      },
      { id: "lifecycle-cost", label: "Lifecycle cost evaluation" },
      {
        id: "supplier-evaluation",
        label: "Supplier evaluation and audit programs",
      },
      { id: "ethical-procurement", label: "Green and ethical procurement" },
      { id: "high-risk-vendors", label: "Engagement with high-risk vendors" },
      {
        id: "procurement-transparency",
        label: "Transparency in procurement decision-making",
      },
      {
        id: "circular-procurement",
        label: "Circular procurement and reuse initiatives",
      },
      {
        id: "tender-sustainability",
        label: "Tender evaluation with sustainability weighting",
      },
      {
        id: "vendor-prequalification",
        label: "Prequalification of vendors based on ESG",
      },
    ],
  },
  {
    heading: "ISO 31000: Risk Management",
    items: [
      {
        id: "risk-identification",
        label: "Risk identification and hazard mapping",
      },
      {
        id: "risk-treatment",
        label: "Risk treatment and mitigation strategies",
      },
      {
        id: "erm-framework",
        label: "Enterprise Risk Management (ERM) framework",
      },
      { id: "risk-appetite", label: "Risk appetite and tolerance thresholds" },
      {
        id: "risk-communication",
        label: "Risk communication and escalation channels",
      },
      {
        id: "kri-monitoring",
        label: "Monitoring and key risk indicators (KRIs)",
      },
      {
        id: "strategic-alignment",
        label: "Strategic and operational risk alignment",
      },
      { id: "residual-risk", label: "Residual risk evaluation" },
      {
        id: "risk-ownership",
        label: "Risk owner assignment and accountability",
      },
      { id: "risk-decision-making", label: "Risk-based decision-making" },
      {
        id: "risk-opportunities",
        label: "Opportunities assessment linked to risk",
      },
      {
        id: "internal-controls",
        label: "Internal control systems linked to risk",
      },
    ],
  },
  {
    heading: "ISO 37001: Anti-Bribery Management",
    items: [
      { id: "abms", label: "Anti-bribery management system (ABMS)" },
      {
        id: "anti-bribery-policy",
        label: "Anti-bribery policies and code of ethics",
      },
      {
        id: "third-party-due-diligence",
        label: "Third-party due diligence process",
      },
      {
        id: "gifts-entertainment-control",
        label: "Gifts, entertainment, and facilitation control",
      },
      {
        id: "whistleblower-policy",
        label: "Internal reporting channels and whistleblower policy",
      },
      {
        id: "bribery-risk-assessment",
        label: "Bribery risk assessment and mitigation",
      },
      {
        id: "disciplinary-actions",
        label: "Disciplinary actions for policy breaches",
      },
      {
        id: "leadership-commitment",
        label: "Leadership and top management commitment",
      },
      {
        id: "anti-bribery-training",
        label: "Training on anti-bribery policies",
      },
      {
        id: "anti-bribery-audits",
        label: "Internal audits and compliance monitoring",
      },
      { id: "anonymous-reporting", label: "Anonymous reporting mechanisms" },
      {
        id: "third-party-certifications",
        label: "Third-party declarations and certifications",
      },
    ],
  },
];
export const OECD_COMPLIANCE_CUSTOMIZATION = [
  {
    heading: "Disclosure",
    items: [
      { id: "sustainability-reports", label: "Sustainability reports" },
      {
        id: "material-information-disclosure",
        label: "Material information disclosure",
      },
      { id: "human-rights-transparency", label: "Human rights transparency" },
      {
        id: "beneficial-ownership-reporting",
        label: "Beneficial ownership reporting",
      },
      {
        id: "climate-financial-disclosures",
        label: "Climate-related financial disclosures",
      },
      {
        id: "sector-specific-disclosure",
        label: "Sector-specific disclosure obligations",
      },
      { id: "due-diligence-transparency", label: "Due diligence transparency" },
      {
        id: "esg-risk-opportunity-reporting",
        label: "ESG risks and opportunity reporting",
      },
    ],
  },
  {
    heading: "Human Rights",
    items: [
      {
        id: "human-rights-due-diligence",
        label: "Human rights due diligence (HRDD)",
      },
      {
        id: "adverse-impacts-identification",
        label: "Identification of adverse impacts",
      },
      { id: "salient-human-rights-risks", label: "Salient human rights risks" },
      {
        id: "grievance-mechanisms",
        label: "Grievance mechanisms (internal & third-party)",
      },
      {
        id: "stakeholder-engagement-remedy",
        label: "Stakeholder engagement and remedy",
      },
      {
        id: "access-to-remedies",
        label: "Access to judicial and non-judicial remedies",
      },
      {
        id: "alignment-un-guiding-principles",
        label:
          "Alignment with UN Guiding Principles on Business and Human Rights",
      },
      {
        id: "vulnerable-group-protections",
        label: "Vulnerable group protections",
      },
      {
        id: "worker-welfare-high-risk",
        label: "Worker welfare in high-risk jurisdictions",
      },
      {
        id: "gender-equality-inclusion",
        label: "Gender equality and inclusion",
      },
      {
        id: "migration-social-protections",
        label: "Migration and social protections",
      },
      {
        id: "youth-ageing-equity-policies",
        label: "Youth, ageing, and equity policies",
      },
      {
        id: "sdgs-human-development",
        label: "Sustainable Development Goals (SDGs) and human development",
      },
      {
        id: "communication-infrastructure-access",
        label: "Communication infrastructure access and online safety",
      },
    ],
  },
  {
    heading: "Employment and Industrial Relations",
    items: [
      { id: "fair-wages-benefits", label: "Fair wages and benefits" },
      { id: "decent-working-conditions", label: "Decent working conditions" },
      {
        id: "working-hours-rest-periods",
        label: "Working hours and rest periods",
      },
      {
        id: "occupational-health-safety",
        label: "Occupational health & safety compliance",
      },
      {
        id: "gender-equality-employment",
        label: "Gender equality in employment",
      },
      {
        id: "freedom-association-bargaining",
        label: "Freedom of association and collective bargaining",
      },
      {
        id: "prevention-child-forced-labor",
        label: "Prevention of child and forced labor",
      },
      {
        id: "migrant-contract-worker-protections",
        label: "Migrant and contract worker protections",
      },
      {
        id: "social-dialogue-labor-consultation",
        label: "Social dialogue and labor consultation",
      },
      {
        id: "ilo-core-labor-standards",
        label: "ILO core labor standards compliance",
      },
      {
        id: "employment-services-local-development",
        label: "Employment services and local employment development",
      },
      { id: "health-work-intersection", label: "Health and work intersection" },
      {
        id: "public-employment-workforce-management",
        label: "Public employment and workforce management",
      },
      {
        id: "job-quality-employability-tracking",
        label: "Job quality metrics and employability tracking",
      },
    ],
  },
  {
    heading: "Environment",
    items: [
      {
        id: "environmental-impact-prevention",
        label: "Environmental impact prevention",
      },
      { id: "sustainable-resource-use", label: "Sustainable resource use" },
      {
        id: "climate-change-mitigation-adaptation",
        label: "Climate change mitigation and adaptation",
      },
      {
        id: "biodiversity-ecosystem-protection",
        label: "Biodiversity and ecosystem protection",
      },
      {
        id: "precautionary-environmental-principle",
        label: "Precautionary environmental principle",
      },
      {
        id: "waste-management-pollution-prevention",
        label: "Waste management and pollution prevention",
      },
      {
        id: "circular-economy-integration",
        label: "Circular economy integration",
      },
      {
        id: "ehs-guidelines-adherence",
        label: "EHS (Environment, Health, Safety) guidelines adherence",
      },
      {
        id: "environmental-performance-reporting",
        label: "Reporting on environmental performance",
      },
      { id: "net-zero-transition", label: "Net-zero transition" },
      {
        id: "green-technology-innovation",
        label: "Green technology and innovation",
      },
      { id: "resource-efficiency", label: "Resource efficiency" },
      {
        id: "environmental-policies-evaluation",
        label: "Environmental policies and evaluation",
      },
      {
        id: "agricultural-sustainability-land-use",
        label: "Agricultural sustainability and land use",
      },
    ],
  },
  {
    heading: "Combating Bribery and Other Forms of Corruption",
    items: [
      {
        id: "anti-bribery-corruption-policy",
        label: "Anti-bribery and corruption policy",
      },
      {
        id: "prohibition-facilitation-payments",
        label: "Prohibition of facilitation payments",
      },
      {
        id: "third-party-due-diligence",
        label: "Third-party due diligence (agents, suppliers)",
      },
      {
        id: "internal-whistleblowing-mechanisms",
        label: "Internal whistleblowing mechanisms",
      },
      {
        id: "ethics-compliance-training",
        label: "Ethics and compliance training",
      },
      {
        id: "political-contributions-transparency",
        label: "Political contributions transparency",
      },
      {
        id: "bribery-incidents-reporting",
        label: "Reporting of bribery incidents and investigations",
      },
      {
        id: "conflict-interest-policy-enforcement",
        label: "Conflict of interest policy enforcement",
      },
      {
        id: "integrity-systems-public-procurement",
        label: "Integrity systems for public procurement",
      },
      {
        id: "anti-corruption-enforcement-initiatives",
        label: "Anti-corruption enforcement and integrity initiatives",
      },
      {
        id: "transparent-policymaking-lobbying-oversight",
        label: "Transparent policymaking and lobbying oversight",
      },
    ],
  },
  {
    heading: "Consumer Interests",
    items: [
      {
        id: "product-safety-labeling-standards",
        label: "Product safety and labeling standards",
      },
      {
        id: "fair-marketing-advertising-practices",
        label: "Fair marketing and advertising practices",
      },
      {
        id: "privacy-personal-data-protection",
        label: "Privacy and personal data protection",
      },
      { id: "digital-consumer-rights", label: "Digital consumer rights" },
      {
        id: "dispute-resolution-complaint-handling",
        label: "Mechanisms for dispute resolution and complaint handling",
      },
      {
        id: "inclusive-access-essential-services",
        label: "Inclusive access to essential services",
      },
      {
        id: "responsible-product-lifecycle-innovation",
        label: "Responsible product lifecycle and innovation",
      },
      {
        id: "ethical-consumer-engagement",
        label: "Ethical consumer engagement",
      },
      {
        id: "ai-usage-digital-trust",
        label: "AI usage and digital trust in services",
      },
      { id: "online-safety-wellbeing", label: "Online safety and well-being" },
    ],
  },
  {
    heading: "Science, Technology and Innovation",
    items: [
      {
        id: "responsible-data-use-cybersecurity",
        label: "Responsible data use and cybersecurity",
      },
      { id: "fair-technology-transfer", label: "Fair technology transfer" },
      {
        id: "support-local-innovation-ecosystems",
        label: "Support for local innovation ecosystems",
      },
      {
        id: "technology-impact-assessments",
        label: "Technology impact assessments",
      },
      {
        id: "ai-ethics-transparency-accountability",
        label: "AI ethics, transparency, and accountability",
      },
      {
        id: "respect-intellectual-property-rights",
        label: "Respect for intellectual property rights",
      },
      { id: "open-innovation-platforms", label: "Open innovation platforms" },
      {
        id: "digital-government-services",
        label: "Digital government services",
      },
      {
        id: "science-policy-sustainable-development",
        label: "Science policy for sustainable development",
      },
    ],
  },
  {
    heading: "Competition",
    items: [
      { id: "antitrust-compliance", label: "Antitrust compliance" },
      { id: "fair-competition-policies", label: "Fair competition policies" },
      {
        id: "avoidance-market-dominance-abuse",
        label: "Avoidance of market dominance abuse",
      },
      {
        id: "prevention-anti-competitive-practices",
        label: "Prevention of anti-competitive practices",
      },
      {
        id: "transparent-tendering-procurement",
        label: "Transparent tendering and procurement practices",
      },
      { id: "non-collusion-commitments", label: "Non-collusion commitments" },
      {
        id: "collaboration-regulators",
        label: "Collaboration with regulators",
      },
      {
        id: "competition-digital-economy",
        label: "Competition in the digital economy",
      },
    ],
  },
  {
    heading: "Taxation",
    items: [
      {
        id: "taxation-note",
        label: "Not included in ESG Compliance Dashboard",
      },
    ],
  },
];
export const TNFD_COMPLIANCE_CUSTOMIZATION = [
  {
    heading: "General",
    items: [
      { id: "general", label: "General" },
      { id: "nature-dependencies", label: "Nature-related dependencies" },
      {
        id: "ecosystem-services",
        label:
          "Ecosystem services (pollination, water purification, climate regulation)",
      },
      { id: "environmental-materiality", label: "Environmental materiality" },
      { id: "nature-financial-risks", label: "Nature-related financial risks" },
      { id: "sector-location-interface", label: "Sector-location interface" },
      {
        id: "nature-opportunities",
        label: "Nature-related opportunities (e.g. restoration markets)",
      },
      {
        id: "double-materiality",
        label: "Double materiality (financial + environmental)",
      },
      { id: "natural-capital", label: "Natural capital" },
      {
        id: "local-global-impacts",
        label: "Local vs global biodiversity impacts",
      },
      {
        id: "enterprise-value-chain-nature",
        label: "Nature in enterprise value chains",
      },
    ],
  },
  {
    heading: "LEAP-Specific",
    items: [
      {
        id: "leap-interface-nature",
        label:
          "Locate: Interface with nature assets (forests, rivers, coral reefs)",
      },
      {
        id: "leap-overlay-protected-areas",
        label:
          "Locate: Overlay with protected areas (Key Biodiversity Areas, Ramsar, IUCN)",
      },
      {
        id: "leap-ecosystem-dependencies",
        label:
          "Evaluate: Ecosystem service dependencies (e.g., soil retention, coastal buffers)",
      },
      {
        id: "leap-impact-drivers",
        label:
          "Evaluate: Impact drivers (GHG emissions, land conversion, water pollution)",
      },
      {
        id: "leap-direct-indirect-impacts",
        label: "Evaluate: Direct and indirect impacts",
      },
      {
        id: "leap-risk-by-activity",
        label: "Assess: Nature risk exposure by business activity",
      },
      {
        id: "leap-materiality-thresholds",
        label: "Assess: Materiality thresholds for nature-related issues",
      },
      {
        id: "leap-physical-transition-risks",
        label: "Assess: physical and transition risks",
      },
      {
        id: "leap-disclosure-tnfd",
        label: "Prepare: Disclosure aligned with TNFD recommendations",
      },
      {
        id: "leap-target-readiness",
        label: "Prepare: Nature-related target setting readiness",
      },
      {
        id: "leap-reporting-package",
        label: "Prepare: LEAP-based reporting package",
      },
    ],
  },
  {
    heading: "Governance",
    items: [
      {
        id: "board-nature-oversight",
        label: "Board oversight of nature risks",
      },
      {
        id: "esg-nature-governance",
        label: "ESG and nature governance integration",
      },
      {
        id: "nature-performance-accountability",
        label: "Accountability for nature performance",
      },
      {
        id: "environmental-internal-controls",
        label: "Internal controls for environmental impacts",
      },
      {
        id: "biodiversity-stakeholder-input",
        label: "Stakeholder input in biodiversity decisions",
      },
      { id: "leap-internal-audit", label: "Internal audit of LEAP process" },
      {
        id: "multi-level-governance",
        label: "Multi-level governance of biodiversity and ecosystem planning",
      },
    ],
  },
  {
    heading: "Strategy",
    items: [
      {
        id: "nature-positive-business",
        label: "Nature-positive business model transformation",
      },
      {
        id: "biodiversity-net-gain",
        label: "Net gain / No Net Loss biodiversity commitments",
      },
      {
        id: "sector-biodiversity-dependencies",
        label:
          "Sector-specific biodiversity dependencies (e.g., agriculture, mining, finance)",
      },
      {
        id: "value-chain-resilience",
        label: "Value chain resilience from ecosystem health",
      },
      {
        id: "adaptation-nature-policy",
        label: "Adaptation to nature-related policies and regulations",
      },
      {
        id: "long-term-nature-risk",
        label: "Long-term strategic exposure to nature-related risks",
      },
    ],
  },
  {
    heading: "Risk & Impact",
    items: [
      {
        id: "physical-nature-risks",
        label: "Physical risks (wildfire, flood, landslide, drought)",
      },
      {
        id: "transition-nature-risks",
        label:
          "Transition risks (deforestation regulations, nature taxes, certification loss)",
      },
      {
        id: "reputational-nature-risks",
        label:
          "Reputational risks (NGO campaigns, ESG ratings, media exposure)",
      },
      {
        id: "systemic-ecosystem-risk",
        label: "Systemic risks (collapse of regional ecosystem services)",
      },
      {
        id: "indigenous-land-rights",
        label: "Risks to indigenous land access and traditional use rights",
      },
      {
        id: "nature-liability-risks",
        label: "Nature liability risks (legal action, compensation)",
      },
      {
        id: "time-horizon-nature-risk",
        label: "Time horizon of nature risk (short / medium / long)",
      },
      {
        id: "interlinked-climate-nature-risk",
        label: "Interlinkage of nature risk with climate risk",
      },
    ],
  },
  {
    heading: "Metrics & Targets",
    items: [
      {
        id: "biodiversity-area-impacted",
        label: "Area of high biodiversity value impacted",
      },
      {
        id: "dependency-adjusted-revenue",
        label: "Dependency-adjusted revenue (% of revenue exposed to nature)",
      },
      {
        id: "water-usage-intensity",
        label: "Water usage intensity (m³ per output unit)",
      },
      {
        id: "biodiversity-net-gain-ratio",
        label: "Biodiversity Net Gain ratio",
      },
      {
        id: "nature-based-solutions",
        label:
          "Nature-based solutions implemented (e.g., reforestation hectares)",
      },
      {
        id: "species-richness-status",
        label: "Species richness or threat status near project sites",
      },
      {
        id: "supply-chain-biodiversity-risk",
        label: "Supply chain biodiversity risk assessment",
      },
    ],
  },
];
export const AA_SERIES_COMPLIANCE_CUSTOMIZATION = [
  {
    heading: "AA1000AP (Accountability Principles)",
    items: [
      { id: "inclusivity", label: "Inclusivity" },
      { id: "stakeholder-inclusiveness", label: "Stakeholder inclusiveness" },
      { id: "stakeholder-diversity", label: "Stakeholder diversity" },
      { id: "broad-stakeholder-input", label: "Broad stakeholder input" },
      { id: "engagement-coverage", label: "Engagement coverage" },
      { id: "stakeholder-relevance", label: "Stakeholder relevance" },
      { id: "materiality-prioritization", label: "Materiality prioritization" },
      { id: "risk-vs-relevance-mapping", label: "Risk vs relevance mapping" },
      {
        id: "issue-materiality-alignment",
        label: "Issue-materiality alignment",
      },
      { id: "responsiveness-tracking", label: "Responsiveness tracking" },
      { id: "feedback-resolution-log", label: "Feedback resolution log" },
      { id: "impact-measurement", label: "Impact measurement" },
      { id: "esg-outcome-tracking", label: "ESG outcome tracking" },
      {
        id: "principles-based-governance",
        label: "Principles-based governance",
      },
    ],
  },
  {
    heading: "AA1000SES (Stakeholder Engagement)",
    items: [
      { id: "stakeholder-mapping", label: "Stakeholder mapping" },
      { id: "stakeholder-identification", label: "Stakeholder identification" },
      { id: "power-interest-grid", label: "Power–interest grid" },
      { id: "stakeholder-segmentation", label: "Stakeholder segmentation" },
      { id: "dialogue-mechanism", label: "Dialogue mechanism" },
      {
        id: "engagement-frequency-depth",
        label: "Engagement frequency and depth",
      },
      { id: "stakeholder-grievance-log", label: "Stakeholder grievance log" },
      {
        id: "concern-registration-tracking",
        label: "Concern registration and tracking",
      },
      {
        id: "marginalized-vulnerable-group-inclusion",
        label: "Marginalized and vulnerable group inclusion",
      },
      {
        id: "indigenous-stakeholder-engagement",
        label: "Indigenous stakeholder engagement",
      },
      {
        id: "underrepresented-stakeholder-outreach",
        label: "Underrepresented stakeholder outreach",
      },
      {
        id: "feedback-integration-decisions",
        label: "Feedback integration into decisions",
      },
      { id: "decision-influence-scoring", label: "Decision influence scoring" },
      {
        id: "multi-channel-engagement",
        label: "Multi-channel engagement (digital, in-person, written)",
      },
    ],
  },
  {
    heading: "AA1000AS (Assurance)",
    items: [
      {
        id: "level-of-assurance-required",
        label: "Level of assurance required",
      },
      { id: "assurance-scope-coverage", label: "Assurance scope and coverage" },
      {
        id: "external-assurance-provider-log",
        label: "External assurance provider log",
      },
      { id: "evidence-trail-kpis", label: "Evidence trail for KPIs" },
      { id: "source-documentation-log", label: "Source documentation log" },
      {
        id: "balanced-transparent-esg-narrative",
        label: "Balanced and transparent ESG narrative",
      },
      {
        id: "esg-narrative-substantiation",
        label: "ESG narrative substantiation",
      },
      {
        id: "auditor-independence-competence",
        label: "Auditor independence and competence",
      },
      {
        id: "materiality-assurance-threshold",
        label: "Materiality assurance threshold",
      },
      { id: "cross-standard-validation", label: "Cross-standard validation" },
      {
        id: "assurance-exclusions-limitations",
        label: "Assurance exclusions or limitations",
      },
    ],
  },
  {
    heading: "AA1000AS – GHG Assurance",
    items: [
      { id: "ghg-inventory-assurance", label: "GHG inventory assurance" },
      {
        id: "scope-1-2-3-boundary-confirmation",
        label: "Scope 1, 2, 3 boundary confirmation",
      },
      {
        id: "ghg-emissions-data-verification",
        label: "GHG emissions data verification",
      },
      {
        id: "carbon-footprint-verification",
        label: "Carbon footprint verification",
      },
      {
        id: "emissions-factor-validation",
        label: "Emissions factor validation",
      },
      { id: "base-year-recalculation", label: "Base year recalculation" },
      { id: "double-counting-review", label: "Double-counting review" },
      { id: "supplier-ghg-data-review", label: "Supplier GHG data review" },
      { id: "offset-inclusion-review", label: "Offset inclusion and review" },
      {
        id: "climate-data-reliability-accuracy",
        label: "Climate data reliability and accuracy",
      },
      {
        id: "ghg-trend-consistency-analysis",
        label: "GHG trend consistency analysis",
      },
      {
        id: "emissions-related-risk-assurance",
        label: "Emissions-related risk assurance",
      },
    ],
  },
];
export const PRI_PRINCIPLE_COMPLIANCE_CUSTOMIZATION = [
  {
    heading: "General PRI Tags",
    items: [
      { id: "responsible-investment", label: "Responsible investment" },
      { id: "esg-integration", label: "ESG integration" },
      { id: "esg-risk-management", label: "ESG risk management" },
      {
        id: "sustainable-finance-disclosure",
        label: "Sustainable finance disclosure",
      },
      { id: "impact-measurement", label: "Impact measurement" },
      { id: "stewardship-duty", label: "Stewardship and fiduciary duty" },
      { id: "pri-transparency-reporting", label: "PRI transparency reporting" },
      { id: "net-zero-strategies", label: "Net-zero investment strategies" },
      { id: "esg-due-diligence", label: "ESG due diligence" },
      { id: "sdg-aligned-investing", label: "SDG-aligned investing" },
      { id: "climate-social-alignment", label: "Climate and social alignment" },
    ],
  },
  {
    heading: "Principle 1 – ESG Integration into Investment Decisions",
    items: [
      { id: "esg-data-analysis", label: "ESG data in investment analysis" },
      { id: "esg-integrated-portfolios", label: "ESG-integrated portfolios" },
      {
        id: "responsible-asset-allocation",
        label: "Responsible asset allocation",
      },
      { id: "esg-screening", label: "ESG screening (positive / negative)" },
      { id: "esg-financial-modeling", label: "ESG in financial modeling" },
      {
        id: "exclusion-policies",
        label: "Exclusion policies (fossil fuels, weapons, etc.)",
      },
      { id: "esg-benchmark", label: "ESG benchmark adoption" },
      { id: "esg-materiality-assessment", label: "ESG materiality assessment" },
      {
        id: "sector-esg-risk-mapping",
        label: "Sector-specific ESG risk mapping",
      },
    ],
  },
  {
    heading: "Principle 2 – Active Ownership",
    items: [
      {
        id: "shareholder-engagement",
        label: "Shareholder engagement strategy",
      },
      {
        id: "corporate-esg-dialogue",
        label: "Corporate ESG dialogue tracking",
      },
      { id: "stewardship-policy", label: "Stewardship policy disclosed" },
      { id: "engagement-case-studies", label: "Engagement case studies" },
      {
        id: "shareholder-resolution-tracking",
        label: "Shareholder resolution tracking",
      },
      { id: "esg-vote-alignment", label: "ESG vote alignment evidence" },
      { id: "engagement-outcomes", label: "Engagement outcomes recorded" },
      {
        id: "company-responsiveness",
        label: "Company responsiveness monitored",
      },
      {
        id: "long-term-investor-duty",
        label: "Long-term investor responsibility",
      },
    ],
  },
  {
    heading: "Principle 3 – ESG Disclosure Advocacy",
    items: [
      {
        id: "esg-reporting-requests",
        label: "ESG reporting requests to investees",
      },
      {
        id: "sustainability-report-monitoring",
        label: "Corporate sustainability report monitoring",
      },
      {
        id: "esg-framework-use",
        label: "Use of relevant and applicable ESG frameworks",
      },
      {
        id: "sector-transparency-campaigns",
        label: "Sector transparency campaigns",
      },
      {
        id: "reporting-standard-tracking",
        label: "Reporting standard adoption tracking",
      },
      { id: "supply-chain-disclosure", label: "Supply chain ESG disclosure" },
      { id: "esg-data-accessibility", label: "ESG data accessibility review" },
      {
        id: "company-disclosure-engagement",
        label: "Company feedback and disclosure engagement",
      },
      {
        id: "private-market-disclosure",
        label: "Private market disclosure practices",
      },
    ],
  },
  {
    heading: "Principle 4 – Promote PRI & ESG Practices",
    items: [
      { id: "esg-education-efforts", label: "ESG education efforts" },
      { id: "investor-esg-training", label: "Investor ESG training sessions" },
      {
        id: "esg-thought-leadership",
        label: "ESG thought leadership activities",
      },
      {
        id: "public-esg-endorsements",
        label: "Public endorsements of ESG practices",
      },
      {
        id: "esg-conference-participation",
        label: "ESG conference participation",
      },
      { id: "working-group-involvement", label: "Working group involvement" },
      { id: "pri-case-sharing", label: "Case sharing of PRI integration" },
      { id: "peer-network-contribution", label: "Peer network contribution" },
      { id: "esg-awareness-initiatives", label: "ESG awareness initiatives" },
    ],
  },
  {
    heading: "Principle 5 – Collaboration for Impact",
    items: [
      {
        id: "collective-investor-action",
        label: "Collective investor action initiatives",
      },
      { id: "collaborative-engagements", label: "Collaborative engagements" },
      {
        id: "global-investor-network",
        label: "Global investor network membership",
      },
      { id: "esg-campaign-participation", label: "ESG campaign participation" },
      {
        id: "investor-coalition-contributions",
        label: "Investor coalition contributions",
      },
      {
        id: "joint-shareholder-statements",
        label: "Joint shareholder statements",
      },
      {
        id: "stewardship-platform",
        label: "Stewardship platform participation",
      },
      {
        id: "shared-risk-assessments",
        label: "Shared risk/opportunity assessments",
      },
    ],
  },
  {
    heading: "Principle 6 – Reporting Progress",
    items: [
      { id: "pri-transparency-filed", label: "PRI transparency report filed" },
      {
        id: "pri-indicator-evaluation",
        label: "PRI indicator coverage evaluated",
      },
      { id: "annual-esg-disclosure", label: "Annual ESG disclosure published" },
      {
        id: "esg-performance-tracking",
        label: "ESG performance indicators tracked",
      },
      { id: "esg-progress-by-portfolio", label: "ESG progress by portfolio" },
      {
        id: "implementation-case-studies",
        label: "Implementation case studies shared",
      },
      { id: "esg-target-tracking", label: "ESG target tracking system" },
      {
        id: "third-party-esg-assurance",
        label: "ESG assurance by third-party audit",
      },
      {
        id: "esg-verification-in-reporting",
        label: "ESG verification in reporting",
      },
    ],
  },
  {
    heading: "Principle 7 – SDG & Just Transition (Addendum)",
    items: [
      { id: "sdg-mapping-investments", label: "SDG mapping of investments" },
      {
        id: "sdg-aligned-impact-investing",
        label: "Impact investing aligned with SDGs",
      },
      {
        id: "climate-justice-strategies",
        label: "Climate justice-focused strategies",
      },
      {
        id: "just-transition-financing",
        label: "Just transition financing tools",
      },
      {
        id: "social-environmental-tracking",
        label: "Social and environmental benefit tracking",
      },
      {
        id: "human-rights-integration",
        label: "Human rights integration in finance",
      },
      {
        id: "local-community-investing",
        label: "Local and community-based investing",
      },
      {
        id: "inclusive-green-finance",
        label: "Inclusive green finance policies",
      },
      {
        id: "indigenous-esg-practices",
        label: "Indigenous ESG investment practices",
      },
      {
        id: "equitable-esg-monitoring",
        label: "Equitable ESG outcomes monitored",
      },
    ],
  },
];
export const PRI_PRINCIPLE_AI_DRIVEN_CUSTOM_FORM = {
  title: "Download PRI Principles AI-Driven Compliance Form",
  downloadFileName: "PRI_Principles_AI_Driven_Compliance_Form",
  downloadFileExtension: "png",
  // formImageUrl: EsgImg,

  sections: [
    {
      id: "PRI_PRINCIPLE_COMPLIANCE_CUSTOMIZATION-1", title: "Section 1: Organization Details",
      fields: [
        { label: "Company Name", type: "text" },
        { label: "Industry / Sector", type: "text" },
        { label: "Countries of Investment / Operation", type: "text" },
        { label: "Reporting Period (e.g., Jan 2024 – Dec 2024)", type: "text" },
        { label: "Contact Person (Name & Title)", type: "text" },
        { label: "Email & Phone (for follow-up)", type: "text" },
        {
          label:
            "✅ This ensures your PRI compliance outputs are tailored to your organization's profile.",
          type: "note",
        },
      ],
    },

    {
      id: "PRI_PRINCIPLE_COMPLIANCE_CUSTOMIZATION-2", title: "Section 2: Upload General Supporting Materials",
      description:
        "✅ Please upload available documents — they do not need to be highly technical or pre-organized. The system will sort and analyze them to generate the reports below.",
      fields: [
        {
          label: "⬆ Upload any or all of the following (if available):",
          type: "header",
        },
        {
          label: "Responsible Investment Policies or ESG Integration Policies",
          type: "file",
        },
        { label: "Portfolio ESG Risk Assessment Summaries", type: "file" },
        {
          label: "Active Ownership or Shareholder Engagement Records",
          type: "file",
        },
        {
          label: "ESG Screening Criteria or Sector Exclusion Lists",
          type: "file",
        },
        { label: "ESG Voting and Resolution Tracking Logs", type: "file" },
        {
          label: "ESG Disclosure and Reporting Requests to Investee Companies",
          type: "file",
        },
        {
          label: "ESG Stewardship Reports or Investor Education Materials",
          type: "file",
        },
        {
          label: "Investor Collaboration or Coalition Participation Records",
          type: "file",
        },
        {
          label: "Annual PRI Transparency Reports (if applicable)",
          type: "file",
        },
        { label: "ESG Impact or SDG Mapping Summaries", type: "file" },
        {
          label: "Climate-Aligned or Net-Zero Investment Strategies",
          type: "file",
        },
        { label: "Internal ESG Monitoring Tools or Dashboards", type: "file" },
        { label: "ESG Assurance or Third-Party Audit Findings", type: "file" },
        {
          label: "Portfolio-Level ESG Metrics and Progress Trackers",
          type: "file",
        },
        {
          label:
            "Any Other ESG-Related Documents, Reports, or Framework Summaries",
          type: "file",
        },
        {
          label:
            "👉 Note: Uploading broad, general files is perfectly acceptable — the system will extract the necessary elements to align with each PRI principle.",
          type: "note",
        },
      ],
    },

    {
      id: "PRI_PRINCIPLE_COMPLIANCE_CUSTOMIZATION-3", title: "Section 3: Confirm PRI Principles and System-Generated Reports",
      description:
        "✅ Based on your uploaded materials and selected focus areas, the system will generate:",
      fields: [
        {
          label: "General PRI Reports",
          type: "checkbox",
          options: [
            "Full PRI Compliance Report",
            "PRI Transparency Report",
            "ESG Integration Practices Report",
            "ESG Disclosure Advocacy Report",
          ],
        },
        {
          label: "Active Ownership & Collaboration Reports",
          type: "checkbox",
          options: [
            "Active Ownership & Engagement Report",
            "Collaborative Engagement Readiness Assessment",
            "ESG Voting and Resolution Tracking Summary",
          ],
        },
        {
          label: "Performance & Progress Reports",
          type: "checkbox",
          options: [
            "ESG Target Monitoring Report",
            "ESG Materiality Assessment for Investment Strategy",
            "ESG Disclosure Advocacy Report",
            "SDG-Aligned Investment Report",
            "Net-Zero and Climate-Aligned Investment Report",
            "Transition & Social Investment Report",
            "PRI Reporting Progress Tracker",
          ],
        },
        {
          label: "Maturity & Gap Assessments",
          type: "checkbox",
          options: [
            "PRI Principle-by-Principle Maturity Assessment",
            "Responsible Investment Readiness Assessment",
            "Gap Assessment on PRI Compliances",
            "Portfolio ESG Exposure Analysis",
            "PRI Crosswalk Analysis",
          ],
        },
      ],
    },
  ],
};
export const Annexure_3 = [
  {
    heading: "SDG Goal 1: No Poverty",
    items: [
      { id: "sdg1-1", label: "Target 1.1 – Eradicate extreme poverty" },
      { id: "sdg1-2", label: "Target 1.2 – Reduce poverty by half" },
      {
        id: "sdg1-3",
        label: "Target 1.3 – Implement social protection systems",
      },
      {
        id: "sdg1-4",
        label:
          "Target 1.4 – Ensure equal rights to economic resources and basic services",
      },
      {
        id: "sdg1-5",
        label: "Target 1.5 – Build resilience to climate and economic shocks",
      },
      { id: "sdg1-a", label: "Target 1.a – Mobilize resources to end poverty" },
      {
        id: "sdg1-b",
        label:
          "Target 1.b – Create pro-poor and gender-sensitive policy frameworks",
      },
    ],
  },
  {
    heading: "SDG Goal 2: Zero Hunger",
    items: [
      {
        id: "sdg2-1",
        label:
          "Target 2.1 – End hunger and ensure access to safe, nutritious food",
      },
      { id: "sdg2-2", label: "Target 2.2 – End all forms of malnutrition" },
      {
        id: "sdg2-3",
        label:
          "Target 2.3 – Double agricultural productivity and incomes of small-scale producers",
      },
      {
        id: "sdg2-4",
        label: "Target 2.4 – Ensure sustainable food production systems",
      },
      {
        id: "sdg2-5",
        label:
          "Target 2.5 – Maintain genetic diversity of seeds, plants, and animals",
      },
      {
        id: "sdg2-a",
        label:
          "Target 2.a – Increase investment in agriculture and rural infrastructure",
      },
      {
        id: "sdg2-b",
        label:
          "Target 2.b – Correct and prevent trade restrictions and distortions",
      },
      {
        id: "sdg2-c",
        label:
          "Target 2.c – Ensure proper functioning of food commodity markets",
      },
    ],
  },
  {
    heading: "SDG Goal 3: Good Health and Well-being",
    items: [
      { id: "sdg3-1", label: "Target 3.1 – Reduce maternal mortality" },
      {
        id: "sdg3-2",
        label:
          "Target 3.2 – End preventable deaths of newborns and children under 5",
      },
      {
        id: "sdg3-3",
        label:
          "Target 3.3 – End epidemics of AIDS, tuberculosis, malaria, and other communicable diseases",
      },
      {
        id: "sdg3-4",
        label:
          "Target 3.4 – Reduce one third mortality from non-communicable diseases and promote mental health",
      },
      { id: "sdg3-5", label: "Target 3.5 – Prevent and treat substance abuse" },
      {
        id: "sdg3-6",
        label: "Target 3.6 – Halve road traffic deaths and injuries",
      },
      {
        id: "sdg3-7",
        label:
          "Target 3.7 – Ensure access to sexual and reproductive health care",
      },
      { id: "sdg3-8", label: "Target 3.8 – Achieve universal health coverage" },
      {
        id: "sdg3-9",
        label:
          "Target 3.9 – Reduce deaths from hazardous chemicals and pollution",
      },
      {
        id: "sdg3-a",
        label:
          "Target 3.a – Implement the WHO Framework Convention on Tobacco Control",
      },
      {
        id: "sdg3-b",
        label:
          "Target 3.b – Support research and development of vaccines and medicines",
      },
      {
        id: "sdg3-c",
        label:
          "Target 3.c – Increase health financing and health workforce development",
      },
      {
        id: "sdg3-d",
        label:
          "Target 3.d – Strengthen capacity for early warning and risk reduction",
      },
    ],
  },
  {
    heading: "SDG Goal 4: Quality Education",
    items: [
      {
        id: "sdg4-1",
        label:
          "Target 4.1 – Ensure completion of primary and secondary education",
      },
      {
        id: "sdg4-2",
        label:
          "Target 4.2 – Ensure access to early childhood development and pre-primary education",
      },
      {
        id: "sdg4-3",
        label:
          "Target 4.3 – Ensure equal access to technical, vocational, and tertiary education",
      },
      {
        id: "sdg4-4",
        label:
          "Target 4.4 – Increase skills for employment and entrepreneurship",
      },
      {
        id: "sdg4-5",
        label: "Target 4.5 – Eliminate gender disparities in education",
      },
      {
        id: "sdg4-6",
        label:
          "Target 4.6 – Ensure youth and adults achieve literacy and numeracy",
      },
      {
        id: "sdg4-7",
        label:
          "Target 4.7 – Ensure learners acquire knowledge for sustainable development",
      },
      {
        id: "sdg4-a",
        label:
          "Target 4.a – Build and upgrade inclusive and safe education facilities",
      },
      {
        id: "sdg4-b",
        label: "Target 4.b – Expand scholarships for developing countries",
      },
      {
        id: "sdg4-c",
        label: "Target 4.c – Increase the supply of qualified teachers",
      },
    ],
  },
  {
    heading: "SDG Goal 5: Gender Equality",
    items: [
      {
        id: "sdg5-1",
        label:
          "Target 5.1 – End all forms of discrimination against women and girls",
      },
      {
        id: "sdg5-2",
        label: "Target 5.2 – Eliminate violence against women and girls",
      },
      {
        id: "sdg5-3",
        label:
          "Target 5.3 – Eliminate harmful practices (e.g., child, early, and forced marriage)",
      },
      {
        id: "sdg5-4",
        label: "Target 5.4 – Recognize and value unpaid care and domestic work",
      },
      {
        id: "sdg5-5",
        label:
          "Target 5.5 – Ensure full participation and equal leadership opportunities",
      },
      {
        id: "sdg5-6",
        label:
          "Target 5.6 – Ensure universal access to sexual and reproductive health and rights",
      },
      {
        id: "sdg5-a",
        label:
          "Target 5.a – Ensure equal rights to economic resources and property",
      },
      {
        id: "sdg5-b",
        label:
          "Target 5.b – Enhance the use of enabling technology to empower women",
      },
      {
        id: "sdg5-c",
        label:
          "Target 5.c – Adopt and strengthen gender equality policies and enforceable legislation",
      },
    ],
  },
  {
    heading: "SDG Goal 6: Clean Water and Sanitation",
    items: [
      {
        id: "sdg6-1",
        label:
          "Target 6.1 – Achieve universal and equitable access to safe and affordable drinking water",
      },
      {
        id: "sdg6-2",
        label:
          "Target 6.2 – Achieve access to adequate and equitable sanitation and hygiene",
      },
      {
        id: "sdg6-3",
        label:
          "Target 6.3 – Improve water quality by reducing pollution and minimizing release of hazardous chemicals",
      },
      {
        id: "sdg6-4",
        label:
          "Target 6.4 – Increase water-use efficiency and ensure sustainable withdrawals",
      },
      {
        id: "sdg6-5",
        label: "Target 6.5 – Implement integrated water resources management",
      },
      {
        id: "sdg6-6",
        label: "Target 6.6 – Protect and restore water-related ecosystems",
      },
      {
        id: "sdg6-a",
        label:
          "Target 6.a – Expand international cooperation for water and sanitation-related activities",
      },
      {
        id: "sdg6-b",
        label:
          "Target 6.b – Support participation of local communities in water and sanitation management",
      },
    ],
  },
  {
    heading: "SDG Goal 7: Affordable and Clean Energy",
    items: [
      {
        id: "sdg7-1",
        label:
          "Target 7.1 – Ensure universal access to affordable, reliable, and modern energy services",
      },
      {
        id: "sdg7-2",
        label:
          "Target 7.2 – Increase the share of renewable energy in the global energy mix",
      },
      {
        id: "sdg7-3",
        label:
          "Target 7.3 – Double the global rate of improvement in energy efficiency",
      },
      {
        id: "sdg7-a",
        label:
          "Target 7.a – Enhance international cooperation to facilitate access to clean energy research and technology",
      },
      {
        id: "sdg7-b",
        label:
          "Target 7.b – Expand infrastructure and upgrade technology for supplying modern and sustainable energy",
      },
    ],
  },
  {
    heading: "SDG Goal 8: Decent Work and Economic Growth",
    items: [
      {
        id: "sdg8-1",
        label: "Target 8.1 – Sustain per capita economic growth",
      },
      {
        id: "sdg8-2",
        label: "Target 8.2 – Achieve higher levels of economic productivity",
      },
      {
        id: "sdg8-3",
        label:
          "Target 8.3 – Promote development-oriented policies for productive employment",
      },
      {
        id: "sdg8-4",
        label:
          "Target 8.4 – Improve resource efficiency and decouple economic growth from environmental degradation",
      },
      {
        id: "sdg8-5",
        label:
          "Target 8.5 – Achieve full and productive employment and equal pay for work of equal value",
      },
      {
        id: "sdg8-6",
        label:
          "Target 8.6 – Substantially reduce the proportion of youth not in employment, education, or training",
      },
      {
        id: "sdg8-7",
        label:
          "Target 8.7 – Eradicate forced labour, end modern slavery and human trafficking, and eliminate child labour",
      },
      {
        id: "sdg8-8",
        label:
          "Target 8.8 – Protect labour rights and promote safe and secure working environments",
      },
      {
        id: "sdg8-9",
        label:
          "Target 8.9 – Promote sustainable tourism that creates jobs and promotes local culture and products",
      },
      {
        id: "sdg8-10",
        label:
          "Target 8.10 – Strengthen the capacity of domestic financial institutions to encourage access to banking, insurance, and financial services",
      },
      {
        id: "sdg8-a",
        label:
          "Target 8.a – Increase Aid for Trade support for developing countries",
      },
      {
        id: "sdg8-b",
        label:
          "Target 8.b – Develop and operationalize a global strategy for youth employment",
      },
    ],
  },
  {
    heading: "SDG Goal 9: Industry, Innovation and Infrastructure",
    items: [
      {
        id: "sdg9-1",
        label:
          "Target 9.1 – Develop quality, reliable, sustainable, and resilient infrastructure",
      },
      {
        id: "sdg9-2",
        label:
          "Target 9.2 – Promote inclusive and sustainable industrialization",
      },
      {
        id: "sdg9-3",
        label:
          "Target 9.3 – Increase the access of small-scale industries to financial services and integration into value chains",
      },
      {
        id: "sdg9-4",
        label:
          "Target 9.4 – Upgrade infrastructure and retrofit industries to make them sustainable",
      },
      {
        id: "sdg9-5",
        label:
          "Target 9.5 – Enhance scientific research and upgrade technological capabilities of industrial sectors",
      },
      {
        id: "sdg9-a",
        label:
          "Target 9.a – Facilitate sustainable and resilient infrastructure development in developing countries",
      },
      {
        id: "sdg9-b",
        label:
          "Target 9.b – Support domestic technology development, research, and innovation",
      },
      {
        id: "sdg9-c",
        label:
          "Target 9.c – Significantly increase access to information and communications technology",
      },
    ],
  },
  {
    heading: "SDG Goal 10: Reduced Inequalities",
    items: [
      { id: "sdg10-1", label: "Target 10.1 – Reduce income inequality" },
      {
        id: "sdg10-2",
        label: "Target 10.2 – Promote social, economic and political inclusion",
      },
      {
        id: "sdg10-3",
        label:
          "Target 10.3 – Ensure equal opportunity and reduce outcome inequalities",
      },
      {
        id: "sdg10-4",
        label: "Target 10.4 – Adopt policies for greater equality",
      },
      {
        id: "sdg10-5",
        label:
          "Target 10.5 – Improve regulation and monitoring of global financial markets and institutions",
      },
      {
        id: "sdg10-6",
        label:
          "Target 10.6 – Enhance representation for developing countries in decision-making in global institutions",
      },
      {
        id: "sdg10-7",
        label:
          "Target 10.7 – Facilitate safe, regular and responsible migration and mobility",
      },
      {
        id: "sdg10-a",
        label:
          "Target 10.a – Implement special and differential treatment for developing countries",
      },
      {
        id: "sdg10-b",
        label:
          "Target 10.b – Encourage official development assistance and financial flows to states most in need",
      },
      {
        id: "sdg10-c",
        label:
          "Target 10.c – Reduce the transaction costs of migrant remittances",
      },
    ],
  },
  {
    heading: "SDG Goal 11: Sustainable Cities and Communities",
    items: [
      {
        id: "sdg11-1",
        label:
          "Target 11.1 – Ensure access to adequate, safe and affordable housing",
      },
      {
        id: "sdg11-2",
        label:
          "Target 11.2 – Provide access to safe, affordable, accessible and sustainable transport systems",
      },
      {
        id: "sdg11-3",
        label:
          "Target 11.3 – Enhance inclusive and sustainable urbanization and participatory planning",
      },
      {
        id: "sdg11-4",
        label:
          "Target 11.4 – Strengthen efforts to protect the world’s cultural and natural heritage",
      },
      {
        id: "sdg11-5",
        label:
          "Target 11.5 – Reduce the number of people affected by disasters",
      },
      {
        id: "sdg11-6",
        label:
          "Target 11.6 – Reduce environmental impact of cities, including air quality and waste management",
      },
      {
        id: "sdg11-7",
        label:
          "Target 11.7 – Provide universal access to safe, inclusive and accessible green and public spaces",
      },
      {
        id: "sdg11-a",
        label:
          "Target 11.a – Support positive economic, social and environmental links between urban, peri-urban and rural areas",
      },
      {
        id: "sdg11-b",
        label:
          "Target 11.b – Increase the number of cities implementing integrated policies for inclusion, resource efficiency and climate change resilience",
      },
      {
        id: "sdg11-c",
        label:
          "Target 11.c – Support least developed countries in building sustainable and resilient buildings",
      },
    ],
  },
  {
    heading: "SDG Goal 12: Responsible Consumption and Production",
    items: [
      {
        id: "sdg12-1",
        label:
          "Target 12.1 – Implement the 10-Year Framework of Programmes on sustainable consumption and production",
      },
      {
        id: "sdg12-2",
        label:
          "Target 12.2 – Achieve sustainable management and efficient use of natural resources",
      },
      {
        id: "sdg12-3",
        label: "Target 12.3 – Halve per capita global food waste",
      },
      {
        id: "sdg12-4",
        label:
          "Target 12.4 – Ensure environmentally sound management of chemicals and waste",
      },
      {
        id: "sdg12-5",
        label:
          "Target 12.5 – Substantially reduce waste generation through prevention, reduction, recycling, and reuse",
      },
      {
        id: "sdg12-6",
        label:
          "Target 12.6 – Encourage companies to adopt sustainable practices and sustainability reporting",
      },
      {
        id: "sdg12-7",
        label: "Target 12.7 – Promote sustainable public procurement practices",
      },
      {
        id: "sdg12-8",
        label:
          "Target 12.8 – Ensure that people everywhere have relevant information for sustainable development",
      },
      {
        id: "sdg12-a",
        label:
          "Target 12.a – Support developing countries to strengthen their scientific and technological capacity",
      },
      {
        id: "sdg12-b",
        label:
          "Target 12.b – Develop tools to monitor sustainable development impacts for sustainable tourism",
      },
      {
        id: "sdg12-c",
        label: "Target 12.c – Rationalize inefficient fossil-fuel subsidies",
      },
    ],
  },
  {
    heading: "SDG Goal 13: Climate Action",
    items: [
      {
        id: "sdg13-1",
        label:
          "Target 13.1 – Strengthen resilience and adaptive capacity to climate-related hazards and natural disasters",
      },
      {
        id: "sdg13-2",
        label:
          "Target 13.2 – Integrate climate change measures into national policies, strategies, and planning",
      },
      {
        id: "sdg13-3",
        label:
          "Target 13.3 – Improve education, awareness, and human and institutional capacity on climate change mitigation, adaptation, impact reduction, and early warning",
      },
      {
        id: "sdg13-a",
        label:
          "Target 13.a – Implement the commitment to mobilize $100 billion annually to support developing countries in climate action",
      },
      {
        id: "sdg13-b",
        label:
          "Target 13.b – Promote mechanisms to raise capacity for effective climate change-related planning and management in least developed countries and small island developing States",
      },
    ],
  },
  {
    heading: "SDG Goal 14: Life Below Water",
    items: [
      { id: "sdg14-1", label: "Target 14.1 – Reduce marine pollution" },
      {
        id: "sdg14-2",
        label:
          "Target 14.2 – Sustainably manage and protect marine and coastal ecosystems",
      },
      {
        id: "sdg14-3",
        label: "Target 14.3 – Minimize and address ocean acidification",
      },
      {
        id: "sdg14-4",
        label: "Target 14.4 – Regulate harvesting and end overfishing",
      },
      {
        id: "sdg14-5",
        label:
          "Target 14.5 – Conserve at least 10% of coastal and marine areas",
      },
      {
        id: "sdg14-6",
        label: "Target 14.6 – Prohibit certain forms of fisheries subsidies",
      },
      {
        id: "sdg14-7",
        label:
          "Target 14.7 – Increase the economic benefits from sustainable use of marine resources",
      },
      {
        id: "sdg14-a",
        label:
          "Target 14.a – Increase scientific knowledge, research and technology for ocean health",
      },
      {
        id: "sdg14-b",
        label:
          "Target 14.b – Provide access for small-scale artisanal fishers to marine resources and markets",
      },
      {
        id: "sdg14-c",
        label:
          "Target 14.c – Enhance conservation and sustainable use of oceans through international law",
      },
    ],
  },
  {
    heading: "SDG Goal 15: Life on Land",
    items: [
      {
        id: "sdg15-1",
        label:
          "Target 15.1 – Ensure conservation of terrestrial and inland freshwater ecosystems",
      },
      {
        id: "sdg15-2",
        label:
          "Target 15.2 – Promote sustainable management of forests and reforestation",
      },
      {
        id: "sdg15-3",
        label: "Target 15.3 – Combat desertification and restore degraded land",
      },
      {
        id: "sdg15-4",
        label: "Target 15.4 – Ensure conservation of mountain ecosystems",
      },
      {
        id: "sdg15-5",
        label:
          "Target 15.5 – Take urgent action to reduce degradation of natural habitats and halt biodiversity loss",
      },
      {
        id: "sdg15-6",
        label:
          "Target 15.6 – Promote fair and equitable sharing of genetic resources",
      },
      {
        id: "sdg15-7",
        label:
          "Target 15.7 – End poaching and trafficking of protected species",
      },
      {
        id: "sdg15-8",
        label:
          "Target 15.8 – Prevent the introduction of invasive alien species",
      },
      {
        id: "sdg15-9",
        label:
          "Target 15.9 – Integrate ecosystem and biodiversity values into national and local planning",
      },
      {
        id: "sdg15-a",
        label:
          "Target 15.a – Mobilize resources to finance sustainable forest management",
      },
      {
        id: "sdg15-b",
        label:
          "Target 15.b – Mobilize funding to conserve and sustainably use biodiversity and ecosystems",
      },
      {
        id: "sdg15-c",
        label:
          "Target 15.c – Enhance global support for combating poaching and trafficking of protected species",
      },
    ],
  },
  {
    heading: null,
    items: [
      {
        id: "sdg16-1",
        label:
          "Target 16.1 – Reduce all forms of violence and related death rates",
      },
      {
        id: "sdg16-2",
        label:
          "Target 16.2 – End abuse, exploitation, trafficking and all forms of violence against children",
      },
      {
        id: "sdg16-3",
        label:
          "Target 16.3 – Promote the rule of law and ensure equal access to justice",
      },
      {
        id: "sdg16-4",
        label: "Target 16.4 – Reduce illicit financial and arms flows",
      },
      {
        id: "sdg16-5",
        label: "Target 16.5 – Substantially reduce corruption and bribery",
      },
      {
        id: "sdg16-6",
        label:
          "Target 16.6 – Develop effective, accountable and transparent institutions",
      },
      {
        id: "sdg16-7",
        label:
          "Target 16.7 – Ensure responsive, inclusive and representative decision-making",
      },
      {
        id: "sdg16-8",
        label:
          "Target 16.8 – Broaden and strengthen participation of developing countries in global governance",
      },
      {
        id: "sdg16-9",
        label:
          "Target 16.9 – Provide legal identity for all, including birth registration",
      },
      {
        id: "sdg16-10",
        label:
          "Target 16.10 – Ensure public access to information and protect fundamental freedoms",
      },
      {
        id: "sdg16-a",
        label:
          "Target 16.a – Strengthen institutions to prevent violence and combat crime and terrorism",
      },
      {
        id: "sdg16-b",
        label:
          "Target 16.b – Promote and enforce non-discriminatory laws and policies",
      },
      {
        id: "sdg17-1",
        label: "Target 17.1 – Strengthen domestic resource mobilization",
      },
      {
        id: "sdg17-2",
        label: "Target 17.2 – Implement all development assistance commitments",
      },
      {
        id: "sdg17-3",
        label:
          "Target 17.3 – Mobilize additional financial resources for developing countries",
      },
      {
        id: "sdg17-4",
        label:
          "Target 17.4 – Assist in attaining long-term debt sustainability",
      },
      {
        id: "sdg17-5",
        label:
          "Target 17.5 – Adopt investment promotion regimes for least developed countries",
      },
      {
        id: "sdg17-6",
        label:
          "Target 17.6 – Enhance cooperation on science, technology, and innovation",
      },
      {
        id: "sdg17-7",
        label:
          "Target 17.7 – Promote development and transfer of environmentally sound technologies",
      },
      {
        id: "sdg17-8",
        label:
          "Target 17.8 – Fully operationalize the technology bank for least developed countries",
      },
      {
        id: "sdg17-9",
        label:
          "Target 17.9 – Enhance international support for implementing capacity-building",
      },
      {
        id: "sdg17-10",
        label:
          "Target 17.10 – Promote a universal, rules-based, open and equitable trading system",
      },
      {
        id: "sdg17-11",
        label:
          "Target 17.11 – Significantly increase exports of developing countries",
      },
      {
        id: "sdg17-12",
        label:
          "Target 17.12 – Realize timely implementation of duty-free and quota-free market access",
      },
      {
        id: "sdg17-13",
        label: "Target 17.13 – Enhance global macroeconomic stability",
      },
      {
        id: "sdg17-14",
        label:
          "Target 17.14 – Enhance policy coherence for sustainable development",
      },
      {
        id: "sdg17-15",
        label:
          "Target 17.15 – Respect each country’s policy space for poverty eradication",
      },
      {
        id: "sdg17-16",
        label:
          "Target 17.16 – Enhance global partnerships for sustainable development",
      },
      {
        id: "sdg17-17",
        label:
          "Target 17.17 – Encourage effective public, public-private and civil society partnerships",
      },
      {
        id: "sdg17-18",
        label:
          "Target 17.18 – Enhance capacity-building to increase availability of high-quality, timely data",
      },
      {
        id: "sdg17-19",
        label:
          "Target 17.19 – Build on existing initiatives to develop sustainable development indicators",
      },
    ],
  },
];
export const EMISSION_METHODOLOGY_CHECKLIST = [
  {
    heading: "Select Emission Factors and Methodology",
    items: [
      { id: "note-methodology", label: "Click: “Select Calculation Method”" },
      {
        id: "checkbox-ghg-protocol",
        label: "GHG Protocol: CARS, Project Accounting, Product Life Cycle",
      },
      { id: "checkbox-iso-14064", label: "ISO 14064-compatible calculation" },
      {
        id: "checkbox-afolu",
        label: "AFOLU Sector Guidance (for agri/land use companies)",
      },
      {
        id: "checkbox-canadian-ghgrp",
        label: "🌏 APAC MRV & GHG Systems (Singapore Carbon Pricing, Malaysia Bursa, Indonesia IDXCarbon)",
      },
    ],
  },
  {
    heading: "Scope 4 (Avoided Emissions) Estimator",
    items: [
      { id: "note-scope4", label: "Click: “Add Avoided Emissions Scenario”" },
      {
        id: "checkbox-ghg-savings-renewables",
        label: "Simulate GHG savings by switching to renewables",
      },
      {
        id: "checkbox-efficiency-upgrades",
        label: "Estimate reduction from energy efficiency upgrades",
      },
      {
        id: "checkbox-circular-economy",
        label: "Calculate circular economy impacts (reuse, recycling)",
      },
    ],
  },
];
export const CLIMATE_IMPACT_STANDARDS = [
  {
    id: "checkbox-risk-vulnerability",
    type: "checkbox",
    label: "Climate Risk and Vulnerability Assessment",
  },
  {
    id: "checkbox-ghg-inventory",
    type: "checkbox",
    label: "GHG Emissions Inventory (Scope 1, 2, 3)",
  },
  {
    id: "checkbox-physical-risk-profile",
    type: "checkbox",
    label: "Physical Climate Risk Profile",
  },
  {
    id: "checkbox-transition-risk",
    type: "checkbox",
    label: "Transition Risk Exposure Assessment",
  },
  {
    id: "checkbox-climate-resilience",
    type: "checkbox",
    label: "Climate Resilience and Adaptation Strategy",
  },
  {
    id: "checkbox-net-zero-progress",
    type: "checkbox",
    label: "Net Zero Alignment Progress Report",
  },
  {
    id: "checkbox-cap-tracker",
    type: "checkbox",
    label: "Climate Action Plan (CAP) Tracker",
  },
  {
    id: "checkbox-tcfd-readiness",
    type: "checkbox",
    label: "TCFD Disclosure Readiness Report",
  },
  {
    id: "checkbox-emission-modeling",
    type: "checkbox",
    label: "Emissions Reduction Scenario Modeling",
  },
  {
    id: "checkbox-financial-risk",
    type: "checkbox",
    label: "Climate-Related Financial Risk Assessment",
  },
];
export const REAL_TIME_EMISSION_CALCULATION = [
  {
    heading: "Real-Time Emission Calculation",
    items: [
      { id: "note-realtime", label: "Click: “Generate Emissions Report”" },
      {
        id: "checkbox-scope-emissions",
        label: "Scope-wise emissions in tCO₂e",
      },
      { id: "checkbox-pie-chart", label: "Pie chart breakdown by scope" },
      { id: "checkbox-yoy-trend", label: "Year-on-Year emissions trend" },
      {
        id: "checkbox-ghg-thresholds",
        label: "🔴 GHG thresholds exceeded (e.g., 25,000 tCO₂e for Singapore Carbon Tax / National Systems)",
      },
      {
        id: "checkbox-ghg-inventory",
        label: "GHG Inventory (by scope, site, and source)",
      },
      {
        id: "checkbox-product-lifecycle",
        label: "🏷️ Product Lifecycle Report (aligned with GHG Product Standard)",
      },
      {
        id: "checkbox-regulatory-export",
        label: "🏛️ Regulatory Format Export",
      },
      {
        id: "checkbox-canadian-ghgrp-export",
        label: "Singapore Carbon Tax & Emissions Reporting / Malaysia ESG Formats",
      },
      {
        id: "checkbox-bc-ghg",
        label: "Indonesia IDXCarbon & MOEF SRN-PPI Reporting",
      },
      {
        id: "checkbox-alberta-offset",
        label: "Thailand TGO Carbon Offset & Philippines SEC Sustainability Reporting",
      },
      {
        id: "checkbox-audit-trail",
        label:
          "Audit trail included. Can be archived for MRV (Monitoring, Reporting & Verification)",
      },
      {
        id: "checkbox-benchmark",
        label: "📊 Benchmark vs sector average (by SSIC/MSIC/ISIC code)",
      },
      {
        id: "checkbox-reduction-targets",
        label: "🔄 Reduction targets & science-based alignment",
      },
      {
        id: "checkbox-ai-forecasting",
        label: "🔮 AI-powered emissions forecasting (Scope-wise)",
      },
    ],
  },
];
export const CARBON_CREDIT_MARKET = [
  {
    heading: "🏷️ Standards & Programs",
    items: [
      { id: "verra", label: "Verra (VCS)" },
      { id: "gold-standard", label: "Gold Standard" },
      { id: "cdm", label: "Clean Development Mechanism (CDM)" },
      { id: "car", label: "Climate Action Reserve (CAR)" },
      { id: "acr", label: "American Carbon Registry (ACR)" },
      { id: "art-trees", label: "ART TREES" },
      { id: "plan-vivo", label: "Plan Vivo" },
      { id: "rec", label: "Renewable Energy Credits (RECs)" },
      { id: "aau", label: "Assigned Amount Units (AAUs)" },
      { id: "vcm", label: "Voluntary Carbon Market (VCM)" },
      { id: "ets-eu", label: "ETS EU" },
      { id: "california-cap-trade", label: "California Cap-and-Trade" },
      { id: "ets-nz", label: "ETS NZ" },
      { id: "ets-south-korea", label: "ETS South Korea" },
      { id: "japan-jcm", label: "Japan JCM" },
      {
        id: "canadian-market-mix",
        label:
          "Singapore CIBS/CIX, Malaysia BCX, Indonesia IDXCarbon, Thailand TGO-VCM",
      },
    ],
  },
  {
    heading: "✅ Sector-Specific Standards",
    items: [
      { id: "corsia", label: "CORSIA (Aviation)" },
      { id: "responsible-care", label: "Responsible Care (Chemicals)" },
      { id: "ipieca", label: "IPIECA (Oil & Gas)" },
      { id: "fsc", label: "FSC" },
      { id: "msc", label: "MSC" },
      { id: "sfi", label: "SFI" },
      {
        id: "quebec-forest-monitoring",
        label: "ASEAN Forest & Peatland Monitoring",
      },
      { id: "ontario-green-energy-act", label: "Renewable Energy & Grid Acts (APAC)" },
    ],
  },
  {
    heading: "🌍 Country-Specific Systems",
    items: [
      {
        id: "canadian-ghg-offset-system",
        label: "Singapore Carbon Pricing Act (CPA) Offset Registry",
      },
      {
        id: "bc-forest-carbon-offsets",
        label: "Malaysia Bursa Carbon Exchange (BCX)",
      },
      { id: "alberta-tier", label: "Indonesia Carbon Exchange (IDXCarbon)" },
      { id: "quebec-cap-trade", label: "Thailand Greenhouse Gas Management Organization (TGO)" },
      { id: "obps-canada", label: "Philippines SEC Sustainability & Energy Regulations" },
      {
        id: "intl-carbon-schemes",
        label: "China VER, Japan JCM, NZ ETS, South Korea ETS, Vietnam Carbon Credit Trading",
      },
    ],
  },
];
export const OFFSET_STANDARD_SELECTOR = CARBON_CREDIT_MARKET;
export const APPLICABLE_STANDARD = [
  {
    heading: "📗 Green Bond Principles (GBP)",
    items: [
      { id: "gbp-standard-use", label: "Standard Green Use of Proceeds Bond" },
      { id: "gbp-revenue", label: "Green Revenue Bond" },
      { id: "gbp-project", label: "Green Project Bond" },
      { id: "gbp-secured", label: "Secured Green Bond" },
    ],
  },
  {
    heading: "📘 Social Bond Principles (SBP)",
    items: [
      { id: "sbp-standard-use", label: "Standard Social Use of Proceeds Bond" },
      { id: "sbp-revenue", label: "Social Revenue Bond" },
      { id: "sbp-project", label: "Social Project Bond" },
      { id: "sbp-secured", label: "Secured Social Bond" },
    ],
  },
  {
    heading: "📙 Other Applicable Standards",
    items: [
      { id: "sbg", label: "Sustainability Bond Guidelines (SBG)" },
      { id: "slbp", label: "Sustainability-Linked Bond Principles (SLBP)" },
      { id: "glp", label: "Green Loan Principles (GLP)" },
      { id: "slp", label: "Social Loan Principles (SLP)" },
      { id: "sllp", label: "Sustainability-Linked Loan Principles (SLLP)" },
      { id: "cbi-taxonomy", label: "Climate Bonds Initiative (CBI) Taxonomy" },
      { id: "eu-gbs", label: "EU Green Bond Standard (if cross-border)" },
      {
        id: "canadian-green-bond-framework",
        label: "Singapore Green Bond Framework & ASEAN Green Bond Standards",
      },
      {
        id: "cib-requirements",
        label: "Malaysia SRI Sukuk Framework & Philippines Sustainable Finance Roadmap",
      },
    ],
  },
];
export const ENVIROMENTAL_COMPLIANCE_REPORTING = [
  {
    id: "checkbox-env-due-diligence",
    type: "checkbox",
    label: "Environmental Compliance Due Diligence Report",
  },
  {
    id: "checkbox-biodiversity-risk",
    type: "checkbox",
    label: "Biodiversity Risk and Sensitivity Assessment",
  },
  {
    id: "checkbox-air-emissions",
    type: "checkbox",
    label: "Air Emissions Inventory and Compliance Report",
  },
  {
    id: "checkbox-water-discharge",
    type: "checkbox",
    label: "Water Use and Wastewater Discharge Assessment",
  },
  {
    id: "checkbox-waste-management",
    type: "checkbox",
    label: "Waste Management and Hazardous Materials Audit",
  },
  {
    id: "checkbox-climate-resilience",
    type: "checkbox",
    label: "Climate Risk and Resilience Assessment",
  },
  {
    id: "checkbox-energy-efficiency",
    type: "checkbox",
    label: "Energy and Resource Efficiency Profile",
  },
  {
    id: "checkbox-soil-groundwater",
    type: "checkbox",
    label: "Soil and Groundwater Contamination Risk Assessment",
  },
  {
    id: "checkbox-noise-vibration",
    type: "checkbox",
    label: "Noise and Vibration Monitoring Report",
  },
  {
    id: "checkbox-emp-tracker",
    type: "checkbox",
    label: "Environmental Management Plan (EMP) Tracker",
  },
  {
    id: "checkbox-permitting-compliance",
    type: "checkbox",
    label: "Environmental Permitting and Regulatory Compliance Report",
  },
  {
    id: "checkbox-protected-areas",
    type: "checkbox",
    label: "Protected Areas and Ecosystem Services Assessment",
  },
  {
    id: "checkbox-cia",
    type: "checkbox",
    label: "Cumulative Environmental Impact Analysis (CIA)",
  },
  {
    id: "checkbox-grievance-monitoring",
    type: "checkbox",
    label: "Environmental Grievance Monitoring Report",
  },
  {
    id: "checkbox-natural-habitat",
    type: "checkbox",
    label: "Natural Habitat & Critical Habitat Assessment",
  },
  {
    id: "checkbox-spill-response",
    type: "checkbox",
    label: "Environmental Incident & Spill Response Record",
  },
];
export const DETAILED_ACTIVITY_UN_RISK_ASSESS = [
  {
    heading: "A. Activity Details",
    isFormSection: true,
    fields: [
      {
        id: "task-activity-title",
        label: "Task / Activity Title",
        inputType: "text",
        placeholder: "Enter task or activity title",
      },
      {
        id: "description-of-work",
        label: "Description of Work",
        inputType: "text",
        placeholder: "Enter description of work",
      },
      {
        id: "project-site-name",
        label: "Project / Site Name",
        inputType: "text",
        placeholder: "Enter project or site name",
      },
      {
        id: "contractor-subcontractor",
        label: "Contractor / Subcontractor Involved",
        inputType: "text",
        placeholder: "Enter contractor or subcontractor name",
      },
      {
        id: "location-type",
        label: "Location Type",
        inputType: "multiselect",
        options: [
          "Indoor",
          "Outdoor",
          "Confined Space",
          "Elevated",
          "Tunnel / Pit",
        ],
      },
      {
        id: "project-phase",
        label: "Project Phase",
        inputType: "multiselect",
        options: [
          "Planning",
          "Execution",
          "Testing / Commissioning",
          "Maintenance",
          "Shutdown",
        ],
      },
      {
        id: "tools-equipment",
        label: "Tools / Equipment Used",
        inputType: "text",
        placeholder: "e.g., welding machine, ladder, generator, harness",
      },
      {
        id: "shift-schedule",
        label: "Shift Schedule",
        inputType: "multiselect",
        options: ["Day", "Night", "Rotational", "24/7"],
      },
      {
        id: "task-frequency",
        label: "Task Frequency",
        inputType: "multiselect",
        options: ["One-time", "Daily", "Weekly", "Recurring / Rotational"],
      },
      {
        id: "number-of-workers",
        label: "Number of Workers (Numeric)",
        inputType: "number",
        placeholder: "Enter number of workers",
      },
      {
        id: "roles-involved",
        label: "Roles Involved",
        inputType: "multiselect",
        options: [
          "Worker",
          "Supervisor",
          "Engineer",
          "Safety Officer",
          "Other",
        ],
      },
    ],
  },
  {
    heading: "B. Environmental & Site Conditions",
    items: [
      {
        id: "proximity-edge-trench",
        label: "Proximity to edge / excavation / trench",
      },
      {
        id: "unprotected-pits",
        label: "Unprotected pits / holes / open shafts",
      },
      {
        id: "fragile-surfaces",
        label:
          "Working on fragile or unstable surfaces (e.g., glass roofs, corroded platforms)",
      },
      {
        id: "overhead-hazards",
        label: "Overhead hazards (live wires, suspended loads, beams, cranes)",
      },
      {
        id: "overhead-work",
        label: "Overhead work taking place above the activity area",
      },
      {
        id: "low-clearance",
        label: "Low clearance height / confined vertical spaces",
      },
      {
        id: "nearby-traffic",
        label:
          "Nearby traffic or mobile equipment operation (e.g., forklifts, dumpers, trucks)",
      },
      {
        id: "restricted-movement",
        label: "Restricted movement / congested work area",
      },
      {
        id: "uneven-surfaces",
        label: "Uneven or slippery surfaces (mud, ice, oil, debris)",
      },
      {
        id: "poor-lighting",
        label:
          "Poor lighting / visibility risk (night work, tunnels, enclosed spaces)",
      },
      {
        id: "obstructed-access",
        label: "Obstructed access / emergency exit blocked",
      },
      {
        id: "noise-vibration",
        label: "Noise or vibration from machinery or nearby operations",
      },
      {
        id: "high-temp",
        label: "High ambient temperatures (risk of heat stress)",
      },
      {
        id: "cold-exposure",
        label: "Cold exposure (risk of hypothermia / frostbite)",
      },
      {
        id: "wind-risk",
        label:
          "Strong wind / storm forecasted (risk to lifts, scaffolds, cranes)",
      },
      {
        id: "rainfall-risk",
        label: "Rainfall risk (slip, flooding, electrical hazard)",
      },
      { id: "chemical-spill", label: "Chemical spill potential" },
      { id: "oil-storage", label: "Oil/fuel storage near site" },
      { id: "poor-air-quality", label: "Poor air quality / dust emissions" },
      { id: "water-discharge", label: "Water discharge zones" },
      { id: "ignition-sources", label: "Open flames or ignition sources" },
      { id: "hazardous-waste", label: "Nearby hazardous waste accumulation" },
      {
        id: "wildlife-proximity",
        label: "Wildlife proximity (snakes, insects, nesting birds)",
      },
      {
        id: "vegetation-disturbance",
        label: "Vegetation or tree disturbance (if in natural habitat)",
      },
      { id: "near-water", label: "Work near water body or coastal zone" },
      {
        id: "drowning-risk",
        label:
          "Risk of drowning / water ingress (if working near tanks, drains, canals)",
      },
      {
        id: "terrain-access",
        label:
          "Site access affected by terrain (steep slopes, loose ground, landslide zones)",
      },
      {
        id: "sensitive-receptors",
        label:
          "Nearby sensitive receptors (schools, hospitals, residential areas, cultural sites)",
      },
      {
        id: "no-barricades",
        label: "Site not demarcated or lacking barricades",
      },
      {
        id: "airflow-restriction",
        label:
          "Airflow restricted / lack of ventilation (especially in enclosed areas)",
      },
      {
        id: "ground-instability",
        label: "Ground instability / evidence of soil movement",
      },
      {
        id: "flooding-history",
        label: "History of flooding or waterlogging in area",
      },
    ],
  },
  {
    heading: "C. Occupational Health & Safety Conditions",
    items: [
      {
        id: "worker-fit-check",
        label:
          "Are all workers medically fit and competent for the task assigned?",
      },
      {
        id: "untrained-worker",
        label:
          "Is any task being performed by an untrained, unfit, or fatigued worker?",
      },
      {
        id: "heat-cold-risk",
        label:
          "Is heat stress, dehydration, or cold exposure a risk in this environment?",
      },
      {
        id: "noise-vibration-check",
        label:
          "Is noise exposure likely to exceed 85 dB, or are vibration risks present?",
      },
      {
        id: "ergonomic-risk",
        label:
          "Is the task repetitive, above shoulder/below knee, or ergonomically poor?",
      },
      {
        id: "manual-handling",
        label:
          "Is manual material handling required (>25kg without mechanical aid)?",
      },
      {
        id: "awkward-posture",
        label: "Is prolonged standing or awkward posture part of the job?",
      },
      {
        id: "scheduled-breaks",
        label:
          "Are workers taking scheduled breaks during long or high-risk tasks?",
      },
      {
        id: "ppe-correct",
        label: "Are all workers wearing correct and adequate PPE for the task?",
      },
      {
        id: "ppe-condition",
        label: "Is PPE in good condition, properly fitted, and certified?",
      },
      {
        id: "toolbox-talk",
        label:
          "Has a safety briefing/toolbox talk been conducted prior to the activity?",
      },
      {
        id: "on-site-supervision",
        label: "Is on-site supervision present and actively overseeing safety?",
      },
      {
        id: "buddy-system",
        label: "Is a buddy system implemented for lone or high-risk workers?",
      },
      {
        id: "female-worker-risk",
        label:
          "Are there any specific OHS risks related to female workers at this site?",
      },
      {
        id: "communication-barriers",
        label:
          "Are there language or communication barriers affecting safety understanding?",
      },
      {
        id: "early-fatigue-detection",
        label:
          "Are workers trained to detect early signs of fatigue, heat illness, or stress?",
      },
      {
        id: "slip-trip-fall-risk",
        label:
          "Is there risk of slips, trips, falls, entrapment, or sharp tool injuries?",
      },
      {
        id: "unguarded-equipment",
        label:
          "Is the worker using or near unguarded, rotating, or sharp equipment?",
      },
      {
        id: "hot-work-controls",
        label:
          "Is hot work (welding, grinding, cutting) being done with appropriate controls?",
      },
      {
        id: "chemical-vapor-risk",
        label:
          "Are chemical vapors, adhesives, or solvents present requiring respiratory protection?",
      },
      {
        id: "confined-space",
        label:
          "Is work being done in a confined, poorly ventilated, or enclosed space?",
      },
      {
        id: "electrical-hazard",
        label:
          "Are there any exposed live wires, energized panels, or electrical hazards?",
      },
      {
        id: "powered-machinery",
        label:
          "Is the worker operating or working near powered vehicles or machinery?",
      },
      {
        id: "fall-risk",
        label:
          "Are working-at-height risks (>2m or below) present without fall protection?",
      },
      {
        id: "noise-interference",
        label:
          "Is background noise interfering with verbal instructions or safety alerts?",
      },
      {
        id: "first-aid-box",
        label:
          "Is a first aid box fully stocked and accessible at the work location?",
      },
      {
        id: "first-aiders",
        label:
          "Are trained first-aiders clearly assigned and known to the team?",
      },
      {
        id: "fire-extinguishers",
        label: "Are fire extinguishers present, inspected, and unobstructed?",
      },
      {
        id: "emergency-exits",
        label: "Are emergency exits visible, accessible, and unobstructed?",
      },
      {
        id: "muster-point",
        label: "Does the team know the location of the muster/assembly point?",
      },
      {
        id: "rescue-plan",
        label:
          "Is a task-specific rescue plan in place and rehearsed if required?",
      },
      {
        id: "emergency-contacts",
        label: "Are emergency contact numbers posted and known to all workers?",
      },
      {
        id: "hydration-kit",
        label:
          "Is a hydration/heat illness prevention kit available on high-temperature sites?",
      },
      {
        id: "unsafe-behaviors",
        label:
          "Are unsafe behaviors, short cuts, or risk tolerance behaviors observed?",
      },
      {
        id: "time-pressure",
        label: "Are production or time pressures influencing safe behavior?",
      },
      {
        id: "proactive-supervision",
        label:
          "Is safety supervision present, proactive, and engaged with the team?",
      },
      {
        id: "worker-concerns",
        label: "Are worker concerns being raised and adequately addressed?",
      },
      {
        id: "punishment-over-systems",
        label:
          "Is there an over-reliance on punishment rather than system improvement?",
      },
    ],
  },
  {
    heading: "D. Hazard & Risk Identification",
    items: [
      {
        id: "example-work-at-height",
        label: "Work at Height",
      },
    ],
  },
  {
    heading: "E. Control Measures",
    items: [
      { id: "fall-arrest", label: "Fall arrest systems in place" },
      { id: "daily-inspection", label: "Daily inspection logs completed" },
      { id: "certified-equipment", label: "Certified equipment used" },
      { id: "area-barricaded", label: "Area barricaded / signage present" },
      { id: "supervision-assigned", label: "Supervision assigned" },
      { id: "rescue-plan-discussed", label: "Rescue plan ready and discussed" },
      {
        id: "additional-controls",
        label: "Additional Controls Needed: (Free text input)",
      },
    ],
  },
];
export const ENV_SOCIAL_MANAGEMENT_PLANS = [
  {
    heading: "Environmental & Social Management Plans",
    items: [
      { id: "esms-manual", label: "ESMS Manual" },
      {
        id: "labor-working-condition-plan",
        label: "Labor and Working Condition Management Plan",
      },
      { id: "contractor-management-plan", label: "Contractor Management Plan" },
      {
        id: "grievance-redress-mechanism-plan",
        label: "Grievance Redress Mechanism Plan",
      },
      {
        id: "stakeholder-engagement-plan",
        label: "Stakeholder Engagement Plan",
      },
      {
        id: "solid-hazardous-waste-management-plan",
        label: "Solid Waste & Hazardous Waste Management Plan",
      },
      { id: "wastewater-management-plan", label: "Wastewater Management Plan" },
      {
        id: "traffic-road-safety-management-plan",
        label: "Traffic and Road Safety Management Plan",
      },
      {
        id: "air-quality-monitoring-management-plan",
        label: "Air Quality Monitoring and Management Plan",
      },
      {
        id: "noise-vibration-monitoring-plan",
        label: "Noise and Vibration Monitoring Plan",
      },
      { id: "security-management-plan", label: "Security Management Plan" },
      {
        id: "environmental-social-risk-assessment-plan",
        label: "Environmental & Social Risk Assessment Plan",
      },
      {
        id: "emergency-preparedness-response-plan",
        label: "Emergency Preparedness and Response Plan",
      },
      {
        id: "es-monitoring-audit-review-framework",
        label: "E&S Monitoring, Audit, and Review Framework",
      },
      {
        id: "supply-chain-procurement-management-plan",
        label: "Supply Chain & Procurement Management Plan",
      },
      {
        id: "resource-efficiency-pollution-prevention-plan",
        label: "Resource Efficiency and Pollution Prevention Plan",
      },
      {
        id: "community-health-safety-security-plan",
        label: "Community Health, Safety, and Security Plan",
      },
      {
        id: "occupational-health-safety-management-plan",
        label: "Occupational Health and Safety (OHS) Management Plan",
      },
      {
        id: "es-training-capacity-building-framework",
        label: "E&S Training and Capacity Building Framework",
      },
      {
        id: "climate-change-risk-adaptation-plan",
        label: "Climate Change Risk and Adaptation Plan",
      },
      {
        id: "biodiversity-conservation-management-plan",
        label: "Biodiversity Conservation and Management Plan",
      },
      {
        id: "cultural-heritage-management-plan",
        label: "Cultural Heritage Management Plan",
      },
      {
        id: "land-acquisition-resettlement-action-plan",
        label: "Land Acquisition and Resettlement Action Plan (if applicable)",
      },
      {
        id: "ghg-emissions-monitoring-plan",
        label: "Greenhouse Gas (GHG) Emissions Monitoring Plan",
      },
      {
        id: "water-resource-management-plan",
        label: "Water Resource Management Plan",
      },
      {
        id: "spill-prevention-response-plan",
        label: "Spill Prevention and Response Plan",
      },
      {
        id: "hazardous-material-management-plan",
        label: "Hazardous Material Management Plan",
      },
      {
        id: "esg-framework-compliance-reporting-plan",
        label:
          "ESG Framework Compliance and Reporting Plan (GRI, SASB, TCFD, IFRS, CSRD)",
      },
      {
        id: "sustainability-risks-opportunities-management-plan",
        label:
          "Sustainability Risks and Opportunities Management Plan (Aligned with SASB/GRI/IFRS)",
      },
      {
        id: "esg-governance-controls-procedures-plan",
        label: "ESG Governance, Controls, and Internal Procedures Plan",
      },
      {
        id: "esg-target-setting-legal-compliance-tracking-plan",
        label: "ESG Target Setting and Legal Compliance Tracking Plan",
      },
      {
        id: "esg-compliance-monitoring-continuous-improvement-plan",
        label: "ESG Compliance Monitoring and Continuous Improvement Plan",
      },
      {
        id: "canadian-esg-occupational-health-compliance-plan",
        label:
          "APAC ESG and Occupational Health Compliance Plan (WSH Singapore, DOSH Malaysia, OSH Standards Philippines)",
      },
      {
        id: "canadian-green-bond-sustainable-finance-compliance-plan",
        label:
          "APAC Green Bond & Sustainable Finance Compliance Plan (Singapore GBS, Malaysia SRI Sukuk, ASEAN Taxonomy)",
      },
      {
        id: "green-bond-sustainability-bond-management-plan",
        label:
          "Green Bond and Sustainability Bond Management Plan (GBP, SBP, SBG Aligned)",
      },
      {
        id: "sustainability-linked-bonds-loans-compliance-plan",
        label:
          "Sustainability-Linked Bonds & Loans Compliance Plan (SLBP, SLLP, GLP, SLP)",
      },
      {
        id: "climate-bonds-certification-compliance-management-plan",
        label:
          "Climate Bonds Certification and Compliance Management Plan (CBI Aligned)",
      },
      {
        id: "accreditation-compliance-certification-tracking-plan",
        label:
          "Accreditation & Compliance Certification Tracking Plan (ISO/IEC etc.)",
      },
      {
        id: "energy-environmental-social-compliance-certification-plan",
        label: "Energy, Environmental & Social Compliance Certification Plan",
      },
      {
        id: "product-certification-compliance-plan",
        label: "Product Certification and Compliance Plan (CE, GMP, etc.)",
      },
    ],
  },
  {
    heading: "Relevant Procedures",
    items: [
      {
        id: "grievance-handling-procedure",
        label: "Grievance Handling Procedure",
      },
      {
        id: "incident-reporting-investigation-procedure",
        label: "Incident Reporting & Investigation Procedure",
      },
      { id: "permit-to-work-procedure", label: "Permit-to-Work Procedure" },
      {
        id: "waste-disposal-handling-procedure",
        label: "Waste Disposal and Handling Procedure",
      },
      {
        id: "chemical-spill-response-procedure",
        label: "Chemical Spill and Response Procedure",
      },
      {
        id: "emergency-evacuation-procedure",
        label: "Emergency Evacuation Procedure",
      },
      {
        id: "air-quality-monitoring-procedure",
        label: "Air Quality Monitoring Procedure",
      },
      {
        id: "noise-vibration-monitoring-procedure",
        label: "Noise and Vibration Monitoring Procedure",
      },
      {
        id: "contractor-safety-procedure",
        label: "Contractor Safety Procedure",
      },
      {
        id: "site-inspection-audit-procedure",
        label: "Site Inspection and Audit Procedure",
      },
      {
        id: "stakeholder-consultation-procedure",
        label: "Stakeholder Consultation Procedure",
      },
      {
        id: "security-access-control-procedure",
        label: "Security Access Control Procedure",
      },
      {
        id: "training-competency-evaluation-procedure",
        label: "Training and Competency Evaluation Procedure",
      },
    ],
  },
  {
    heading: "Work Instructions (Expanded List)",
    items: [
      { id: "toolbox-talk-instruction", label: "Toolbox Talk Instruction" },
      {
        id: "ppe-usage-inspection-instruction",
        label: "PPE Usage and Inspection Instruction",
      },
      {
        id: "confined-space-entry-instruction",
        label: "Confined Space Entry Instruction",
      },
      {
        id: "hot-work-permit-issuance-instruction",
        label: "Hot Work Permit Issuance Instruction",
      },
      {
        id: "lockout-tagout-work-instruction",
        label: "Lockout-Tagout (LOTO) Work Instruction",
      },
      {
        id: "hazardous-waste-segregation-instruction",
        label: "Hazardous Waste Segregation Instruction",
      },
      {
        id: "spill-kit-deployment-instruction",
        label: "Spill Kit Deployment Instruction",
      },
      {
        id: "air-quality-sampling-instruction",
        label: "Air Quality Sampling Instruction",
      },
      {
        id: "noise-level-measurement-instruction",
        label: "Noise Level Measurement Instruction",
      },
      {
        id: "safe-manual-handling-instruction",
        label: "Safe Manual Handling Instruction",
      },
      {
        id: "first-aid-medical-emergency-instruction",
        label: "First Aid and Medical Emergency Instruction",
      },
      {
        id: "fire-extinguisher-use-instruction",
        label: "Fire Extinguisher Use Instruction",
      },
      {
        id: "safety-signage-barricading-instruction",
        label: "Safety Signage and Barricading Instruction",
      },
      {
        id: "contractor-induction-briefing-instruction",
        label: "Contractor Induction Briefing Instruction",
      },
      {
        id: "visitor-safety-orientation-instruction",
        label: "Visitor Safety Orientation Instruction",
      },
      {
        id: "work-at-height-safety-instruction",
        label: "Work-at-Height Safety Instruction",
      },
      {
        id: "equipment-pre-use-checklist-instruction",
        label: "Equipment Pre-Use Checklist Instruction",
      },
      {
        id: "wastewater-sampling-instruction",
        label: "Wastewater Sampling Instruction",
      },
      {
        id: "security-patrol-checklist-instruction",
        label: "Security Patrol Checklist Instruction",
      },
      {
        id: "community-engagement-record-instruction",
        label: "Community Engagement Record Instruction",
      },
    ],
  },
];

export const NATURE_OF_ACTIVITIES = [
  {
    heading: "Nature of Activities",
    description: "Nature of Activities",
    items: [
      {
        id: "new-construction",
        label: "New Construction (Buildings, Roads, Infrastructure, Bridges)",
      },
      {
        id: "plant-operations",
        label: "Plant Operations (Industrial Production, Chemical Processing)",
      },
      {
        id: "equipment-installation",
        label: "Equipment Installation, Commissioning, and Testing",
      },
      {
        id: "survey-monitoring",
        label: "Survey, Monitoring, Inspection Field Work",
      },
      {
        id: "logistics-warehousing",
        label: "Logistics and Warehousing Operations",
      },
      {
        id: "administration-supplier",
        label: "Administration and Supplier, Vendor Management",
      },
      {
        id: "vehicle-fleet",
        label: "Vehicle Fleet and Transport Management",
      },
      {
        id: "maintenance-repair",
        label: "Maintenance and Repair Services",
      },
      {
        id: "renewable-energy",
        label: "Renewable Energy Operations (Solar, Wind, Hydro, Hybrid)",
      },
      {
        id: "waste-extraction",
        label: "Waste Extraction, Supply, and Wastewater Treatment",
      },
      {
        id: "water-management",
        label: "Water Management and Restoration Activities",
      },
      {
        id: "biodiversity-protection",
        label: "Biodiversity Protection and Conservation Programs",
      },
      {
        id: "other-activities",
        label: "Other Activities (Specify text field)",
        custom: true, // Flag for custom input field
      },
    ],
  },
];
export const INDUSTRY_SECTORS = [
  {
    heading: "Industrial Identification",
    description: "Industrial Identification",
    items: [
      {
        id: "construction-infrastructure",
        label: "Construction & Infrastructure",
      },
      {
        id: "manufacturing",
        label: "Manufacturing (Food, Industrial Goods, Chemicals)",
      },
      {
        id: "energy",
        label: "Energy (Renewable, Fossil, Transmission, Distribution)",
      },
      {
        id: "it-data-centers",
        label: "IT & Data Centers",
      },
      {
        id: "warehousing-logistics",
        label: "Warehousing & Logistics",
      },
      {
        id: "transportation-mobility",
        label: "Transportation & Mobility Services",
      },
      {
        id: "agriculture-food-processing",
        label: "Agriculture & Food Processing",
      },
      {
        id: "mining-extractives",
        label: "Mining and Extractives",
      },
      {
        id: "retail-consumer-goods",
        label: "Retail and Consumer Goods",
      },
      {
        id: "healthcare-pharmaceuticals",
        label: "Healthcare and Pharmaceuticals",
      },
      {
        id: "financial-insurance",
        label: "Financial and Insurance Services",
      },
      {
        id: "public-services-government",
        label: "Public Services / Government Projects",
      },
      {
        id: "consulting-professional",
        label: "Consulting and Professional Services",
      },
      {
        id: "telecommunications-media",
        label: "Telecommunications and Media",
      },
      {
        id: "others",
        label: "Others (Custom entry field)",
        custom: true, // Flag for custom input field
      },
    ],
  },
];

export const TRAINING_CAPACITY_BUILDING_PROGRAM = [
  {
    heading: "📊 Dashboard Use & Digital Skills",
    items: [
      { id: "intro-dashboard", label: "Introduction to ESG Vision Dashboard" },
      { id: "user-access", label: "User Account Setup & Access Control" },
      { id: "data-entry", label: "ESG Data Entry & Uploading" },
      { id: "bulk-upload", label: "Bulk Upload & Template Use" },
      { id: "api-integration", label: "API Integration & Data Sync" },
      { id: "ai-tools", label: "Smart Tools & AI Report Generation" },
      { id: "compliance-tracking", label: "Compliance Monitoring & Tracking" },
      { id: "kpi-visualization", label: "ESG KPI Setup & Visualization" },
      { id: "benchmarking", label: "Benchmarking & Performance Tracking" },
      { id: "gis-mapping", label: "GIS Mapping & Spatial Analysis" },
      { id: "modeling-tools", label: "Environmental & Social Modeling Tools" },
      { id: "scenario-simulation", label: "Scenario Simulation & Forecasting" },
      { id: "cloud-storage", label: "Cloud Data Storage & Archival" },
      { id: "data-retrieval", label: "Data Retrieval & Reporting" },
      { id: "version-control", label: "Version Control & Audit Trails" },
      { id: "notifications", label: "Alerts & Notifications Setup" },
      { id: "custom-widgets", label: "Custom Dashboard Design & Widgets" },
      {
        id: "advanced-analytics",
        label: "Advanced Analytics & Data Filtering",
      },
      { id: "real-time-monitoring", label: "Real-Time Compliance Monitoring" },
      {
        id: "historical-comparison",
        label: "Historical Data Comparison Tools",
      },
      {
        id: "multi-project-tracking",
        label: "Cross-Site & Multi-Project Tracking",
      },
      { id: "risk-dashboard", label: "Risk Assessment Dashboard Use" },
      { id: "cap-tracking", label: "Corrective Action Plan Tracking" },
      { id: "mobile-access", label: "Mobile Dashboard Access & Use" },
      { id: "data-privacy", label: "Security & Data Privacy Settings" },
    ],
  },
  {
    heading: "🌐 ESG Global Standards Training",
    items: [
      {
        id: "gri",
        label: "GRI Standards (Core, Comprehensive, Sector-Specific)",
      },
      {
        id: "sasb-issb",
        label: "SASB & ISSB (Sector-Specific ESG Disclosures)",
      },
      {
        id: "csrd-esrs",
        label: "CSRD & ESRS (EU Sustainability Reporting Standards)",
      },
      { id: "tcfd", label: "TCFD (Climate-Related Disclosures)" },
      { id: "tnfd", label: "TNFD (Nature-Related Disclosures)" },
      { id: "ungc-sdg", label: "UNGC & SDG Alignment" },
      { id: "ifc-ps", label: "IFC Performance Standards (PS1–PS8)" },
      { id: "equator-principles", label: "Equator Principles & ESG Lending" },
      { id: "iso", label: "ISO Standards (14001, 45001, 50001, 26000, etc.)" },
      {
        id: "canadian-frameworks",
        label: "APAC ESG Frameworks (SGX, Bursa Malaysia, IDX, SEC Philippines)",
      },
      {
        id: "oecd-guidelines",
        label: "OECD Guidelines for Multinational Enterprises",
      },
      { id: "eu-taxonomy", label: "EU Taxonomy for Sustainable Activities" },
      { id: "cbi", label: "Climate Bonds Initiative (CBI) Standards" },
      { id: "green-social-bonds", label: "Green & Social Bond Principles" },
      { id: "slb-sllp", label: "Sustainability-Linked Bonds & Loans" },
      { id: "pri", label: "Principles for Responsible Investment (PRI)" },
      { id: "aa1000", label: "AA1000 Standards (Stakeholder Engagement)" },
      {
        id: "ungps",
        label: "UN Guiding Principles on Business & Human Rights",
      },
      { id: "sfdr", label: "Sustainable Finance Disclosure Regulation (SFDR)" },
      { id: "sbti", label: "Science Based Targets Initiative (SBTi)" },
      { id: "cdp", label: "CDP (Carbon Disclosure Project)" },
      { id: "iris", label: "IRIS+ (Impact Measurement & Management)" },
      { id: "b-corp", label: "B-Corp Certification & ESG Metrics" },
      { id: "leed-well", label: "LEED & WELL Certification (Green Buildings)" },
      {
        id: "global-compact-canada",
        label: "UNGC Network Singapore & Malaysia Frameworks",
      },
      {
        id: "local-regulations",
        label: "Local/National E&S Regulations (Custom)",
      },
    ],
  },
  {
    heading: "⚖️ Legal & Compliance Workshops",
    items: [
      { id: "legal-compliance", label: "E&S Legal Compliance (By Country)" },
      {
        id: "due-diligence",
        label: "ESG Regulatory & Due Diligence Requirements",
      },
      { id: "permits", label: "Permit & Licensing Management" },
      { id: "audit-docs", label: "Audit-Ready ESG Documentation" },
      { id: "gap-analysis", label: "Gap Analysis & CAPs" },
      {
        id: "carbon-ghg",
        label: "Carbon Accounting & GHG Reporting (Scope 1–3)",
      },
      {
        id: "green-finance",
        label: "Sustainable Finance & Green Bonds Compliance",
      },
      { id: "env-laws", label: "National & Local Environmental Laws" },
      { id: "ohs-compliance", label: "OHS Compliance & Worker Welfare" },
      { id: "anti-corruption", label: "Anti-Bribery & Corruption Compliance" },
      { id: "human-rights", label: "Human Rights Due Diligence & Labor Law" },
      {
        id: "biodiversity-laws",
        label: "Biodiversity & Resource Protection Laws",
      },
      {
        id: "waste-regulations",
        label: "Waste & Circular Economy Regulations",
      },
      { id: "water-laws", label: "Water Resource Compliance" },
      { id: "indigenous-rights", label: "Indigenous Rights & FPIC Frameworks" },
      {
        id: "land-resettlement",
        label: "Land Acquisition & Resettlement Laws",
      },
      { id: "climate-laws", label: "Climate Change & Net Zero Legal Pathways" },
      { id: "supply-chain-risk", label: "Supply Chain & Modern Slavery Laws" },
      { id: "data-protection", label: "ESG Data Privacy Laws (GDPR, etc.)" },
      {
        id: "gender-compliance",
        label: "Gender Equality & Non-Discrimination",
      },
      { id: "crisis-legal", label: "Crisis Response Legal Obligations" },
      {
        id: "financial-disclosure",
        label: "Financial & ESG Reporting Mandates",
      },
      { id: "carbon-regulations", label: "Energy Efficiency & Carbon Markets" },
      { id: "security-laws", label: "Security Management Regulations" },
      {
        id: "intl-frameworks",
        label: "International ESG Legal Best Practices",
      },
    ],
  },
  {
    heading: "🎯 Specialized ESG Topics",
    items: [
      { id: "climate-risk", label: "Climate Risk & Adaptation Planning" },
      {
        id: "biodiversity-monitoring",
        label: "Biodiversity & Habitat Monitoring",
      },
      { id: "stakeholder-fpic", label: "Stakeholder Engagement & FPIC" },
      {
        id: "social-impact",
        label: "Social Impact & Vulnerability Assessment",
      },
      { id: "gender-gbv", label: "Gender Equity & GBV Risk Screening" },
      {
        id: "labor-due-diligence",
        label: "Labor & Human Rights Due Diligence",
      },
      { id: "waste-management", label: "Waste & Resource Efficiency" },
      {
        id: "water-stewardship",
        label: "Water Stewardship & Pollution Prevention",
      },
      { id: "emergency-prep", label: "Emergency Preparedness Integration" },
      { id: "materiality", label: "ESG Materiality Assessment" },
      { id: "net-zero", label: "Carbon Neutrality & Net Zero Roadmaps" },
      { id: "renewable-esg", label: "Renewable Energy Integration & ESG" },
      { id: "supply-chain-esg", label: "Sustainable Supply Chain Strategies" },
      { id: "community-health", label: "Community Health & Safety Planning" },
      { id: "cultural-heritage", label: "Cultural Heritage Protection" },
      { id: "env-justice", label: "Environmental Justice & Equity" },
      { id: "esg-digital", label: "ESG Data & Digital Transformation" },
      { id: "circular-economy", label: "Circular Economy & Product Design" },
      {
        id: "green-infrastructure",
        label: "Green Building & Infrastructure Standards",
      },
      {
        id: "climate-finance",
        label: "Climate Finance & Investment Strategies",
      },
      { id: "esg-kpis", label: "ESG Performance Metrics & KPIs" },
      { id: "marine-coastal", label: "Marine & Coastal Risk Management" },
      { id: "air-quality", label: "Air Quality & Health Assessments" },
      { id: "disaster-resilience", label: "Disaster Risk Reduction Planning" },
      { id: "esg-communication", label: "ESG Communication & Reporting" },
      { id: "esg-innovation", label: "ESG Trends & Innovations" },
      { id: "indigenous-stewardship", label: "Indigenous Land Stewardship" },
      {
        id: "decarbonization",
        label: "Decarbonization & Low-Carbon Strategies",
      },
      { id: "transport-risk", label: "Transport & Logistics ESG Risk" },
      { id: "corporate-integration", label: "ESG in Corporate Strategy" },
    ],
  },
  {
    heading: "🦺 Health & Safety (OHS) Training",
    items: [
      {
        id: "ohs-compliance-training",
        label: "OHS Compliance & Risk Assessment",
      },
      { id: "incident-reporting", label: "Incident & Near-Miss Reporting" },
      { id: "worker-health", label: "Worker Welfare & Health Monitoring" },
      { id: "ppe-protocols", label: "PPE & Site Safety Protocols" },
      { id: "fire-drills", label: "Fire & Emergency Drill Procedures" },
      { id: "contractor-safety", label: "Contractor Safety Training" },
      { id: "hirac", label: "Hazard Identification & Risk Control" },
      { id: "confined-space", label: "Confined Space Entry Safety" },
      {
        id: "fall-protection",
        label: "Work-at-Height Safety & Fall Protection",
      },
      { id: "hot-work", label: "Hot Work Safety Procedures" },
      { id: "electrical-safety", label: "Electrical Safety & LOTO" },
      { id: "hazardous-materials", label: "Hazardous Materials Handling" },
      { id: "noise-management", label: "Noise & Vibration Management" },
      { id: "manual-handling", label: "Manual Handling & Ergonomics" },
      { id: "first-aid", label: "First Aid & Medical Response" },
      { id: "heat-cold-stress", label: "Heat & Cold Stress Prevention" },
      { id: "occupational-health", label: "Occupational Health Monitoring" },
      { id: "vehicle-safety", label: "Vehicle & Traffic Safety" },
      { id: "machine-safety", label: "Machine & Equipment Safety" },
      { id: "toolbox-talks", label: "Toolbox Talks & Safety Briefings" },
      { id: "safety-leadership", label: "Safety Leadership & Culture" },
      { id: "security-risk", label: "Security Risk Management" },
      { id: "audit-readiness", label: "OHS Audit Readiness" },
      { id: "mental-health", label: "Mental Health & Well-Being" },
      { id: "pandemic-safety", label: "Pandemic Safety Protocols" },
      { id: "rescue-evacuation", label: "Rescue & Evacuation Planning" },
      { id: "fire-watch", label: "Fire Watch & Supervision" },
      { id: "sds-labeling", label: "SDS & Chemical Labeling" },
      { id: "emergency-disaster", label: "Natural Disaster Response Planning" },
      { id: "safety-reporting", label: "Safety Performance Reporting" },
    ],
  },
  {
    heading: "🎓 Training Delivery Modes",
    items: [
      { id: "self-paced", label: "Online Self-Paced Training" },
      { id: "live-virtual", label: "Live Virtual Workshops" },
      { id: "in-person", label: "In-Person Batch Sessions" },
      { id: "train-trainer", label: "Train-the-Trainer Programs" },
      { id: "webinars", label: "Webinars & Sector Knowledge Sharing" },
      { id: "hands-on", label: "Practical Hands-On Workshops" },
      {
        id: "blended-learning",
        label: "Blended Learning (Digital + In-Person)",
      },
    ],
  },
];
export const UPCOMING_FEATURES = [
  {
    heading: "📍 Reference Data Obtaining Tool",
    items: [
      {
        id: "automated-access",
        label: "Automated Access to Geo-Referenced Environmental & Social Data",
      },
      {
        id: "location-based-retrieval",
        label:
          "Location-Based Data Retrieval (Air, Water, Noise, Soil, Biodiversity, etc.)",
      },
      {
        id: "integration-public-sources",
        label:
          "Integration with Public & Verified Data Sources (APIs, National Databases)",
      },
      {
        id: "auto-mapping",
        label: "Auto-Mapping of Project & Site Locations (GPS/Map Interface)",
      },
      {
        id: "downloadable-snapshots",
        label:
          "Downloadable Geo-Referenced Compliance Snapshots (PDF, GeoJSON, CSV)",
      },
      {
        id: "cloud-archival",
        label:
          "Cloud-Based Archival of Geo-Referenced Data for Historical Tracking",
      },
    ],
  },
  {
    heading: "🧮 Environmental & ESG Modeling",
    items: [
      { id: "air-quality-modeling", label: "Air Quality Modeling" },
      { id: "noise-impact-modeling", label: "Noise Impact Modeling" },
      {
        id: "water-resource-modeling",
        label: "Water Resource / Watershed Modeling",
      },
      { id: "ghg-emissions-modeling", label: "GHG Emissions Modeling" },
      {
        id: "wastewater-modeling",
        label: "Wastewater Flow & Treatment Modeling",
      },
      {
        id: "soil-contamination-modeling",
        label: "Soil & Groundwater Contamination Modeling",
      },
      {
        id: "biodiversity-impact-modeling",
        label: "Biodiversity & Habitat Impact Modeling",
      },
      {
        id: "traffic-safety-modeling",
        label: "Traffic & Road Safety Impact Modeling",
      },
      {
        id: "climate-risk-modeling",
        label: "Climate Risk & Scenario Modeling (Flood, Heatwave, Drought)",
      },
      {
        id: "energy-efficiency-modeling",
        label: "Energy Efficiency & Carbon Footprint Modeling",
      },
      {
        id: "land-use-modeling",
        label: "Land Use & Urban Development Modeling",
      },
      {
        id: "ecological-carrying-capacity",
        label: "Ecological Carrying Capacity Modeling",
      },
      {
        id: "erosion-sedimentation-modeling",
        label: "Erosion & Sedimentation Modeling",
      },
      {
        id: "chemical-dispersion-modeling",
        label: "Chemical Dispersion & Spill Modeling",
      },
      {
        id: "renewable-energy-forecasting",
        label: "Renewable Energy Yield Forecasting (Solar, Wind)",
      },
      {
        id: "supply-chain-esg-modeling",
        label: "Supply Chain Carbon & ESG Risk Modeling",
      },
      {
        id: "social-impact-modeling",
        label: "Social Impact & Population Density Modeling",
      },
      {
        id: "health-risk-assessment",
        label: "Health Risk Assessment Modeling (HRA)",
      },
      {
        id: "lifecycle-assessment",
        label: "Lifecycle Assessment (LCA) Modeling",
      },
      {
        id: "financial-esg-impact",
        label: "Financial ESG Impact Modeling (Green Bonds, Carbon Pricing)",
      },
    ],
  },
  {
    heading: "🗺️ GIS Modelling Module",
    items: [
      {
        id: "environmental-impact-mapping",
        label: "Environmental Impact Mapping (Air, Noise, Water)",
      },
      {
        id: "watershed-hydrology-modeling",
        label: "Watershed & Hydrology Modeling",
      },
      { id: "floodplain-mapping", label: "Floodplain & Inundation Mapping" },
      { id: "biodiversity-mapping", label: "Biodiversity & Habitat Mapping" },
      {
        id: "climate-risk-mapping",
        label: "Climate Risk & Vulnerability Mapping",
      },
      {
        id: "land-use-change-analysis",
        label: "Land Use & Land Cover Change Analysis",
      },
      {
        id: "urban-development-mapping",
        label: "Urban Development / Zoning & Infrastructure Mapping",
      },
      {
        id: "traffic-risk-mapping",
        label: "Traffic & Road Safety Risk Mapping",
      },
      {
        id: "social-impact-mapping",
        label:
          "Social Impact Mapping (Population Density, Sensitive Receptors)",
      },
      {
        id: "supply-chain-gis-analysis",
        label: "Supply Chain & Logistics GIS Analysis",
      },
    ],
  },
  {
    heading: "🎓 Capacity Building & Certification",
    items: [
      { id: "esg-lead-auditor", label: "ESG Lead Auditor Certification" },
      { id: "ghg-verifier", label: "GHG Verifier Certification" },
      {
        id: "stakeholder-engagement",
        label: "Stakeholder Engagement Practitioner Certification",
      },
      {
        id: "social-impact-assessor",
        label: "Social Impact Assessor Certification",
      },
      { id: "ohs-auditor", label: "OHS Auditor & Inspector Certification" },
      {
        id: "climate-risk-assessor",
        label: "Climate Risk Assessor Certification",
      },
      {
        id: "esg-compliance-masterclass",
        label: "ESG Compliance & Governance Masterclass",
      },
    ],
  },
  {
    heading: "☁️ ESG Vision Cloud Data Storage & Archival",
    items: [],
  },
  {
    heading: "⚠️ Disclaimer",
    items: [],
  },
  {
    heading: "💳 Subscription",
    items: [],
  },
];
export const PREQUALIFICATION_CHECKLIST = [
  {
    heading: "✔ Legal & Company Info",
    items: [
      { id: "company-registration", label: "Company Registration Certificate" },
      { id: "business-license-tax-id", label: "Business License & Tax ID" },
      { id: "ownership-structure", label: "Company Ownership Structure" },
      { id: "board-directors", label: "Board of Directors List" },
      {
        id: "corporate-governance",
        label: "Proof of Corporate Governance Policies",
      },
    ],
  },
  {
    heading: "✔ Financial & Operational",
    items: [
      {
        id: "financial-statements",
        label: "Financial Statements (Past 3 Years)",
      },
      {
        id: "financial-stability-proof",
        label: "Proof of Financial Stability (Credit Rating, Bank Letter)",
      },
      {
        id: "insurance-coverage",
        label: "Insurance Coverage (Liability, Worker Comp, etc.)",
      },
      { id: "bank-reference-letters", label: "Bank Reference Letters" },
    ],
  },
  {
    heading: "✔ E&S Compliance",
    items: [
      { id: "environmental-policy", label: "Environmental Policy Statement" },
      {
        id: "environmental-permits",
        label: "Environmental Permits (Waste, Air, Water, EIA Approvals)",
      },
      {
        id: "ohs-policy",
        label: "OHS Policy & Certifications (ISO 45001 or equivalent)",
      },
      {
        id: "health-safety-records",
        label: "Health & Safety Performance Records (Accident/Incident Logs)",
      },
      {
        id: "social-compliance",
        label: "Social Compliance Policy (No Child / Forced Labor)",
      },
      { id: "grievance-mechanism", label: "Grievance Mechanism in Place" },
      {
        id: "anti-bribery-policy",
        label: "Anti-Bribery & Anti-Corruption Policy",
      },
      {
        id: "conflict-minerals",
        label: "Conflict Minerals / Modern Slavery Statement",
      },
      {
        id: "climate-policy",
        label: "Energy & Climate Change Policy (GHG Reduction Efforts)",
      },
    ],
  },
  {
    heading: "✔ Certifications & Awards",
    items: [
      { id: "iso-9001", label: "ISO 9001 (Quality Management)" },
      { id: "iso-14001", label: "ISO 14001 (Environmental Management)" },
      { id: "iso-45001", label: "ISO 45001 (OHS Management)" },
      {
        id: "other-certifications",
        label: "Other Certifications (LEED, Fair Trade, FSC, SA8000, B-Corp)",
      },
      { id: "awards-recognition", label: "Awards & Recognitions (if any)" },
    ],
  },
  {
    heading: "✔ Supply Chain Transparency",
    items: [
      { id: "supplier-code-conduct", label: "Supplier Code of Conduct" },
      {
        id: "subcontractor-list",
        label: "List of Subcontractors / Key Suppliers",
      },
      {
        id: "traceability-systems",
        label: "Supply Chain Traceability Systems",
      },
    ],
  },
  {
    heading: "✔ Ethics & Social Responsibility",
    items: [
      {
        id: "gender-diversity-policy",
        label: "Gender Equality & Diversity Policy",
      },
      {
        id: "human-rights-commitments",
        label: "Human Rights & Indigenous Rights Commitments",
      },
      {
        id: "community-initiatives",
        label: "Community Development Initiatives",
      },
      {
        id: "download-custom-questionnaire",
        label:
          "Download Customized Pre-Qualification Questionnaire for additional documents",
      },
      {
        id: "upload-supporting-docs",
        label:
          "Upload Additional Supporting Documents as per Customized Pre-Qualification Questionnaire",
      },
    ],
  },
];
export const ESG_ANALYTIC_SUBJECT = [
  {
    heading: "Select Your Analytical Subject",
    description: "Choose from the following focus areas:",
    items: [
      {
        id: "kpi-monitoring-performance",
        label: "📈 KPI Monitoring & Performance Tracking",
      },
      {
        id: "data-analysis-trend-visualization",
        label: "📊 Data Analysis & Trend Visualization",
      },
      {
        id: "real-time-monitoring-alerts",
        label: "🚨 Real-Time Monitoring & Alerts",
      },
      {
        id: "energy-resource-optimization",
        label: "⚡ Energy & Resource Optimization",
      },
      { id: "predictions-forecasting", label: "🔮 Predictions & Forecasting" },
      {
        id: "climate-scenario-analysis",
        label: "🌡️ Climate Scenario Analysis (TCFD-Aligned)",
      },
      { id: "carbon-market-simulation", label: "💰 Carbon Market Simulation" },
      {
        id: "emission-reduction-planning",
        label: "📉 Emission Reduction Planning",
      },
      {
        id: "benchmarking-esg-comparison",
        label: "🧭 Benchmarking & ESG Comparison",
      },
      {
        id: "reviews-ai-recommendations",
        label: "📎 Reviews & AI-Driven Recommendations",
      },
      {
        id: "regulatory-compliance-alignment",
        label: "📉 Regulatory Compliance Alignment",
      },
      {
        id: "interactive-graphs-dashboard",
        label: "🖥️ Interactive Graphs & Dashboard Visualizations",
      },
    ],
  },
];
export const ESG_AI_DRIVEN_PROCESS_OUTPUT_GEN = [
  {
    heading: "🔍 A. KPI Monitoring & Performance Tracking",
    items: [
      {
        id: "current-target-thresholds",
        label: "Current vs. Target vs. Regulatory Thresholds",
      },
      {
        id: "historical-performance-charts",
        label: "Historical Performance Charts (monthly/quarterly/yearly)",
      },
      {
        id: "rag-flags-priority-indicators",
        label: "Red, Amber, Green (RAG) flags for priority indicators",
      },
    ],
  },
  {
    heading: "📊 B. Trend Visualization",
    items: [
      {
        id: "time-series-graphs",
        label:
          "Time-series graphs for emissions, DEI, board structure, energy, water",
      },
      {
        id: "yoy-quarterly-slope-analysis",
        label: "YoY/Quarterly slope analysis for ESG intensity",
      },
      {
        id: "interactive-kpi-drilldowns",
        label: "Interactive KPI drill-downs (by site, asset, or department)",
      },
    ],
  },
  {
    heading: "⚠️ C. Real-Time Monitoring & Alerts",
    items: [
      {
        id: "live-esg-metrics-feed",
        label: "Live feed of ESG metrics via IoT or ERP systems",
      },
      {
        id: "instant-alerts",
        label: "Instant alerts on deviation from benchmarks or regulations",
      },
      {
        id: "alert-routing",
        label: "Alert routing to responsible functions (e.g., EHS, HR, Audit)",
      },
    ],
  },
  {
    heading: "🧠 D. Predictive Analytics & Forecasting",
    items: [
      {
        id: "emissions-energy-projections",
        label: "Emissions/energy projections using machine learning models",
      },
      {
        id: "kpi-underperformance-risk",
        label: "Risk of KPI underperformance (flagged as probability range)",
      },
      {
        id: "sector-specific-benchmarks",
        label: "Sector-specific emission benchmarks with future comparisons",
      },
    ],
  },
  {
    heading: "🔄 E. Energy Optimization Recommendations",
    items: [
      {
        id: "renewable-mix-shifts",
        label: "Suggested shifts to renewable mix",
      },
      {
        id: "equipment-process-efficiency",
        label: "Equipment/process efficiency improvements",
      },
      {
        id: "carbon-savings-roi",
        label: "Estimated carbon savings & ROI analysis",
      },
    ],
  },
  {
    heading: "🌍 F. Climate Risk Scenario Analysis",
    items: [
      { id: "tcfd-pathways", label: "TCFD Pathways: 1.5°C, 2°C, 4°C models" },
      {
        id: "risk-maps",
        label: "Physical & transition risk maps per facility/geography",
      },
      {
        id: "climate-adaptation-roadmaps",
        label: "AI-generated climate adaptation roadmaps",
      },
    ],
  },
  {
    heading: "💸 G. Carbon Market Simulation",
    items: [
      {
        id: "carbon-credit-forecasting",
        label: "Carbon credit volume forecasting",
      },
      {
        id: "offset-vs-reduction-potential",
        label: "Offset needs vs. internal reduction potential",
      },
      {
        id: "price-exposure-graphs",
        label: "EU ETS / VCM / GCC / JCM price exposure graphs",
      },
    ],
  },
  {
    heading: "📊 H. Benchmarking & ESG Score Comparison",
    items: [
      { id: "compare-esg-scores", label: "Compare ESG score with:" },
      { id: "msci-esg-ratings", label: "  MSCI ESG Ratings" },
      { id: "gresb-djsi-cdp", label: "  GRESB / DJSI / CDP" },
      {
        id: "regional-global-peers",
        label: "  Regional peers and global leaders",
      },
      {
        id: "kpi-percentile-rank",
        label: "KPI-specific percentile rank & maturity grade",
      },
    ],
  },
  {
    heading: "🧾 I. Reviews & AI-Driven Recommendations",
    items: [
      { id: "automated-review", label: "Automated review for:" },
      { id: "missed-targets", label: "Missed targets" },
      { id: "improvement-levers", label: "Best improvement levers" },
      {
        id: "readiness-green-finance",
        label: "Readiness for green finance, ESG ratings, or SDG alignment",
      },
    ],
  },
  {
    heading: "📈 J. Graphical Visualization & Reporting Tools",
    items: [
      {
        id: "interactive-dashboards",
        label: "Interactive dashboards (line/bar/pie/radar/heatmap)",
      },
      {
        id: "esg-report-builder",
        label: "ESG report builder with export options (PDF, XLS, API)",
      },
      {
        id: "view-filters",
        label: "View by: Materiality Theme / Site / Year / Stakeholder Focus",
      },
      {
        id: "shareable-links",
        label: "📨Shareable links with investors, board, or compliance teams",
      },
    ],
  },
];
export const INDUSTRY_SPECIFIC_STANDARD_COMPLIANCE = [
  {
    heading: "Select your Industry.",
    description: "Choose from the following industries:",
    items: [
      { id: "chemical", label: "Chemical" },
      { id: "textile-apparel", label: "Textile & Apparel" },
      { id: "electronics-technology", label: "Electronics & Technology" },
      { id: "transport-logistics", label: "Transport & Logistics" },
      {
        id: "healthcare-pharmaceuticals",
        label: "Healthcare & Pharmaceuticals",
      },
      {
        id: "agriculture-food-processing",
        label: "Agriculture & Food Processing",
      },
      {
        id: "construction-infrastructure",
        label: "Construction & Infrastructure",
      },
      { id: "manufacturing", label: "Manufacturing" },
      { id: "mining-extractives", label: "Mining & Extractives" },
      { id: "finance-investment", label: "Finance & Investment" },
      { id: "oil-gas", label: "Oil & Gas" },
      { id: "utilities", label: "Utilities" },
      { id: "energy", label: "Energy" },
      { id: "telecommunications", label: "Telecommunications" },
      { id: "automotive-mobility", label: "Automotive & Mobility" },
      { id: "retail-consumer-goods", label: "Retail & Consumer Goods" },
      { id: "real-estate", label: "Real Estate" },
      { id: "hospitality-tourism", label: "Hospitality & Tourism" },
      { id: "aviation", label: "Aviation" },
      { id: "others", label: "Others" },
    ],
  },
];
export const APPLICABLE_STANDARD_FRAMEWORK = [
  {
    heading: "Select Your Applicable Standard or Framework",
    description:
      "Choose from the following ESG, sustainability, and reporting standards:",
    items: [
      {
        id: "ifc-performance-standards",
        label: "IFC Performance Standards (1–8)",
      },
      { id: "gri", label: "GRI" },
      { id: "sasb-issb", label: "SASB / ISSB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs-s1", label: "IFRS S1" },
      { id: "ifrs-s2", label: "IFRS S2" },
      { id: "sfdr", label: "SFDR (EU)" },
      { id: "iso-14001", label: "ISO 14001" },
      { id: "iso-45001", label: "ISO 45001" },
      { id: "iso-50001", label: "ISO 50001" },
      { id: "iso-20400", label: "ISO 20400" },
      { id: "iso-21401", label: "ISO 21401" },
      { id: "iso-21930", label: "ISO 21930" },
      { id: "iso-52000", label: "ISO 52000" },
      { id: "sa8000", label: "SA8000" },
      { id: "cdp", label: "CDP" },
      { id: "reach", label: "REACH" },
      { id: "rohs", label: "RoHS" },
      { id: "weee", label: "WEEE" },
      { id: "higg-index", label: "Higg Index" },
      { id: "oeko-tex", label: "OEKO-TEX" },
      { id: "leed", label: "LEED" },
      { id: "breeam", label: "BREEAM" },
      { id: "gresb", label: "GRESB" },
      { id: "rspo", label: "RSPO Certification Standard" },
      {
        id: "rainforest-alliance",
        label: "Rainforest Alliance Sustainability Certification",
      },
      { id: "icmm", label: "ICMM" },
      { id: "gistm", label: "GISTM" },
      { id: "ogmp-2-0", label: "OGMP 2.0" },
      { id: "api-ghg", label: "API GHG" },
      { id: "ipieca", label: "IPIECA" },
      { id: "corsia", label: "CORSIA" },
      { id: "un-pri", label: "UN PRI" },
      { id: "ungc", label: "UNGC" },
      { id: "aa1000", label: "AA1000" },
      { id: "oecd", label: "OECD" },
      { id: "smartway", label: "SmartWay" },
      { id: "gsma-esg-metrics", label: "GSMA ESG Metrics" },
      { id: "gstc", label: "GSTC" },
      { id: "icma-green", label: "ICMA Green" },
      { id: "icma-social", label: "ICMA Social" },
      { id: "icma-sustainability", label: "ICMA Sustainability" },
      { id: "icma-linked-bond", label: "ICMA Linked Bond Principles" },
      { id: "equator-principles", label: "Equator Principles" },
      { id: "others", label: "Others as applicable" },
    ],
  },
];
export const Annexure_5 = [
  {
    heading: "🏢 IFC Performance Standards (1–8)",
    items: [
      {
        id: "ps1",
        label:
          "PS1: Environmental and Social Risk Assessment and Management System (ESMS)",
      },
      { id: "ps2", label: "PS2: Labor and Working Conditions" },
      { id: "ps3", label: "PS3: Resource Efficiency and Pollution Prevention" },
      { id: "ps4", label: "PS4: Community Health, Safety, and Security" },
      {
        id: "ps5",
        label: "PS5: Land Acquisition and Involuntary Resettlement",
      },
      {
        id: "ps6",
        label:
          "PS6: Biodiversity Conservation and Sustainable Management of Living Natural Resources",
      },
      { id: "ps7", label: "PS7: Indigenous Peoples" },
      { id: "ps8", label: "PS8: Cultural Heritage" },
    ],
  },
  {
    heading: "📊 GRI – Global Reporting Initiative",
    items: [
      { id: "gri-universal", label: "GRI 1–3: Universal Standards" },
      { id: "gri-biodiversity", label: "GRI 101: Biodiversity 2024" },
      { id: "gri-economic", label: "GRI 200: Economic Standards" },
      { id: "gri-environmental", label: "GRI 300: Environmental Standards" },
      { id: "gri-social", label: "GRI 400: Social Standards" },
      { id: "gri-oil-gas", label: "GRI 11 (Oil & Gas)" },
      { id: "gri-coal", label: "GRI 12 (Coal Sector 2022)" },
      { id: "gri-agriculture", label: "GRI 13 (Agriculture)" },
      { id: "gri-mining", label: "GRI 14 (Mining)" },
    ],
  },
  {
    heading: "📈 SASB / ISSB",
    items: [
      {
        id: "sasb-standards",
        label:
          "SASB: 77 industry-specific sustainability accounting standards (Refer to SASB Specific Guideline)",
      },
      {
        id: "issb-s1",
        label: "ISSB IFRS S1: General Sustainability-Related Disclosures",
      },
      {
        id: "issb-s2",
        label: "ISSB IFRS S2: Climate-Related Disclosures (aligned with TCFD)",
      },
    ],
  },
  {
    heading: "🌡️ TCFD – Task Force on Climate-related Financial Disclosures",
    items: [
      {
        id: "tcfd-governance",
        label: "Governance: Board and management oversight",
      },
      {
        id: "tcfd-strategy",
        label: "Strategy: Short-, medium-, and long-term climate impacts",
      },
      {
        id: "tcfd-risk",
        label: "Risk Management: Identifying, assessing, and managing risks",
      },
      {
        id: "tcfd-metrics",
        label:
          "Metrics and Targets: Scope 1–3 GHG emissions, internal carbon price, and transition plans",
      },
      {
        id: "tcfd-scenario",
        label: "Scenario Analysis: 1.5°C, 2°C, and 4°C pathways",
      },
    ],
  },
  {
    heading: "📋 IFRS S1 & S2",
    items: [
      {
        id: "ifrs-s1",
        label:
          "IFRS S1: General disclosures on sustainability risks and opportunities",
      },
      {
        id: "ifrs-s2",
        label:
          "IFRS S2: Climate-related disclosures; scenario analysis, Scope 1–3 emissions, transition risk",
      },
    ],
  },
  {
    heading: "🇪🇺 SFDR (EU) – Sustainable Finance Disclosure Regulation",
    items: [
      {
        id: "sfdr-article6",
        label: "Article 6: Products with no ESG objectives",
      },
      {
        id: "sfdr-article8",
        label:
          "Article 8: Products promoting environmental or social characteristics",
      },
      {
        id: "sfdr-article9",
        label: "Article 9: Products with sustainable investment objectives",
      },
      { id: "sfdr-pai", label: "Principal Adverse Impact (PAI) indicators" },
    ],
  },
  {
    heading: "🇪🇺 CSRD – Corporate Sustainability Reporting Directive (EU)",
    items: [
      {
        id: "csrd-mandatory",
        label: "Mandatory for EU-listed and large companies",
      },
      {
        id: "csrd-materiality",
        label: "Requires double materiality assessment (impact + financial)",
      },
      {
        id: "csrd-esrs",
        label: "Mandatory European Sustainability Reporting Standards (ESRS)",
      },
      {
        id: "csrd-coverage",
        label:
          "Covers: Governance, Strategy, Impact, Risks, Opportunities, Metrics & Targets",
      },
    ],
  },
  {
    heading: "🔧 ISO Standards",
    items: [
      {
        id: "iso-14001",
        label:
          "ISO 14001: Environmental Management System (EMS) - Environmental policy, aspect identification, compliance obligations, monitoring",
      },
      {
        id: "iso-45001",
        label:
          "ISO 45001: Occupational Health and Safety Management - Hazard identification, incident investigation, worker participation, performance tracking",
      },
      {
        id: "iso-50001",
        label:
          "ISO 50001: Energy Management System - Energy review, baselines, indicators, performance evaluation",
      },
      {
        id: "iso-20400",
        label:
          "ISO 20400: Sustainable Procurement - Policy alignment, lifecycle costing, supplier engagement, risk analysis",
      },
      {
        id: "iso-21401",
        label:
          "ISO 21401: Sustainability for Accommodation Sector - Environmental & social impact control, stakeholder well-being, community respect",
      },
      {
        id: "iso-21930",
        label:
          "ISO 21930: Environmental Declarations for Construction Products - Life cycle assessment (LCA), Environmental Product Declarations (EPD)",
      },
      {
        id: "iso-52000",
        label:
          "ISO 52000: Energy Performance of Buildings - Energy demand, renewable energy, energy use calculation framework",
      },
      { id: "iso-26000", label: "ISO 26000 (Social Responsibility)" },
      { id: "iso-14064", label: "ISO 14064 (GHG Accounting)" },
      { id: "iso-31000", label: "ISO 31000 (Risk Management)" },
      { id: "iso-37001", label: "ISO 37001:2025 (Anti-Bribery Management)" },
      { id: "iso-37301", label: "ISO 37301 – Compliance Management Systems" },
      {
        id: "iso-37002",
        label: "ISO 37002 – Whistleblowing Management Systems",
      },
    ],
  },
  {
    heading: "🌍 CDP – Carbon Disclosure Project",
    items: [
      { id: "cdp-climate", label: "Climate Change Questionnaire" },
      { id: "cdp-water", label: "Water Security Questionnaire" },
      { id: "cdp-forests", label: "Forests Questionnaire" },
      { id: "cdp-supply", label: "Supply Chain Program" },
      {
        id: "cdp-transition",
        label: "Transition Risk and Opportunity Disclosure",
      },
    ],
  },
  {
    heading: "⚗️ Chemical and E-Waste Regulations",
    items: [
      {
        id: "reach",
        label:
          "REACH: Chemical Registration, SDS, risk assessment, usage restrictions",
      },
      {
        id: "rohs",
        label:
          "RoHS: Prohibits hazardous substances in electronics (lead, mercury, cadmium)",
      },
      {
        id: "weee",
        label:
          "WEEE: E-waste collection, recovery, recycling targets; producer responsibility",
      },
    ],
  },
  {
    heading: "🧵 Textile Certifications",
    items: [
      {
        id: "higg-fem",
        label: "Higg Index FEM: Facility Environmental Module",
      },
      {
        id: "higg-fslm",
        label: "Higg Index FSLM: Facility Social and Labor Module",
      },
      { id: "higg-brm", label: "Higg Index BRM: Brand and Retail Module" },
      {
        id: "oeko-standard100",
        label: "OEKO-TEX STANDARD 100: Harmful substance testing",
      },
      {
        id: "oeko-made-green",
        label: "OEKO-TEX MADE IN GREEN: Product traceability",
      },
      {
        id: "oeko-step",
        label: "OEKO-TEX STeP: Sustainable textile and leather production",
      },
    ],
  },
  {
    heading: "🏗️ Green Building Certifications",
    items: [
      {
        id: "leed",
        label:
          "LEED: Energy and Atmosphere, Water Efficiency, Materials, Indoor Environmental Quality, Innovation",
      },
      {
        id: "breeam",
        label:
          "BREEAM: Management, Health & Wellbeing, Energy, Transport, Water, Materials, Waste, Ecology, Pollution",
      },
    ],
  },
  {
    heading: "🏢 GRESB – Global Real Estate Sustainability Benchmark",
    items: [
      { id: "gresb-management", label: "Management Component" },
      { id: "gresb-performance", label: "Performance Component" },
      { id: "gresb-asset", label: "Asset-Level Indicators" },
      { id: "gresb-health", label: "Health and Well-being Module" },
      { id: "gresb-resilience", label: "Resilience Module" },
    ],
  },
  {
    heading: "🌾 Agriculture & Forestry",
    items: [
      {
        id: "rspo",
        label:
          "RSPO: Principles & Criteria, Chain of Custody, Smallholder Inclusion",
      },
      {
        id: "rainforest-alliance",
        label:
          "Rainforest Alliance: Sustainable Agriculture Standard, Human Rights, Biodiversity, Climate Resilience",
      },
    ],
  },
  {
    heading: "⛏️ Mining & Extractives",
    items: [
      {
        id: "icmm",
        label:
          "ICMM: 10 Mining Principles, Performance Expectations, Tailings Governance, Water Management",
      },
      {
        id: "gistm",
        label:
          "GISTM: Governance, Planning, Operation, Monitoring & Closure of Tailings Facilities",
      },
      {
        id: "eiti",
        label:
          "EITI: Revenue transparency, contract disclosure, beneficial ownership",
      },
    ],
  },
  {
    heading: "🛢️ Oil & Gas",
    items: [
      {
        id: "ogmp",
        label:
          "OGMP 2.0: Methane Reporting Levels 1–5, Source-level data, Reconciliation methods",
      },
      {
        id: "api-ghg",
        label:
          "API GHG Compendium: Methods for flaring, venting, fugitives, combustion emissions",
      },
      {
        id: "ipieca",
        label:
          "IPIECA: ESG guidance on climate, health, biodiversity, water, and stakeholder engagement",
      },
    ],
  },
  {
    heading: "✈️ Aviation",
    items: [
      {
        id: "corsia",
        label:
          "CORSIA: MRV (Monitoring, Reporting, Verification), eligible offset criteria, baseline emissions",
      },
    ],
  },
  {
    heading: "💰 Finance & Investment",
    items: [
      {
        id: "un-pri",
        label:
          "UN PRI: Six Principles for ESG investing, ESG integration, stewardship, disclosure",
      },
      {
        id: "ungc",
        label:
          "UNGC: Ten Principles – Human Rights, Labour, Environment, Anti-Corruption",
      },
      {
        id: "aa1000",
        label:
          "AA1000: Inclusivity, Materiality, and Responsiveness (Stakeholder Engagement Standard)",
      },
      {
        id: "oecd",
        label:
          "OECD: Multinational enterprise guidelines, supply chain due diligence, anti-bribery",
      },
    ],
  },
  {
    heading: "🚛 Logistics, Telecom & Tourism",
    items: [
      {
        id: "smartway",
        label:
          "SmartWay (EPA): Emissions tracking, fuel efficiency benchmarking, carrier ratings",
      },
      {
        id: "gsma",
        label:
          "GSMA ESG Metrics: Climate metrics, energy use, digital inclusion, privacy, e-waste",
      },
      {
        id: "gstc",
        label:
          "GSTC: Criteria for Hotels, Tour Operators, and Destinations; environmental, socio-cultural sustainability",
      },
    ],
  },
  {
    heading: "💚 Sustainable Finance (ICMA)",
    items: [
      {
        id: "icma-gbp",
        label:
          "ICMA Green Bond Principles: Use of proceeds, evaluation process, impact reporting",
      },
      {
        id: "icma-sbp",
        label:
          "ICMA Social Bond Principles: Targeting affordable housing, education, health, financial inclusion",
      },
      {
        id: "icma-sbg",
        label:
          "ICMA Sustainability Bond Guidelines: Combined green + social bond requirements",
      },
      {
        id: "icma-slbp",
        label:
          "ICMA Sustainability-Linked Bond Principles: SPTs (targets), KPIs, penalties/incentives for performance",
      },
    ],
  },
  {
    heading: "⚖️ Equator Principles",
    items: [
      { id: "ep-categorization", label: "Project Categorization (A/B/C)" },
      { id: "ep-due-diligence", label: "E&S Due Diligence" },
      { id: "ep-esmp", label: "ESMP requirements" },
      { id: "ep-esia", label: "ESIA requirements" },
      { id: "ep-action-plans", label: "Action Plans and Management Systems" },
      {
        id: "ep-stakeholder",
        label: "Stakeholder Engagement and Grievance Mechanism",
      },
    ],
  },
  {
    heading: "🌡️ Climate Bonds Initiative (CBI)",
    items: [
      {
        id: "cbi-taxonomy",
        label:
          "Climate Bond Taxonomy: Energy, transport, water, buildings, land use",
      },
      {
        id: "cbi-sector",
        label:
          "Sector Criteria: Eligibility criteria for green bonds (e.g., solar, wind, rail, waste)",
      },
      {
        id: "cbi-certification",
        label:
          "Certification Process: Pre-issuance and post-issuance verification",
      },
      {
        id: "cbi-reporting",
        label:
          "Reporting & Assurance: Climate bond reporting and impact measurement",
      },
    ],
  },
  {
    heading: "🌍 UN SDGs – United Nations Sustainable Development Goals",
    items: [
      { id: "sdg-1", label: "1. No Poverty" },
      { id: "sdg-2", label: "2. Zero Hunger" },
      { id: "sdg-3", label: "3. Good Health and Well-being" },
      { id: "sdg-4", label: "4. Quality Education" },
      { id: "sdg-5", label: "5. Gender Equality" },
      { id: "sdg-6", label: "6. Clean Water and Sanitation" },
      { id: "sdg-7", label: "7. Affordable and Clean Energy" },
      { id: "sdg-8", label: "8. Decent Work and Economic Growth" },
      { id: "sdg-9", label: "9. Industry, Innovation and Infrastructure" },
      { id: "sdg-10", label: "10. Reduced Inequalities" },
      { id: "sdg-11", label: "11. Sustainable Cities and Communities" },
      { id: "sdg-12", label: "12. Responsible Consumption and Production" },
      { id: "sdg-13", label: "13. Climate Action" },
      { id: "sdg-14", label: "14. Life Below Water" },
      { id: "sdg-15", label: "15. Life on Land" },
      { id: "sdg-16", label: "16. Peace, Justice and Strong Institutions" },
      { id: "sdg-17", label: "17. Partnerships for the Goals" },
      {
        id: "sdg-targets",
        label:
          "169 Targets addressing poverty, inequality, education, climate, ecosystems, peace, and partnerships",
      },
      {
        id: "sdg-compass",
        label: "Corporate Alignment Tools: SDG Compass, SDG Action Manager",
      },
      {
        id: "sdg-disclosure",
        label:
          "Disclosure Linkage: Mapped into GRI, SASB, TCFD, and Integrated Reporting frameworks",
      },
    ],
  },
  {
    heading: "📋 Integrated Reporting Framework (IR)",
    items: [
      { id: "ir-financial", label: "Six Capitals: Financial" },
      { id: "ir-manufactured", label: "Six Capitals: Manufactured" },
      { id: "ir-human", label: "Six Capitals: Human" },
      { id: "ir-social", label: "Six Capitals: Social & Relationship" },
      { id: "ir-intellectual", label: "Six Capitals: Intellectual" },
      { id: "ir-natural", label: "Six Capitals: Natural" },
      { id: "ir-strategic", label: "Guiding Principles: Strategic focus" },
      { id: "ir-connectivity", label: "Guiding Principles: Connectivity" },
      {
        id: "ir-stakeholder",
        label: "Guiding Principles: Stakeholder relationships",
      },
      { id: "ir-materiality", label: "Guiding Principles: Materiality" },
      {
        id: "ir-organizational",
        label: "Content Elements: Organizational overview",
      },
      { id: "ir-governance", label: "Content Elements: Governance" },
      { id: "ir-risks", label: "Content Elements: Risks" },
      { id: "ir-strategy", label: "Content Elements: Strategy" },
      { id: "ir-performance", label: "Content Elements: Performance" },
      { id: "ir-outlook", label: "Content Elements: Outlook" },
    ],
  },
  {
    heading: "🌿 TNFD – Taskforce on Nature-related Financial Disclosures",
    items: [
      {
        id: "tnfd-leap",
        label: "LEAP Approach: Locate, Evaluate, Assess, Prepare",
      },
      { id: "tnfd-governance", label: "Four Pillars: Governance" },
      { id: "tnfd-strategy", label: "Four Pillars: Strategy" },
      { id: "tnfd-risk", label: "Four Pillars: Risk & Impact Management" },
      { id: "tnfd-metrics", label: "Four Pillars: Metrics & Targets" },
      {
        id: "tnfd-nature-risks",
        label:
          "Nature-related risks: Dependency and impact on land, freshwater, oceans, biodiversity",
      },
    ],
  },
  {
    heading: "👷 SA8000 – Social Accountability International",
    items: [
      {
        id: "sa8000-labor",
        label:
          "Labor Rights: Child labor, forced labor, health and safety, discrimination",
      },
      {
        id: "sa8000-association",
        label: "Freedom of Association: Unionization and collective bargaining",
      },
      {
        id: "sa8000-working",
        label: "Working Hours and Compensation: Alignment with ILO Conventions",
      },
    ],
  },
  {
    heading: "🌾 GRASP – GLOBALG.A.P. Risk Assessment on Social Practice",
    items: [
      {
        id: "grasp-focus",
        label:
          "Focus Areas: Labor rights in agriculture, wages, contracts, grievance mechanism",
      },
      {
        id: "grasp-integration",
        label: "Integrated into: GLOBALG.A.P. farm certifications",
      },
      {
        id: "grasp-applicable",
        label: "Applicable For: Fresh produce supply chains",
      },
    ],
  },
  {
    heading: "📊 IIRC (International Integrated Reporting Council)",
    items: [
      {
        id: "iirc-integration",
        label: "Framework Integration: Combines financial and ESG disclosures",
      },
      {
        id: "iirc-value",
        label: "Value Creation Model: Capital inputs and outcomes over time",
      },
      {
        id: "iirc-materiality",
        label: "Materiality & Conciseness: Forward-looking ESG strategy",
      },
    ],
  },
  {
    heading: "💧 WWF Water Risk Filter",
    items: [
      {
        id: "wwf-modules",
        label:
          "Modules: Water Risk Assessment, Scenario Planning, Risk Response Actions",
      },
      {
        id: "wwf-indicators",
        label:
          "Indicators: Physical, regulatory, reputational risks across supply chains",
      },
      {
        id: "wwf-alignment",
        label: "Alignment: Supports CDP Water, TCFD, and Science-Based Targets",
      },
    ],
  },
  {
    heading: "🎯 SBTi – Science Based Targets initiative",
    items: [
      {
        id: "sbti-scope",
        label: "Scope Coverage: Scope 1, 2, and 3 emission targets",
      },
      {
        id: "sbti-net-zero",
        label:
          "Net-Zero Standard: 1.5°C aligned pathways, sector-specific criteria",
      },
      {
        id: "sbti-validation",
        label:
          "Target Validation Protocol: Formal approval of reduction commitments",
      },
    ],
  },
  {
    heading: "🌳 FSC – Forest Stewardship Council",
    items: [
      {
        id: "fsc-principles",
        label:
          "Core Principles: Sustainable forest management, biodiversity protection, indigenous rights",
      },
      { id: "fsc-100", label: "FSC 100% (from certified forests)" },
      { id: "fsc-mix", label: "FSC Mix (blend of certified/recycled)" },
      { id: "fsc-recycled", label: "FSC Recycled (post-consumer materials)" },
      { id: "fsc-coc", label: "Chain of Custody (CoC) Certification" },
      { id: "fsc-controlled", label: "Controlled Wood Standard" },
    ],
  },
  {
    heading: "🍽️ ISO 22000 – Food Safety Management",
    items: [
      {
        id: "iso22000-haccp",
        label: "Hazard Analysis and Critical Control Points (HACCP)",
      },
      {
        id: "iso22000-traceability",
        label: "Food Chain Traceability & Risk Control",
      },
      { id: "iso22000-iso9001", label: "Integration with ISO 9001" },
      { id: "iso22000-iso14001", label: "Integration with ISO 14001" },
    ],
  },
  {
    heading: "⚖️ ILO Core Labour Standards",
    items: [
      { id: "ilo-forced", label: "Key Conventions: Forced labor" },
      { id: "ilo-child", label: "Key Conventions: Child labor" },
      {
        id: "ilo-discrimination",
        label: "Key Conventions: Non-discrimination",
      },
      {
        id: "ilo-association",
        label: "Key Conventions: Freedom of association",
      },
      { id: "ilo-ifc-ps2", label: "Referenced in: IFC PS2" },
      { id: "ilo-ungc", label: "Referenced in: UNGC" },
      { id: "ilo-sa8000", label: "Referenced in: SA8000" },
      { id: "ilo-oecd", label: "Referenced in: OECD Due Diligence" },
    ],
  },
  {
    heading: "🛡️ UNEP FI Principles for Sustainable Insurance (PSI)",
    items: [
      {
        id: "psi-principles",
        label:
          "Four Principles: ESG integration in underwriting, client engagement, transparency",
      },
    ],
  },
  {
    heading: "📈 IRIS+ (GIIN) – Impact Measurement for Investors",
    items: [
      {
        id: "iris-metrics",
        label:
          "Standardized metrics for impact investing (IRIS Version 5.3a Matrix)",
      },
    ],
  },
];
export const FOCUS_AREA_SECTOR_SPECIFIC = [
  {
    heading: "Select Your Key Focus Areas",
    description:
      "Choose applicable focus areas for ESG, sustainability, and impact reporting:",
    items: [
      {
        id: "ghg-emissions",
        label:
          "Greenhouse Gas (GHG) Emissions: Scope 1, 2, 3, and 4 (Avoided Emissions)",
      },
      { id: "resource-use-water", label: "Resource Use: Water" },
      { id: "resource-use-waste", label: "Resource Use: Waste" },
      { id: "resource-use-energy", label: "Resource Use: Energy" },
      { id: "resource-use-materials", label: "Resource Use: Materials" },
      { id: "biodiversity", label: "Biodiversity" },
      { id: "land-use-change", label: "Land Use Change" },
      { id: "hazardous-materials", label: "Hazardous Materials" },
      { id: "chemical-management", label: "Chemical Management" },
      {
        id: "labor-rights",
        label:
          "Labor Conditions, Worker Safety, Human Rights (incl. Migrant Labor)",
      },
      {
        id: "dei-gender-equality",
        label: "Diversity, Equity, Inclusion (DEI) & Gender Equality",
      },
      {
        id: "climate-risk",
        label: "Climate Risk (Transition + Physical), Adaptation & Resilience",
      },
      {
        id: "circular-economy",
        label: "Circular Economy: Reuse, Recyclability, Design, EPR",
      },
      { id: "cybersecurity", label: "Cybersecurity" },
      { id: "consumer-rights", label: "Consumer Rights" },
      { id: "product-lifecycle", label: "Product Lifecycle Safety" },
      {
        id: "financial-esg-green-bond",
        label: "Financial ESG Integration: Green Bonds",
      },
      {
        id: "financial-esg-social-bond",
        label: "Financial ESG Integration: Social Bonds",
      },
      { id: "financial-esg-sllps", label: "Financial ESG Integration: SLLPs" },
      { id: "sdg-finance", label: "SDG Finance" },
      { id: "community-engagement", label: "Community Engagement" },
      { id: "resettlement-fpic", label: "Resettlement and FPIC" },
      { id: "cultural-heritage", label: "Cultural Heritage Protection" },
    ],
  },
];
export const COMPANY_IDENTIFICATION_OPERATIONAL = [
  {
    heading: "Industrial Identification",
    description:
      "Let's Understand Your Work to Build the Right ESG Reporting Path!",
    items: [
      {
        id: "construction-infrastructure",
        label: "Construction & Infrastructure",
      },
      {
        id: "manufacturing",
        label: "Manufacturing (Food, Industrial Goods, Chemicals)",
      },
      {
        id: "energy",
        label: "Energy (Renewable, Fossil, Transmission, Distribution)",
      },
      { id: "it-data-centers", label: "IT & Data Centers" },
      { id: "warehousing-logistics", label: "Warehousing & Logistics" },
      {
        id: "transportation-mobility",
        label: "Transportation & Mobility Services",
      },
      {
        id: "agriculture-food-processing",
        label: "Agriculture & Food Processing",
      },
      { id: "mining-extractives", label: "Mining and Extractives" },
      { id: "retail-consumer-goods", label: "Retail and Consumer Goods" },
      {
        id: "healthcare-pharmaceuticals",
        label: "Healthcare and Pharmaceuticals",
      },
      { id: "financial-insurance", label: "Financial and Insurance Services" },
      {
        id: "public-services-government",
        label: "Public Services / Government Projects",
      },
      {
        id: "consulting-professional",
        label: "Consulting and Professional Services",
      },
      { id: "telecom-media", label: "Telecommunications and Media" },
      { id: "others", label: "Others (Custom entry field)" },
    ],
  },
];
export const ACTIVITY_SPECIFICATION_OPERATIONAL = [
  {
    heading: "Nature of Activities",
    description:
      "Select the activities that apply to build the right ESG reporting path!",
    items: [
      {
        id: "new-construction",
        label: "New Construction (Buildings, Roads, Infrastructure, Bridges)",
      },
      {
        id: "plant-operations",
        label: "Plant Operations (Industrial Production, Chemical Processing)",
      },
      {
        id: "equipment-installation",
        label: "Equipment Installation, Commissioning, and Testing",
      },
      {
        id: "survey-monitoring",
        label: "Survey, Monitoring, Inspection Field Work",
      },
      {
        id: "logistics-warehousing",
        label: "Logistics and Warehousing Operations",
      },
      {
        id: "procurement-supplier",
        label: "Procurement, Supplier, and Vendor Management",
      },
      {
        id: "administration-corporate",
        label: "Administration and Corporate Office Operations",
      },
      { id: "vehicle-fleet", label: "Vehicle Fleet and Transport Management" },
      { id: "maintenance-repair", label: "Maintenance and Repair Services" },
      {
        id: "renewable-energy",
        label: "Renewable Energy Operations (Solar, Wind, Hydro, Hybrid)",
      },
      {
        id: "waste-management",
        label: "Waste Collection, Management, Recycling, Disposal",
      },
      {
        id: "water-management",
        label: "Water Extraction, Supply, and Wastewater Treatment",
      },
      {
        id: "land-management",
        label: "Land Management and Restoration Activities",
      },
      {
        id: "biodiversity-protection",
        label: "Biodiversity Protection and Conservation Programs",
      },
      {
        id: "other-activities",
        label: "Other Activities (Specify in text field)",
      },
    ],
  },
];
export const REQUIREMENT_SELECTION_INT_EXT_OPERATIONAL = [
  {
    heading: "Internal Reporting Needs",
    description:
      "Select the internal ESG reporting needs to align with your sustainability goals!",
    items: [
      {
        id: "progress-monitoring",
        label: "Progress Monitoring on Internal ESG Targets",
      },
      {
        id: "environmental-monitoring",
        label: "Internal Environmental Monitoring (Air, Water, Waste)",
      },
      {
        id: "ohs-compliance",
        label: "Occupational Health & Safety (OHS) Compliance Tracking",
      },
      {
        id: "labor-human-rights",
        label:
          "Labor and Human Rights (Diversity, Equity, Inclusion) Monitoring",
      },
      {
        id: "community-engagement",
        label: "Community Engagement and CSR Activity Tracking",
      },
      {
        id: "supply-chain-esg",
        label: "Internal Supply Chain ESG Performance Tracking",
      },
      {
        id: "employee-welfare",
        label: "Employee Welfare and Gender Equality Status",
      },
      {
        id: "energy-carbon",
        label: "Energy Efficiency and Carbon Footprint Monitoring",
      },
    ],
  },
  {
    heading: "External Reporting Requirements",
    description:
      "Select the external ESG reporting requirements to meet regulatory and stakeholder expectations!",
    items: [
      {
        id: "regulatory-compliance",
        label: "Regulatory Compliance (Local, Federal Laws)",
      },
      {
        id: "canada-priority-laws",
        label:
          "APAC Priority Laws (Singapore EPMA, Malaysia EQA, Indonesia UU 32/2009, Vietnam LEP, Thailand NEQA, Philippines Clean Air/Water Acts)",
      },
      {
        id: "iso-standards",
        label: "ISO Standards Compliance (ISO 14001, ISO 45001, ISO 26000)",
      },
      {
        id: "ifc-standards",
        label: "IFC Performance Standards (PS1-PS8) Compliance",
      },
      {
        id: "gri-standards",
        label: "GRI Standards (Core or Comprehensive) Reporting",
      },
      { id: "sasb-reporting", label: "SASB Materiality-Based ESG Reporting" },
      { id: "ungc-cop", label: "UNGC Communication on Progress (COP)" },
      {
        id: "csrd-esrs",
        label: "CSRD/ESRS (EU Corporate Sustainability Reporting Directive)",
      },
      {
        id: "client-investor-esg",
        label: "Client, Investor, or Lender ESG Compliance Requests",
      },
      {
        id: "public-disclosure",
        label: "Public Sustainability Disclosure Reports (Voluntary)",
      },
    ],
  },
];
export const COMPANY_ACTIVITY_SETUP = [
  {
    heading: "📋 Basic Details",
    items: [
      { id: "project-facility-name", label: "Project/Facility Name" },
      { id: "company-name", label: "Company Name" },
      {
        id: "sector-industry-type",
        label: "Sector / Industry Type (Dropdown selection)",
      },
      { id: "location", label: "Country / Province / District" },
      { id: "site-gps-location", label: "Site GPS Location (Optional)" },
      {
        id: "ownership-type",
        label: "Ownership Type",
        subItems: [
          { id: "ownership-private", label: "Private" },
          { id: "ownership-public", label: "Public" },
          { id: "ownership-jv", label: "JV" },
          { id: "ownership-ppp", label: "PPP" },
        ],
      },
      {
        id: "funding-source",
        label: "Funding Source",
        subItems: [
          { id: "funding-equity", label: "Equity" },
          { id: "funding-debt", label: "Debt" },
          { id: "funding-multilateral", label: "Multilateral" },
          { id: "funding-other", label: "Other" },
        ],
      },
    ],
  },
  {
    heading: "🏭 Activities/Operations",
    items: [
      {
        id: "construction",
        label: "Construction (Buildings, Roads, Infrastructure)",
      },
      {
        id: "manufacturing-processing",
        label: "Manufacturing / Processing Facility",
      },
      {
        id: "warehousing-logistics",
        label: "Warehousing / Logistics Operations",
      },
      {
        id: "agriculture-forestry-aquaculture",
        label: "Agriculture / Forestry / Aquaculture",
      },
      {
        id: "energy-generation-transmission",
        label: "Energy Generation / Transmission (Solar, Wind, Hydro, Gas)",
      },
      { id: "mining-extraction", label: "Mining and Extraction" },
      {
        id: "water-extraction-treatment",
        label: "Water Extraction / Treatment",
      },
      { id: "chemical-handling-storage", label: "Chemical Handling / Storage" },
      {
        id: "transportation-shipping",
        label: "Transportation / Shipping Operations",
      },
      { id: "retail-office", label: "Retail / Office Facility" },
      { id: "other-activity", label: "Other" },
    ],
  },
  {
    heading: "📍 Reference Data Obtaining Tool",
    items: [
      {
        id: "automated-access",
        label: "Automated Access to Geo-Referenced Environmental & Social Data",
      },
      {
        id: "location-based-retrieval",
        label:
          "Location-Based Data Retrieval (Air, Water, Noise, Soil, Biodiversity, etc.)",
      },
      {
        id: "integration-public-sources",
        label:
          "Integration with Public & Verified Data Sources (APIs, National Databases)",
      },
      {
        id: "auto-mapping",
        label: "Auto-Mapping of Project & Site Locations (GPS/Map Interface)",
      },
      {
        id: "downloadable-snapshots",
        label:
          "Downloadable Geo-Referenced Compliance Snapshots (PDF, GeoJSON, CSV)",
      },
      {
        id: "cloud-archival",
        label:
          "Cloud-Based Archival of Geo-Referenced Data for Historical Tracking",
      },
    ],
  },
  {
    heading: "🧮 Environmental & ESG Modeling",
    items: [
      { id: "air-quality-modeling", label: "Air Quality Modeling" },
      { id: "noise-impact-modeling", label: "Noise Impact Modeling" },
      {
        id: "water-resource-modeling",
        label: "Water Resource / Watershed Modeling",
      },
      { id: "ghg-emissions-modeling", label: "GHG Emissions Modeling" },
      {
        id: "wastewater-modeling",
        label: "Wastewater Flow & Treatment Modeling",
      },
      {
        id: "soil-contamination-modeling",
        label: "Soil & Groundwater Contamination Modeling",
      },
      {
        id: "biodiversity-impact-modeling",
        label: "Biodiversity & Habitat Impact Modeling",
      },
      {
        id: "traffic-safety-modeling",
        label: "Traffic & Road Safety Impact Modeling",
      },
      {
        id: "climate-risk-modeling",
        label: "Climate Risk & Scenario Modeling (Flood, Heatwave, Drought)",
      },
      {
        id: "energy-efficiency-modeling",
        label: "Energy Efficiency & Carbon Footprint Modeling",
      },
      {
        id: "land-use-modeling",
        label: "Land Use & Urban Development Modeling",
      },
      {
        id: "ecological-carrying-capacity",
        label: "Ecological Carrying Capacity Modeling",
      },
      {
        id: "erosion-sedimentation-modeling",
        label: "Erosion & Sedimentation Modeling",
      },
      {
        id: "chemical-dispersion-modeling",
        label: "Chemical Dispersion & Spill Modeling",
      },
      {
        id: "renewable-energy-forecasting",
        label: "Renewable Energy Yield Forecasting (Solar, Wind)",
      },
      {
        id: "supply-chain-esg-modeling",
        label: "Supply Chain Carbon & ESG Risk Modeling",
      },
      {
        id: "social-impact-modeling",
        label: "Social Impact & Population Density Modeling",
      },
      {
        id: "health-risk-assessment",
        label: "Health Risk Assessment Modeling (HRA)",
      },
      {
        id: "lifecycle-assessment",
        label: "Lifecycle Assessment (LCA) Modeling",
      },
      {
        id: "financial-esg-impact",
        label: "Financial ESG Impact Modeling (Green Bonds, Carbon Pricing)",
      },
    ],
  },
  {
    heading: "🗺️ GIS Modelling Module",
    items: [
      {
        id: "environmental-impact-mapping",
        label: "Environmental Impact Mapping (Air, Noise, Water)",
      },
      {
        id: "watershed-hydrology-modeling",
        label: "Watershed & Hydrology Modeling",
      },
      { id: "floodplain-mapping", label: "Floodplain & Inundation Mapping" },
      { id: "biodiversity-mapping", label: "Biodiversity & Habitat Mapping" },
      {
        id: "climate-risk-mapping",
        label: "Climate Risk & Vulnerability Mapping",
      },
      {
        id: "land-use-change-analysis",
        label: "Land Use & Land Cover Change Analysis",
      },
      {
        id: "urban-development-mapping",
        label: "Urban Development / Zoning & Infrastructure Mapping",
      },
      {
        id: "traffic-risk-mapping",
        label: "Traffic & Road Safety Risk Mapping",
      },
      {
        id: "social-impact-mapping",
        label:
          "Social Impact Mapping (Population Density, Sensitive Receptors)",
      },
      {
        id: "supply-chain-gis-analysis",
        label: "Supply Chain & Logistics GIS Analysis",
      },
    ],
  },
  {
    heading: "🎓 Capacity Building & Certification",
    items: [
      { id: "esg-lead-auditor", label: "ESG Lead Auditor Certification" },
      { id: "ghg-verifier", label: "GHG Verifier Certification" },
      {
        id: "stakeholder-engagement",
        label: "Stakeholder Engagement Practitioner Certification",
      },
      {
        id: "social-impact-assessor",
        label: "Social Impact Assessor Certification",
      },
      { id: "ohs-auditor", label: "OHS Auditor & Inspector Certification" },
      {
        id: "climate-risk-assessor",
        label: "Climate Risk Assessor Certification",
      },
      {
        id: "esg-compliance-masterclass",
        label: "ESG Compliance & Governance Masterclass",
      },
    ],
  },
  {
    heading: "☁️ ESG Vision Cloud Data Storage & Archival",
    items: [],
  },
  {
    heading: "⚠️ Disclaimer",
    items: [],
  },
  {
    heading: "💳 Subscription",
    items: [],
  },
];

export const Annexure_6 = [
  {
    heading: "📍 Reference Data Obtaining Tool",
    items: [
      {
        id: "automated-access",
        label: "Automated Access to Geo-Referenced Environmental & Social Data",
      },
      {
        id: "location-based-retrieval",
        label:
          "Location-Based Data Retrieval (Air, Water, Noise, Soil, Biodiversity, etc.)",
      },
      {
        id: "integration-public-sources",
        label:
          "Integration with Public & Verified Data Sources (APIs, National Databases)",
      },
      {
        id: "auto-mapping",
        label: "Auto-Mapping of Project & Site Locations (GPS/Map Interface)",
      },
      {
        id: "downloadable-snapshots",
        label:
          "Downloadable Geo-Referenced Compliance Snapshots (PDF, GeoJSON, CSV)",
      },
      {
        id: "cloud-archival",
        label:
          "Cloud-Based Archival of Geo-Referenced Data for Historical Tracking",
      },
    ],
  },
  {
    heading: "🧮 Environmental & ESG Modeling",
    items: [
      { id: "air-quality-modeling", label: "Air Quality Modeling" },
      { id: "noise-impact-modeling", label: "Noise Impact Modeling" },
      {
        id: "water-resource-modeling",
        label: "Water Resource / Watershed Modeling",
      },
      { id: "ghg-emissions-modeling", label: "GHG Emissions Modeling" },
      {
        id: "wastewater-modeling",
        label: "Wastewater Flow & Treatment Modeling",
      },
      {
        id: "soil-contamination-modeling",
        label: "Soil & Groundwater Contamination Modeling",
      },
      {
        id: "biodiversity-impact-modeling",
        label: "Biodiversity & Habitat Impact Modeling",
      },
      {
        id: "traffic-safety-modeling",
        label: "Traffic & Road Safety Impact Modeling",
      },
      {
        id: "climate-risk-modeling",
        label: "Climate Risk & Scenario Modeling (Flood, Heatwave, Drought)",
      },
      {
        id: "energy-efficiency-modeling",
        label: "Energy Efficiency & Carbon Footprint Modeling",
      },
      {
        id: "land-use-modeling",
        label: "Land Use & Urban Development Modeling",
      },
      {
        id: "ecological-carrying-capacity",
        label: "Ecological Carrying Capacity Modeling",
      },
      {
        id: "erosion-sedimentation-modeling",
        label: "Erosion & Sedimentation Modeling",
      },
      {
        id: "chemical-dispersion-modeling",
        label: "Chemical Dispersion & Spill Modeling",
      },
      {
        id: "renewable-energy-forecasting",
        label: "Renewable Energy Yield Forecasting (Solar, Wind)",
      },
      {
        id: "supply-chain-esg-modeling",
        label: "Supply Chain Carbon & ESG Risk Modeling",
      },
      {
        id: "social-impact-modeling",
        label: "Social Impact & Population Density Modeling",
      },
      {
        id: "health-risk-assessment",
        label: "Health Risk Assessment Modeling (HRA)",
      },
      {
        id: "lifecycle-assessment",
        label: "Lifecycle Assessment (LCA) Modeling",
      },
      {
        id: "financial-esg-impact",
        label: "Financial ESG Impact Modeling (Green Bonds, Carbon Pricing)",
      },
    ],
  },
  {
    heading: "🗺️ GIS Modelling Module",
    items: [
      {
        id: "environmental-impact-mapping",
        label: "Environmental Impact Mapping (Air, Noise, Water)",
      },
      {
        id: "watershed-hydrology-modeling",
        label: "Watershed & Hydrology Modeling",
      },
      { id: "floodplain-mapping", label: "Floodplain & Inundation Mapping" },
      { id: "biodiversity-mapping", label: "Biodiversity & Habitat Mapping" },
      {
        id: "climate-risk-mapping",
        label: "Climate Risk & Vulnerability Mapping",
      },
      {
        id: "land-use-change-analysis",
        label: "Land Use & Land Cover Change Analysis",
      },
      {
        id: "urban-development-mapping",
        label: "Urban Development / Zoning & Infrastructure Mapping",
      },
      {
        id: "traffic-risk-mapping",
        label: "Traffic & Road Safety Risk Mapping",
      },
      {
        id: "social-impact-mapping",
        label:
          "Social Impact Mapping (Population Density, Sensitive Receptors)",
      },
      {
        id: "supply-chain-gis-analysis",
        label: "Supply Chain & Logistics GIS Analysis",
      },
    ],
  },
  {
    heading: "🎓 Capacity Building & Certification",
    items: [
      { id: "esg-lead-auditor", label: "ESG Lead Auditor Certification" },
      { id: "ghg-verifier", label: "GHG Verifier Certification" },
      {
        id: "stakeholder-engagement",
        label: "Stakeholder Engagement Practitioner Certification",
      },
      {
        id: "social-impact-assessor",
        label: "Social Impact Assessor Certification",
      },
      { id: "ohs-auditor", label: "OHS Auditor & Inspector Certification" },
      {
        id: "climate-risk-assessor",
        label: "Climate Risk Assessor Certification",
      },
      {
        id: "esg-compliance-masterclass",
        label: "ESG Compliance & Governance Masterclass",
      },
    ],
  },
  {
    heading: "☁️ ESG Vision Cloud Data Storage & Archival",
    items: [],
  },
  {
    heading: "⚠️ Disclaimer",
    items: [],
  },
  {
    heading: "💳 Subscription",
    items: [],
  },
];

export const getAnnexure9 = (countryName) => {
  const normalizedCountry = countryName?.trim();

  if (normalizedCountry === "Singapore") {
    return [
      {
        heading: "Singapore Reports / Assessments / Analysis",
        items: [
          { id: "singapore-report-1", label: "Singapore Environmental & ESHS Legal Compliance Report" },
          { id: "singapore-report-2", label: "Singapore Environmental Permit / Licence Register" },
          { id: "singapore-report-3", label: "Singapore Air Emissions & Ambient Air Compliance Assessment" },
          { id: "singapore-report-4", label: "Singapore Trade Effluent / Sewer Discharge Compliance Assessment" },
          { id: "singapore-report-5", label: "Singapore Toxic Industrial Waste & General Waste Compliance Report" },
          { id: "singapore-report-6", label: "Singapore Hazardous Substances Compliance Assessment" },
          { id: "singapore-report-7", label: "Singapore Resource Sustainability / EPR Compliance Assessment" },
          { id: "singapore-report-8", label: "Singapore Carbon Pricing Act Applicability & Compliance Report" },
          { id: "singapore-report-9", label: "Singapore GHG Measurement, Reporting & Verification Readiness Report" },
          { id: "singapore-report-10", label: "Singapore Energy Conservation Act Compliance Assessment" },
          { id: "singapore-report-11", label: "Singapore Workplace Safety & Health Compliance Report" },
          { id: "singapore-report-12", label: "Singapore Major Hazard Installation / Process Safety Readiness Assessment" },
          { id: "singapore-report-13", label: "Singapore Fire Safety Compliance Assessment" },
          { id: "singapore-report-14", label: "Singapore Biodiversity / Wildlife / Protected Area Screening" },
          { id: "singapore-report-15", label: "Singapore SGX Sustainability Reporting Compliance Assessment" },
          { id: "singapore-report-16", label: "Singapore ACRA Climate / Sustainability Reporting Applicability Assessment" },
          { id: "singapore-report-17", label: "Singapore Sustainability Disclosure & Assurance Readiness Report" },
          { id: "singapore-report-18", label: "Singapore ESG Compliance Gap & CAPA Register" },
        ],
      },
    ];
  }

  if (normalizedCountry === "Malaysia") {
    return [
      {
        heading: "Malaysia Reports / Assessments / Analysis",
        items: [
          { id: "malaysia-report-1", label: "Malaysia Federal Environmental & ESHS Compliance Report" },
          { id: "malaysia-report-2", label: "Malaysia State Environmental / Natural Resources Compliance Report" },
          { id: "malaysia-report-3", label: "Malaysia EIA Applicability & Approval Compliance Assessment" },
          { id: "malaysia-report-4", label: "Malaysia Clean Air Regulations Compliance Assessment" },
          { id: "malaysia-report-5", label: "Malaysia Industrial Effluent / Sewage Compliance Assessment" },
          { id: "malaysia-report-6", label: "Malaysia Scheduled Waste Compliance Report" },
          { id: "malaysia-report-7", label: "Malaysia Hazardous Chemicals / USECHH / CLASS Compliance Assessment" },
          { id: "malaysia-report-8", label: "Malaysia CHRA & Medical Surveillance Status Review" },
          { id: "malaysia-report-9", label: "Malaysia OSHA Compliance Report" },
          { id: "malaysia-report-10", label: "Malaysia CDM 2024 Construction Safety Compliance Assessment" },
          { id: "malaysia-report-11", label: "Malaysia Plant / Machinery Compliance Register" },
          { id: "malaysia-report-12", label: "Malaysia Water & Sewerage Compliance Assessment" },
          { id: "malaysia-report-13", label: "Malaysia Biodiversity / Forestry / Wildlife Compliance Assessment" },
          { id: "malaysia-report-14", label: "Malaysia Sabah Environmental Compliance Report" },
          { id: "malaysia-report-15", label: "Malaysia Sarawak Environmental Compliance Report" },
          { id: "malaysia-report-16", label: "Malaysia Bursa Sustainability Reporting Assessment" },
          { id: "malaysia-report-17", label: "Malaysia NSRF / IFRS S1-S2 Readiness Assessment" },
          { id: "malaysia-report-18", label: "Malaysia Climate & GHG Disclosure Readiness Report" },
          { id: "malaysia-report-19", label: "Malaysia ESG Compliance Gap & CAPA Register" },
        ],
      },
    ];
  }

  if (normalizedCountry === "Indonesia") {
    return [
      {
        heading: "Indonesia Reports / Assessments / Analysis",
        items: [
          { id: "indonesia-report-1", label: "Indonesia Environmental Approval & AMDAL Compliance Report" },
          { id: "indonesia-report-2", label: "Indonesia UKL-UPL / SPPL Compliance Review" },
          { id: "indonesia-report-3", label: "Indonesia Air / Wastewater / B3 Waste Compliance Assessment" },
          { id: "indonesia-report-4", label: "Indonesia PROPER Readiness Assessment" },
          { id: "indonesia-report-5", label: "Indonesia SMK3 / OHS Compliance Report" },
          { id: "indonesia-report-6", label: "Indonesia Carbon Economic Value / GHG Readiness Assessment" },
          { id: "indonesia-report-7", label: "Indonesia OJK Sustainable Finance & Sustainability Report Assessment" },
          { id: "indonesia-report-8", label: "Indonesia TKBI Alignment Assessment" },
          { id: "indonesia-report-9", label: "Indonesia ESG Compliance Gap & CAPA Register" },
        ],
      },
    ];
  }

  if (normalizedCountry === "Vietnam") {
    return [
      {
        heading: "Vietnam Reports / Assessments / Analysis",
        items: [
          { id: "vietnam-report-1", label: "Vietnam EIA & Environmental Licence Compliance Report" },
          { id: "vietnam-report-2", label: "Vietnam Environmental Monitoring / QCVN Compliance Assessment" },
          { id: "vietnam-report-3", label: "Vietnam Waste & Hazardous Waste Compliance Report" },
          { id: "vietnam-report-4", label: "Vietnam EPR Compliance Assessment" },
          { id: "vietnam-report-5", label: "Vietnam GHG Inventory & Mitigation Compliance Assessment" },
          { id: "vietnam-report-6", label: "Vietnam OHS Compliance Report" },
          { id: "vietnam-report-7", label: "Vietnam Chemical Safety Compliance Assessment" },
          { id: "vietnam-report-8", label: "Vietnam Energy Efficiency Compliance Assessment" },
          { id: "vietnam-report-9", label: "Vietnam ESG / Securities Disclosure Readiness Report" },
          { id: "vietnam-report-10", label: "Vietnam ESG Compliance Gap & CAPA Register" },
        ],
      },
    ];
  }

  if (normalizedCountry === "Thailand") {
    return [
      {
        heading: "Thailand Reports / Assessments / Analysis",
        items: [
          { id: "thailand-report-1", label: "Thailand EIA / EHIA Compliance Assessment" },
          { id: "thailand-report-2", label: "Thailand Factory Environmental Compliance Report" },
          { id: "thailand-report-3", label: "Thailand Industrial Waste / Wastewater / Air Compliance Assessment" },
          { id: "thailand-report-4", label: "Thailand Hazardous Substances Compliance Assessment" },
          { id: "thailand-report-5", label: "Thailand OHS Compliance Report" },
          { id: "thailand-report-6", label: "Thailand Energy Management Compliance Assessment" },
          { id: "thailand-report-7", label: "Thailand 56-1 One Report / Sustainability Disclosure Assessment" },
          { id: "thailand-report-8", label: "Thailand ISSB Readiness Assessment" },
          { id: "thailand-report-9", label: "Thailand ESG Compliance Gap & CAPA Register" },
        ],
      },
    ];
  }

  if (normalizedCountry === "Philippines") {
    return [
      {
        heading: "Philippines Reports / Assessments / Analysis",
        items: [
          { id: "philippines-report-1", label: "Philippines PEISS / ECC Compliance Assessment" },
          { id: "philippines-report-2", label: "Philippines Clean Air / Permit to Operate Compliance Report" },
          { id: "philippines-report-3", label: "Philippines Clean Water / Discharge Permit Compliance Report" },
          { id: "philippines-report-4", label: "Philippines Hazardous Waste Compliance Assessment" },
          { id: "philippines-report-5", label: "Philippines EPR Compliance Assessment" },
          { id: "philippines-report-6", label: "Philippines Solid Waste Compliance Report" },
          { id: "philippines-report-7", label: "Philippines OHS / DOLE Compliance Report" },
          { id: "philippines-report-8", label: "Philippines Energy Efficiency Compliance Assessment" },
          { id: "philippines-report-9", label: "Philippines Biodiversity / Protected Area / IPRA Screening" },
          { id: "philippines-report-10", label: "Philippines SEC Sustainability Reporting Assessment" },
          { id: "philippines-report-11", label: "Philippines ESG Compliance Gap & CAPA Register" },
        ],
      },
    ];
  }

  return [
    {
      heading: `${countryName} ESG Compliance Reports`,
      items: [
        { id: "def-report-1", label: `${countryName} Environmental & ESHS Legal Compliance Report` },
        { id: "def-report-2", label: `${countryName} Environmental Permit / Licence Register` },
        { id: "def-report-3", label: `${countryName} ESG Compliance Gap & CAPA Register` },
      ],
    },
  ];
};

export const FEDRAL_LAW_REGULATION = [
  {
    heading: "Environmental Protection and Climate Laws",
    description:
      "These regulations set the foundation for environmental protection, climate action, and sustainable development.",
    items: [
      {
        id: "law-24-1999",
        label:
          "Federal Law No. 24 of 1999 — Protection and Development of the Environment (air, water, waste, natural resources, EIA mandatory)",
      },
      {
        id: "law-10-2022",
        label:
          "Federal Law No. 10 of 2022 — UAE Climate Change Law (legally binding Net Zero commitment, emission reduction targets, climate risk assessments)",
      },
      {
        id: "law-46-2023",
        label:
          "Federal Decree Law No. 46 of 2023 — Corporate Taxation Law (Green investment incentives for compliance with UAE Net Zero targets)",
      },
      {
        id: "cabinet-37-2022",
        label:
          "UAE Cabinet Resolution No. 37 of 2022 — Mandatory Sustainability Reporting for public joint stock companies and large private entities",
      },
      {
        id: "law-20-2006",
        label:
          "Federal Law No. 20 of 2006 — Regulation of the Use of Chemical Materials",
      },
      {
        id: "decree-12-2016",
        label:
          "Ministerial Decree No. 12 of 2016 — Regulations for Water Quality Protection",
      },
    ],
  },
  {
    heading: "Waste Management and Pollution Control",
    description:
      "Mandatory regulations targeting waste reduction, segregation, recycling, and hazardous material handling.",
    items: [
      {
        id: "law-11-2018",
        label:
          "Federal Law No. 11 of 2018 — Integrated Waste Management (mandatory waste segregation, recycling, hazardous waste control)",
      },
      {
        id: "waste-strategy-2030",
        label:
          "UAE National Waste Management Strategy 2030 — Targets 75% waste diversion from landfills",
      },
    ],
  },
  {
    heading: "Labor and Occupational Health & Safety",
    description:
      "Key laws to ensure health, safety, and worker well-being in compliance with ESG principles.",
    items: [
      {
        id: "law-33-2021",
        label:
          "Federal Decree-Law No. 33 of 2021 — New Labour Law (health, safety, equality, diversity, well-being standards)",
      },
      {
        id: "res-46-2022",
        label:
          "Ministerial Resolution No. 46/2022 — Specific Occupational Health and Safety Rules (incident reporting, safety committees, audits)",
      },
    ],
  },
  {
    heading: "Energy and Sustainability Regulations",
    description:
      "Regulations driving the UAE’s clean energy transition and green economy ambitions.",
    items: [
      {
        id: "energy-strategy-2050",
        label: "UAE Energy Strategy 2050 — 50% clean energy by 2050",
      },
      {
        id: "hydrogen-roadmap",
        label:
          "UAE Hydrogen Leadership Roadmap (2021) — low-carbon and green hydrogen transition",
      },
      {
        id: "carbon-credit-registry",
        label:
          "UAE National Carbon Credit Registry (Launched 2023) — Voluntary carbon trading framework for businesses",
      },
      {
        id: "biodiversity-strategy",
        label:
          "UAE National Biodiversity Strategy and Action Plan (2014, update ongoing) — habitat conservation, species at risk protection",
      },
      {
        id: "sustainable-finance-2021",
        label:
          "UAE Sustainable Finance Framework 2021 — sustainable lending, ESG disclosures, green bonds",
      },
    ],
  },
];

export const PROVISIONAL_TERRITORY = [
  {
    heading: "Abu Dhabi Regulations",
    description:
      "Mandated environment, climate, and safety frameworks aimed at reducing risks and promoting sustainability across all sectors.",
    items: [
      {
        id: "abu-dhabi-ehsms-2009",
        label:
          "Environment, Health and Safety Management System (EHSMS) Regulatory Framework — Mandatory for all sectors (Decree No. 42 of 2009)",
      },
      {
        id: "abu-dhabi-plastic-policy-2020",
        label:
          "Abu Dhabi Single Use Plastic Policy (2020) — Bans single-use plastics",
      },
      {
        id: "abu-dhabi-climate-strategy-2023",
        label:
          "Abu Dhabi Climate Change Strategy 2023 — Mandates climate risk reporting for priority sectors",
      },
    ],
  },
  {
    heading: "Dubai Regulations",
    description:
      "Clean energy targets, sustainable construction standards, and decarbonization mandates for key economic sectors.",
    items: [
      {
        id: "dubai-green-building",
        label:
          "Dubai Municipality Green Building Regulations (Al Sa'fat Program) — Sustainability standards for all new construction",
      },
      {
        id: "dubai-clean-energy-2050",
        label:
          "Dubai Clean Energy Strategy 2050 — 75% clean energy target by 2050",
      },
      {
        id: "dubai-energy-strategy-2030",
        label:
          "Dubai Integrated Energy Strategy 2030 — Reduce energy demand by 30% by 2030",
      },
      {
        id: "dubai-net-zero-2050",
        label:
          "Dubai Net Zero Carbon Emissions Strategy 2050 (2021) — mandatory for industrial, transport, and real estate sectors",
      },
    ],
  },
  {
    heading: "Sharjah Regulations",
    description:
      "Focused guidelines for sustainable urban development and local environmental protection standards.",
    items: [
      {
        id: "sharjah-sustainable-city-2020",
        label:
          "Sharjah Sustainable City Guidelines (2020) — Focus on water, energy, waste, green buildings",
      },
      {
        id: "sharjah-epa-regulations",
        label:
          "Sharjah Environmental Protection Authority Regulations — Local EIA approvals and waste management standards",
      },
    ],
  },
  {
    heading: "Ras Al Khaimah Regulations",
    description:
      "Territory-wide decarbonization efforts through energy efficiency targets and mandatory retrofitting programs.",
    items: [
      {
        id: "rak-energy-strategy-2040",
        label:
          "RAK Energy Efficiency and Renewable Energy Strategy 2040 — 30% energy efficiency target, 20% renewables by 2040",
      },
      {
        id: "rak-retrofit-program",
        label:
          "RAK Building Retrofit Program — Mandatory energy efficiency improvements for public and private sector",
      },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ = [
  {
    heading: "Environmental Requirements",
    description:
      "Mandatory environmental compliance standards enforced through federal laws and emirate-specific regulations.",
    items: [
      {
        id: "eia-process-federal-24-1999",
        label:
          "Environmental Impact Assessment (EIA) Process mandatory under Federal Law No. 24/1999 and local emirate regulations (Dubai Municipality, Abu Dhabi EAD, etc.)",
      },
      {
        id: "carbon-footprint-reporting",
        label:
          "Carbon Footprint Reporting: voluntary but encouraged nationally, mandatory for banks under Central Bank ESG Guideline",
      },
      {
        id: "waste-management-law-11-2018",
        label:
          "Waste Management Compliance: strict rules for waste segregation, recycling (Law No. 11/2018), penalties for non-compliance",
      },
      {
        id: "air-quality-monitoring",
        label:
          "Air Quality Monitoring: industries must monitor and report emissions; emirates operate independent air monitoring networks",
      },
    ],
  },
  {
    heading: "Social Requirements",
    description:
      "Worker protection, human rights, and occupational safety aligned with global labor standards and enforced by UAE law.",
    items: [
      {
        id: "ohs-iso-45001",
        label:
          "Occupational Health and Safety Standards: based on ISO 45001, mandatory across UAE workplaces",
      },
      {
        id: "worker-welfare-ilo",
        label:
          "Worker Welfare Standards: enforced through free zones and government projects (aligned with ILO guidelines)",
      },
      {
        id: "human-rights-due-diligence-sca",
        label:
          "Human Rights Due Diligence: required for listed companies under Securities and Commodities Authority (SCA) corporate governance standards",
      },
    ],
  },
  {
    heading: "Governance Requirements",
    description:
      "National-level directives to strengthen sustainability reporting, biodiversity protection, and ESG risk management.",
    items: [
      {
        id: "sustainability-reporting-cabinet-37-2022",
        label:
          "Sustainability Reporting: public companies and financial institutions must submit ESG reports as per Cabinet Resolution No. 37/2022",
      },
      {
        id: "esg-risk-central-bank",
        label:
          "ESG Risk Management Integration: banks must assess climate and ESG risks, report to Central Bank",
      },
      {
        id: "biodiversity-impact-assessment",
        label:
          "Biodiversity Protection: projects near natural reserves, marine parks, or ecologically sensitive areas must submit biodiversity impact assessments",
      },
      {
        id: "renewable-energy-alignment",
        label:
          "Renewable Energy Integration: large-scale industrial and construction projects must align with renewable energy usage mandates by emirate-level regulations",
      },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_FRANCE = [
  {
    heading: "Environmental Framework and Sustainability Laws",
    description:
      "Core legal instruments shaping France's environmental governance, climate resilience, and sustainable development goals.",
    items: [
      {
        id: "code-environnement",
        label: "Environmental Code (Code de l'Environnement)",
      },
      {
        id: "climate-resilience-2021",
        label: "Climate and Resilience Law 2021",
      },
      {
        id: "grenelle-laws",
        label:
          "Grenelle I and II Laws — National Sustainable Development Strategy",
      },
      { id: "biodiversity-2030", label: "Biodiversity Plan 2030" },
      {
        id: "soil-remediation-2017",
        label: "Soil Remediation Guidelines 2017",
      },
    ],
  },
  {
    heading: "Social and Labor Regulations",
    description:
      "Laws focused on labor rights, corporate responsibility, and human rights compliance in line with international ESG standards.",
    items: [
      { id: "labour-code", label: "Labour Code (Code du Travail)" },
      {
        id: "duty-of-vigilance-2017",
        label:
          "Law on Duty of Vigilance 2017 — mandatory human rights and environmental due diligence for large companies",
      },
    ],
  },
  {
    heading: "Energy Transition and Circular Economy",
    description:
      "Legislation to drive France's shift toward renewable energy, energy efficiency, and circular production models.",
    items: [
      { id: "energy-code", label: "Energy Code (Code de l'Énergie)" },
      {
        id: "circular-economy-2020",
        label:
          "Circular Economy Law 2020 — waste reduction, reuse, and recycling incentives",
      },
    ],
  },
];

export const PROVISIONAL_TERRITORY_FRANCE = [
  {
    heading: "Regional Climate and Energy Planning",
    description:
      "Strategic frameworks designed at the regional level to guide climate action, renewable energy deployment, and emissions reduction.",
    items: [
      {
        id: "sr-cae",
        label:
          "Regional Climate-Energy Plans (Schéma Régional Climat Air Énergie - SRCAE)",
      },
    ],
  },
  {
    heading: "Urban and Territorial Planning Codes",
    description:
      "Local and intercommunal planning tools that embed sustainability, zoning, and urban resilience into development projects.",
    items: [
      {
        id: "plu-scot",
        label:
          "Local Urban Planning Codes (Plans Locaux d’Urbanisme - PLU, Schéma de Cohérence Territoriale - SCOT)",
      },
    ],
  },
  {
    heading: "Waste and Circular Economy Strategies",
    description:
      "Territory-specific programs targeting waste prevention, recycling, and resource circularity goals.",
    items: [
      {
        id: "prpgd",
        label:
          "Regional Waste Prevention and Management Plans (Plans Régionaux de Prévention et de Gestion des Déchets - PRPGD)",
      },
    ],
  },
  {
    heading: "Biodiversity Protection Strategies",
    description:
      "Comprehensive regional strategies for conservation of ecosystems, endangered species, and natural heritage.",
    items: [
      {
        id: "srb",
        label:
          "Regional Biodiversity Strategies (Stratégies Régionales pour la Biodiversité - SRB)",
      },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_FRANCE = [
  {
    heading: "Environmental Requirements",
    description:
      "National and regional mandates requiring environmental assessments, offsetting, and compliance in land use and infrastructure planning.",
    items: [
      {
        id: "environmental-risk-assessment-france",
        label:
          "Environmental Risk Assessment: required for infrastructure, industrial, and energy projects as part of national impact study processes",
      },
      {
        id: "biodiversity-offsetting-measures",
        label:
          "Mandatory Biodiversity Offsetting Measures: new developments must offset ecological impacts under Environmental Code (Code de l’environnement)",
      },
    ],
  },
  {
    heading: "Social Requirements",
    description:
      "Worker safety and labor risk regulations aimed at improving employee well-being and aligning with EU labor standards.",
    items: [
      {
        id: "labour-risk-plan-duerp",
        label:
          "Labour Risk Prevention Plan (DUERP): required for all employers to assess and mitigate occupational risks",
      },
    ],
  },
  {
    heading: "Governance Requirements",
    description:
      "National-level sustainability governance directives for large organizations, ensuring ESG transparency and corporate responsibility.",
    items: [
      {
        id: "mandatory-esg-disclosure-dpef",
        label:
          "Mandatory ESG Disclosures (DPEF): large companies must publish Extra-Financial Performance Declarations (Déclaration de Performance Extra-Financière)",
      },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_GERMANY = [
  {
    heading: "Environmental and Climate Legislation",
    description:
      "Core national laws that govern Germany’s climate protection, biodiversity conservation, and environmental resilience.",
    items: [
      {
        id: "klimaschutzgesetz",
        label: "Federal Climate Protection Act (Klimaschutzgesetz)",
      },
      { id: "bnatschg", label: "Federal Nature Conservation Act (BNatSchG)" },
      { id: "bbodschg", label: "Federal Soil Protection Act (BBodSchG)" },
      {
        id: "krwg",
        label: "Closed Substance Cycle and Waste Management Act (KrWG)",
      },
    ],
  },
  {
    heading: "Social and Corporate Due Diligence Laws",
    description:
      "Worker protection and corporate accountability laws aligned with EU human rights and sustainability frameworks.",
    items: [{ id: "lksg", label: "Supply Chain Due Diligence Act (LkSG)" }],
  },
  {
    heading: "Energy Transition and Product Safety",
    description:
      "Laws driving Germany’s renewable energy goals and consumer product safety standards across industries.",
    items: [
      { id: "eeg-2023", label: "Renewable Energy Sources Act (EEG 2023)" },
      { id: "prodsg", label: "Product Safety Act (ProdSG)" },
    ],
  },
];

export const PROVISIONAL_TERRITORY_GERMANY = [
  {
    heading: "State-Level Climate Legislation",
    description:
      "Regional climate protection acts outlining emissions targets, carbon neutrality goals, and adaptation strategies.",
    items: [
      {
        id: "bavarian-climate-act",
        label:
          "State-level Climate Protection Laws (e.g., Bavarian Climate Protection Act)",
      },
    ],
  },
  {
    heading: "State Waste and Circular Economy Policies",
    description:
      "Länder-level waste management laws and circular economy initiatives to reduce landfill and promote recycling.",
    items: [
      {
        id: "state-waste-management",
        label: "State Waste Management Acts",
      },
    ],
  },
  {
    heading: "Regional Biodiversity and Ecosystem Protection",
    description:
      "Ordinances aimed at protecting biodiversity, ecosystems, and natural heritage at the state level.",
    items: [
      {
        id: "regional-biodiversity-ordinance",
        label: "Regional Biodiversity Protection Ordinances",
      },
    ],
  },
  {
    heading: "Energy Transition Frameworks by State",
    description:
      "Energy transition strategies tailored by German states to boost renewables and decarbonize power sectors.",
    items: [
      {
        id: "state-energy-transition-nrw-bavaria",
        label: "State Energy Transition Plans (e.g., NRW, Bavaria)",
      },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_GERMANY = [
  {
    heading: "Environmental Requirements",
    description:
      "Federal and regional regulations enforcing environmental assessments, emissions limits, and natural resource protection in project development.",
    items: [
      {
        id: "eia-uvp-energy-transport-mining",
        label:
          "Environmental Impact Assessment (UVP): required for energy, transport, and mining projects",
      },
      {
        id: "regional-waste-water-emissions",
        label: "Regional Enforcement of Waste, Water, and Emissions Limits",
      },
    ],
  },
  {
    heading: "Social Requirements",
    description:
      "Legally binding corporate responsibility mandates to ensure human rights protection throughout the supply chain.",
    items: [
      {
        id: "lkSG-human-rights-due-diligence",
        label:
          "Mandatory Corporate Human Rights Due Diligence (Supply Chain Due Diligence Act - LkSG) for applicable companies",
      },
    ],
  },
  {
    heading: "Governance Requirements",
    description:
      "Corporate ESG reporting obligations to enhance transparency and sustainability strategy alignment with EU directives.",
    items: [
      {
        id: "csrd-esg-disclosure",
        label:
          "ESG Disclosures under the Corporate Sustainability Reporting Directive (CSRD)",
      },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_ITALY = [
  {
    heading: "Environmental and Climate Legislation",
    description:
      "Foundational laws for Italy's environmental protection, biodiversity, and national climate resilience strategies.",
    items: [
      {
        id: "env-code-dlgs-152-2006",
        label: "Environmental Code (Decreto Legislativo 152/2006)",
      },
      { id: "law-68-2015", label: "Law 68/2015 (Environmental Crimes)" },
      {
        id: "climate-strategy-2015",
        label: "National Climate Change Adaptation Strategy 2015",
      },
      { id: "biodiversity-2030-it", label: "Biodiversity Strategy 2030" },
    ],
  },
  {
    heading: "Corporate Liability and ESG Reporting",
    description:
      "Laws regulating corporate criminal liability and mandating transparency in non-financial sustainability reporting.",
    items: [
      {
        id: "dlgs-231-2001",
        label:
          "Legislative Decree 231/2001 (Corporate Criminal Liability including EHS)",
      },
      {
        id: "dlgs-254-2016",
        label: "Legislative Decree 254/2016 (Non-Financial Reporting, ESG)",
      },
    ],
  },
  {
    heading: "Energy Strategy and Transition",
    description:
      "National strategies and policies to promote energy security, renewable energy adoption, and decarbonization.",
    items: [
      { id: "energy-strategy-2017", label: "National Energy Strategy 2017" },
    ],
  },
];

export const PROVISIONAL_TERRITORY_ITALY = [
  {
    heading: "Regional Environmental Monitoring and Enforcement",
    description:
      "Institutions responsible for environmental assessments, data collection, and regulatory oversight at the regional level.",
    items: [
      {
        id: "arpa-system",
        label: "Regional Environmental Agencies (ARPA system)",
      },
    ],
  },
  {
    heading: "Regional Waste and Water Governance",
    description:
      "Comprehensive regional plans for managing solid waste, water resources, and circular economy initiatives.",
    items: [
      {
        id: "piani-regionali-waste-water",
        label: "Regional Waste and Water Management Plans (Piani Regionali)",
      },
    ],
  },
  {
    heading: "Sustainable Urban Mobility Planning",
    description:
      "Strategic plans aimed at improving public transportation, reducing traffic emissions, and promoting low-carbon mobility.",
    items: [
      {
        id: "pums",
        label: "Urban Sustainable Mobility Plans (PUMS)",
      },
    ],
  },
  {
    heading: "Climate and Energy Strategy at the Regional Level",
    description:
      "Region-specific frameworks supporting emissions reduction, clean energy, and climate adaptation targets.",
    items: [
      {
        id: "pair-climate-energy-plan",
        label: "Regional Climate and Energy Plans (PAIR)",
      },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_ITALY = [
  {
    heading: "Environmental Requirements",
    description:
      "National and regional mandates for impact assessments, municipal-level waste regulation, and environmental protection.",
    items: [
      {
        id: "via-environmental-impact",
        label:
          "Environmental Impact Assessment (VIA): mandatory for major works",
      },
      {
        id: "municipal-waste-recycling",
        label: "Waste Separation and Recycling Enforcement at Municipal Levels",
      },
    ],
  },
  {
    heading: "Social Requirements",
    description:
      "Worker protection mechanisms and public health enforcement through decentralized agencies.",
    items: [
      {
        id: "asl-occupational-safety",
        label:
          "Occupational Health and Safety Enforcement by ASL (Local Health Units)",
      },
    ],
  },
  {
    heading: "Governance Requirements",
    description:
      "National ESG disclosure regulations aligned with EU directives and sustainability transparency mandates.",
    items: [
      {
        id: "decree-254-2016-esg",
        label:
          "ESG Reporting Mandatory for Large Companies under Legislative Decree 254/2016",
      },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_NETHERLANDS = [
  {
    heading: "Environmental and Climate Legislation",
    description:
      "Key national laws shaping the Netherlands’ approach to environmental protection, climate action, and resource resilience.",
    items: [
      {
        id: "wet-milieubeheer",
        label: "Environmental Management Act (Wet milieubeheer)",
      },
      { id: "klimaatwet", label: "Climate Act (Klimaatwet)" },
      { id: "soil-protection-act", label: "Soil Protection Act" },
      {
        id: "energy-efficiency-law",
        label: "Energy Efficiency Directive Implementation Law",
      },
    ],
  },
  {
    heading: "Social and Corporate Due Diligence Laws",
    description:
      "Laws focused on workplace health, safety, and corporate social accountability.",
    items: [{ id: "arbowet", label: "Working Conditions Act (Arbowet)" }],
  },
  {
    heading: "Governance and ESG Transparency",
    description:
      "Frameworks enhancing corporate responsibility and sustainability reporting standards.",
    items: [
      {
        id: "corporate-governance-code-2022",
        label: "Dutch Corporate Governance Code 2022 (for ESG Transparency)",
      },
    ],
  },
];

export const PROVISIONAL_TERRITORY_NETHERLANDS = [
  {
    heading: "Provincial and Regional Planning",
    description:
      "Spatial development policies set by Dutch provinces to manage land use, zoning, and environmental integration.",
    items: [
      {
        id: "provincial-spatial-planning",
        label: "Provincial Spatial Planning Policies",
      },
    ],
  },
  {
    heading: "Energy and Climate Strategies",
    description:
      "Collaborative regional plans for clean energy generation and climate adaptation under the Dutch Climate Agreement.",
    items: [
      {
        id: "res-regional-energy-strategies",
        label:
          "Regional Energy Strategies (Regionale Energiestrategieën - RES)",
      },
    ],
  },
  {
    heading: "Local Sustainability Initiatives",
    description:
      "City-level climate action plans and sustainability frameworks advancing local green goals.",
    items: [
      {
        id: "local-sustainability-programs",
        label:
          "Local Sustainability Programs (e.g., Amsterdam, Rotterdam Climate Action)",
      },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_NETHERLANDS = [
  {
    heading: "Environmental Requirements",
    description:
      "Key national and regional regulations ensuring environmental assessments, industrial compliance, and sustainable resource use.",
    items: [
      {
        id: "eia-mer-industrial-energy",
        label:
          "Environmental Impact Assessment (MER): mandatory for industrial and energy sectors",
      },
      {
        id: "eed-energy-audit-enterprises",
        label:
          "Mandatory Energy Efficiency Audits (EED audits) for enterprises",
      },
    ],
  },
  {
    heading: "Social Requirements",
    description:
      "Workplace safety regulations and labor rights enforcement through national inspectorates.",
    items: [
      {
        id: "occupational-safety-inspectie-szw",
        label: "Occupational Safety compliance through Inspectie SZW",
      },
    ],
  },
  {
    heading: "Governance Requirements",
    description:
      "ESG disclosure mandates for public companies and enterprises aligning with EU transparency directives.",
    items: [
      {
        id: "euronext-esg-disclosure",
        label:
          "ESG disclosure mandatory for listed companies (Euronext ESG Index compliance)",
      },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_SPAIN = [
  {
    heading: "Environmental and Climate Legislation",
    description:
      "Core national frameworks guiding Spain's strategy on climate action, environmental responsibility, and sustainable development.",
    items: [
      {
        id: "law-26-2007-environmental-liability",
        label: "Law 26/2007 on Environmental Liability",
      },
      {
        id: "royal-decree-1028-2007-eia",
        label: "Royal Decree 1028/2007 (Environmental Impact Assessment)",
      },
      {
        id: "climate-change-energy-transition-2021",
        label: "Climate Change and Energy Transition Law 2021",
      },
      {
        id: "circular-economy-spain-2030",
        label: "Circular Economy Strategy Spain 2030",
      },
      {
        id: "biodiversity-natural-heritage-2015",
        label: "Biodiversity and Natural Heritage Law (2015)",
      },
    ],
  },
  {
    heading: "Governance and ESG Transparency",
    description:
      "Legal standards for corporate accountability, non-financial reporting, and sustainability disclosures.",
    items: [
      {
        id: "law-11-2018-non-financial-disclosure",
        label: "Law 11/2018 on Non-Financial and Diversity Information",
      },
    ],
  },
];

export const PROVISIONAL_TERRITORY_SPAIN = [
  {
    heading: "Regional Environmental Protection",
    description:
      "Environmental regulations enacted by Autonomous Communities, reflecting Spain's decentralized governance and regional priorities.",
    items: [
      {
        id: "regional-environmental-laws",
        label:
          "Regional Environmental Protection Laws (Autonomous Communities)",
      },
    ],
  },
  {
    heading: "Climate Adaptation at Regional Level",
    description:
      "Adaptation strategies designed by regions like Catalonia and Andalusia to tackle climate risks and enhance resilience.",
    items: [
      {
        id: "regional-climate-adaptation-strategies",
        label:
          "Regional Climate Adaptation Strategies (e.g., Catalonia, Andalusia)",
      },
    ],
  },
  {
    heading: "Municipal Sustainability and Mobility",
    description:
      "City-led initiatives to green urban living through sustainability plans, emission reduction, and mobility overhauls.",
    items: [
      {
        id: "municipal-green-mobility-strategies",
        label:
          "Municipal Green Plans and Mobility Strategies (e.g., Madrid 360)",
      },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_SPAIN = [
  {
    heading: "Environmental Requirements",
    description:
      "Regulations ensuring regional-level environmental permitting and sustainability alignment across sectors.",
    items: [
      {
        id: "regional-environmental-permits",
        label: "Environmental permits issued at regional level",
      },
    ],
  },
  {
    heading: "Social Requirements",
    description:
      "Federally framed occupational health and safety rules, executed and enforced by regional authorities.",
    items: [
      {
        id: "federal-safety-regional-enforcement",
        label:
          "Workplace Health and Safety managed federally, enforced regionally",
      },
    ],
  },
  {
    heading: "Governance Requirements",
    description:
      "Mandatory ESG reporting for large companies under Spanish law and aligned with EU's CSRD directive.",
    items: [
      {
        id: "law-11-2018-csrd-esg-reporting",
        label:
          "ESG Reporting mandatory for large companies per Law 11/2018 and CSRD alignment",
      },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_PAKISTAN = [
  {
    heading: "Environmental and Climate Legislation",
    description:
      "Core national frameworks guiding Pakistan's approach to environmental protection, climate resilience, and sustainable energy development.",
    items: [
      {
        id: "pepa-1997",
        label: "Pakistan Environmental Protection Act (PEPA) 1997",
      },
      {
        id: "national-climate-policy-2021",
        label: "National Climate Change Policy 2021",
      },
      {
        id: "renewable-energy-policy-2019",
        label: "Renewable Energy Policy 2019",
      },
    ],
  },
  {
    heading: "Governance and ESG Transparency",
    description:
      "Corporate governance rules and sustainability mandates including CSR obligations and workplace safety laws.",
    items: [
      {
        id: "companies-act-2017-csr",
        label: "Companies Act 2017 (CSR clause)",
      },
      {
        id: "anti-harassment-law-2010",
        label: "Protection against Harassment at Workplace Act 2010",
      },
    ],
  },
];

export const PROVISIONAL_TERRITORY_PAKISTAN = [
  {
    heading: "Provincial Environmental Protection",
    description:
      "Environmental oversight and enforcement carried out by Provincial Environmental Protection Agencies across Pakistan.",
    items: [
      {
        id: "provincial-epas",
        label:
          "Provincial Environment Protection Agencies (SEPA, Punjab, KPK, Balochistan EPA, etc.)",
      },
    ],
  },
  {
    heading: "Provincial Climate and Green Strategies",
    description:
      "Provincial climate frameworks and sustainable development programs supporting regional resilience and low-carbon goals.",
    items: [
      {
        id: "sindh-climate-policy-2022",
        label: "Sindh Climate Change Policy 2022",
      },
      {
        id: "punjab-green-development",
        label: "Punjab Green Development Program Regulations",
      },
    ],
  },
  {
    heading: "Provincial Social and Labour Regulations",
    description:
      "Labour laws and welfare provisions governed by provincial ordinances, ensuring workplace rights and compliance.",
    items: [
      {
        id: "labour-welfare-ordinances",
        label: "Labour Welfare Ordinances (Provincial Industrial Relations)",
      },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_PAKISTAN = [
  {
    heading: "Environmental Requirements",
    description:
      "Environmental approvals governed under provincial EPA regulations through mandatory IEE and EIA processes.",
    items: [
      {
        id: "provincial-eia-iee",
        label: "EIA/IEE mandatory under provincial EPA rules",
      },
    ],
  },
  {
    heading: "Social Requirements",
    description:
      "Occupational health and safety compliance governed by provincial labor departments and regional enforcement bodies.",
    items: [
      {
        id: "provincial-ohs-enforcement",
        label: "Occupational Health and Safety enforced provincially",
      },
    ],
  },
  {
    heading: "Governance Requirements",
    description:
      "Corporate social responsibility disclosures encouraged for listed companies under SECP guidance and company law.",
    items: [
      {
        id: "csr-reporting-listed-companies",
        label: "CSR Reporting encouraged for public listed companies",
      },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_BANGLADESH = [
  {
    heading: "Environmental and Climate Legislation",
    description:
      "Core national frameworks guiding Bangladesh's environmental protection, energy efficiency, and climate resilience strategies.",
    items: [
      {
        id: "bangladesh-environment-act-1995",
        label: "Bangladesh Environment Conservation Act 1995",
      },
      {
        id: "energy-efficiency-master-plan-2015",
        label: "Energy Efficiency and Conservation Master Plan 2015",
      },
      {
        id: "national-adaptation-plan-2022",
        label: "National Adaptation Plan 2022",
      },
    ],
  },
  {
    heading: "Governance and ESG Transparency",
    description:
      "Labor law protections, CSR-related policy mandates, and alignment with the Sustainable Development Goals (SDGs).",
    items: [
      {
        id: "labour-act-2006-amended-2018",
        label: "Bangladesh Labour Act 2006 (amended 2018)",
      },
      {
        id: "sdg-action-plan",
        label: "Sustainable Development Goals (SDG) Action Plan",
      },
    ],
  },
];

export const PROVISIONAL_TERRITORY_BANGLADESH = [
  {
    heading: "Regional Environmental Protection",
    description:
      "Environmental regulation and guidance executed through the Department of Environment (DoE) across Bangladesh.",
    items: [
      {
        id: "doe-eia-guidelines",
        label: "EIA Guidelines issued by Department of Environment (DoE)",
      },
    ],
  },
  {
    heading: "Industrial and Export Zone Safety",
    description:
      "Environmental and safety enforcement specific to Bangladesh's Export Processing Zones (EPZs).",
    items: [
      {
        id: "epz-industrial-safety-rules",
        label:
          "Industrial Safety Enforcement Rules for Export Processing Zones (EPZs)",
      },
    ],
  },
  {
    heading: "Municipal Environmental Oversight",
    description:
      "Local government-driven health and environmental rules to promote sustainability and compliance in urban areas.",
    items: [
      {
        id: "municipal-health-environment",
        label: "Local Municipal Health and Environment Regulations",
      },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_BANGLADESH = [
  {
    heading: "Environmental Requirements",
    description:
      "Mandatory environmental certification for industrial establishments, issued by the Department of Environment (DoE).",
    items: [
      {
        id: "environmental-clearance-certificate",
        label:
          "Environmental Clearance Certificate (ECC) required for all factories",
      },
    ],
  },
  {
    heading: "Social Requirements",
    description:
      "Labour rights compliance through industry-wide audits in the ready-made garments (RMG) sector and others.",
    items: [
      {
        id: "labour-welfare-audits-rmg",
        label:
          "Labour welfare audits in RMG and other sectors (via Accord/RMG Sustainability Council)",
      },
    ],
  },
  {
    heading: "Governance Requirements",
    description:
      "Climate risk due diligence mandated for vulnerable zones to address disaster risk and adaptation planning.",
    items: [
      {
        id: "climate-vulnerability-assessments",
        label:
          "Climate vulnerability and disaster risk assessments mandatory for high-risk areas",
      },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_NIGERIA = [
  {
    heading: "Environmental and Climate Legislation",
    description:
      "Key national laws defining Nigeria’s commitment to environmental protection, climate action, renewable energy development, and petroleum sector sustainability.",
    items: [
      {
        id: "nesrea-act-2007",
        label: "NESREA Act (Environmental Protection) 2007",
      },
      {
        id: "climate-change-act-2021",
        label: "Climate Change Act 2021",
      },
      {
        id: "renewable-energy-policy-2015",
        label: "Nigeria Renewable Energy Policy 2015",
      },
      {
        id: "petroleum-industry-act-2021",
        label: "Petroleum Industry Act 2021 (EHS Provisions)",
      },
    ],
  },
  {
    heading: "Governance and ESG Transparency",
    description:
      "National frameworks for labor rights, occupational health, and corporate responsibility within Nigeria’s governance ecosystem.",
    items: [
      {
        id: "nigerian-labour-act-2004",
        label: "Nigerian Labour Act 2004 (amended)",
      },
    ],
  },
];

export const PROVISIONAL_TERRITORY_NIGERIA = [
  {
    heading: "State-Level Environmental Oversight",
    description:
      "Environmental management, pollution control, and enforcement led by State Environmental Protection Agencies (SEPAs).",
    items: [
      {
        id: "state-epas-nigeria",
        label: "State EPAs (e.g., Lagos, Rivers, Kano)",
      },
    ],
  },
  {
    heading: "Local Environmental Governance",
    description:
      "State-specific laws, sanitation guidelines, and waste management protocols tailored to urban and industrial dynamics.",
    items: [
      {
        id: "state-environmental-laws",
        label: "State Environmental Laws and Waste Management Guidelines",
      },
    ],
  },
  {
    heading: "Regional Environmental Restoration",
    description:
      "Environmental remediation frameworks focused on pollution cleanup, ecosystem rehabilitation, and social accountability—particularly in extractive zones.",
    items: [
      {
        id: "niger-delta-remediation",
        label: "Niger Delta Environmental Remediation Framework",
      },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_NIGERIA = [
  {
    heading: "Environmental Requirements",
    description:
      "Mandatory environmental impact assessments and management plans for high-risk sectors, coordinated across federal and state agencies.",
    items: [
      {
        id: "eia-key-sectors",
        label: "EIA mandatory for energy, infrastructure, mining sectors",
      },
      {
        id: "oil-gas-emp",
        label:
          "Oil and gas projects must submit EMPs and community engagement plans",
      },
    ],
  },
  {
    heading: "Social Requirements",
    description:
      "Labour rights and welfare jointly monitored by federal labour ministry and state-level bodies across industrial zones.",
    items: [
      {
        id: "joint-labour-oversight",
        label:
          "Labour and worker welfare regulated jointly by state and federal agencies",
      },
    ],
  },
  {
    heading: "Governance Requirements",
    description:
      "ESG disclosures are being guided by Financial Reporting Council and emerging corporate governance frameworks.",
    items: [
      {
        id: "frc-esg-guidelines",
        label:
          "ESG Disclosure evolving under Financial Reporting Council (FRC) guidelines",
      },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_SINGAPORE = [
  {
    heading: "Singapore Primary Laws / Acts",
    description: "Primary legislative frameworks and acts governing environmental, climate, OHS, and sustainability in Singapore.",
    items: [
      { id: "singapore-law-1", label: "Environmental Protection and Management Act 1999 (EPMA)" },
      { id: "singapore-law-2", label: "Environmental Public Health Act 1987" },
      { id: "singapore-law-3", label: "Resource Sustainability Act 2019" },
      { id: "singapore-law-4", label: "Carbon Pricing Act 2018" },
      { id: "singapore-law-5", label: "Sewerage and Drainage Act 1999" },
      { id: "singapore-law-6", label: "Workplace Safety and Health Act 2006" },
      { id: "singapore-law-7", label: "Fire Safety Act 1993" },
      { id: "singapore-law-8", label: "Energy Conservation Act 2012" },
      { id: "singapore-law-9", label: "Wildlife Act 1965" },
      { id: "singapore-law-10", label: "Parks and Trees Act 2005" },
      { id: "singapore-law-11", label: "Endangered Species (Import and Export) Act 2006" },
      { id: "singapore-law-12", label: "Control of Plants Act 1993" },
      { id: "singapore-law-13", label: "Maritime and Port Authority of Singapore Act 1996 and applicable marine pollution legislation" },
      { id: "singapore-law-14", label: "Companies Act 1967 and corporate reporting requirements relevant to sustainability reporting" },
    ],
  },
];

export const PROVISIONAL_TERRITORY_SINGAPORE = [
  {
    heading: "Singapore Regulations & Subsidiary Legislation",
    description: "Subsidiary regulations, orders, notifications, and decrees applicable in Singapore.",
    items: [
      { id: "singapore-reg-1", label: "Environmental Protection and Management (Air Impurities) Regulations" },
      { id: "singapore-reg-2", label: "Environmental Protection and Management (Trade Effluent) Regulations" },
      { id: "singapore-reg-3", label: "Environmental Protection and Management (Hazardous Substances) Regulations" },
      { id: "singapore-reg-4", label: "Environmental Protection and Management (Vehicular Emissions) Regulations" },
      { id: "singapore-reg-5", label: "Environmental Public Health (Toxic Industrial Waste) Regulations" },
      { id: "singapore-reg-6", label: "Environmental Public Health (General Waste Collection) Regulations" },
      { id: "singapore-reg-7", label: "Environmental Public Health (Public Cleansing) Regulations" },
      { id: "singapore-reg-8", label: "Resource Sustainability (E-Waste Recyclers) Regulations" },
      { id: "singapore-reg-9", label: "Resource Sustainability (Packaging Reporting) Regulations" },
      { id: "singapore-reg-10", label: "Resource Sustainability (Prescribed Regulated Products) Regulations" },
      { id: "singapore-reg-11", label: "Carbon Pricing (Registration and General Matters) Regulations 2018" },
      { id: "singapore-reg-12", label: "Carbon Pricing (Measurement, Reporting and Verification) Regulations 2018" },
      { id: "singapore-reg-13", label: "Sewerage and Drainage (Trade Effluent) Regulations" },
      { id: "singapore-reg-14", label: "Workplace Safety and Health (General Provisions) Regulations" },
      { id: "singapore-reg-15", label: "Workplace Safety and Health (Risk Management) Regulations" },
      { id: "singapore-reg-16", label: "Workplace Safety and Health (Incident Reporting) Regulations" },
      { id: "singapore-reg-17", label: "Workplace Safety and Health (Work at Heights) Regulations" },
      { id: "singapore-reg-18", label: "Workplace Safety and Health (Confined Spaces) Regulations" },
      { id: "singapore-reg-19", label: "Workplace Safety and Health (Construction) Regulations" },
      { id: "singapore-reg-20", label: "Workplace Safety and Health (Scaffolds) Regulations" },
      { id: "singapore-reg-21", label: "Workplace Safety and Health (Noise) Regulations" },
      { id: "singapore-reg-22", label: "Workplace Safety and Health (Medical Examinations) Regulations" },
      { id: "singapore-reg-23", label: "Workplace Safety and Health (Major Hazard Installations) Regulations" },
      { id: "singapore-reg-24", label: "Workplace Safety and Health (Operation of Cranes) Regulations" },
      { id: "singapore-reg-25", label: "Fire Safety (Petroleum and Flammable Materials) Regulations" },
      { id: "singapore-reg-26", label: "Energy Conservation (Energy Management Practices) Regulations" },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_SINGAPORE = [
  {
    heading: "Singapore ESHS Standards, Codes & Guidelines",
    description: "Sector standards, codes of practice, environmental guidelines, and ESG disclosure requirements for Singapore.",
    items: [
      { id: "singapore-eshs-1", label: "NEA Code of Practice on Pollution Control" },
      { id: "singapore-eshs-2", label: "NEA Technical Guidance on air pollution control and industrial emissions" },
      { id: "singapore-eshs-3", label: "NEA toxic industrial waste requirements and licensed waste-collector controls" },
      { id: "singapore-eshs-4", label: "PUB Code of Practice on Sewerage and Sanitary Works" },
      { id: "singapore-eshs-5", label: "PUB trade-effluent discharge requirements" },
      { id: "singapore-eshs-6", label: "PUB water efficiency and water conservation requirements" },
      { id: "singapore-eshs-7", label: "SCDF Fire Code and fire-safety requirements" },
      { id: "singapore-eshs-8", label: "MOM Workplace Safety and Health Guidelines and Approved Codes of Practice" },
      { id: "singapore-eshs-9", label: "MOM risk management guidance" },
      { id: "singapore-eshs-10", label: "MOM major-hazard installation / Safety Case guidance" },
      { id: "singapore-eshs-11", label: "Singapore Standard SS 651: Safety and Health Management System for Chemical Industry, where applicable" },
      { id: "singapore-eshs-12", label: "Energy Efficiency Opportunities Assessment and energy-management guidance under ECA" },
      { id: "singapore-eshs-13", label: "NEA GHG Measurement and Reporting requirements for reportable facilities" },
      { id: "singapore-eshs-14", label: "NEA MRV requirements for taxable facilities" },
      { id: "singapore-eshs-15", label: "International Carbon Credits framework guidance for taxable facilities" },
      { id: "singapore-eshs-16", label: "SGX Listing Rules 711A and 711B on Sustainability Reports" },
      { id: "singapore-eshs-17", label: "SGX Practice Note 7.6 / 7F climate-related disclosure requirements, as applicable" },
      { id: "singapore-eshs-18", label: "ACRA sustainability reporting and assurance requirements" },
      { id: "singapore-eshs-19", label: "Singapore Sustainability Disclosure Standards / SFRS sustainability standards once finalised and effective; draft status to be separately identified" },
      { id: "singapore-eshs-20", label: "ISSB-based climate disclosure requirements incorporated into Singapore reporting roadmap" },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_MALAYSIA = [
  {
    heading: "Malaysia Primary Laws / Acts",
    description: "Primary legislative frameworks and acts governing environmental, climate, OHS, and sustainability in Malaysia.",
    items: [
      { id: "malaysia-law-1", label: "Environmental Quality Act 1974 (Act 127), including Environmental Quality (Amendment) Act 2024" },
      { id: "malaysia-law-2", label: "Occupational Safety and Health Act 1994 (Act 514), as amended" },
      { id: "malaysia-law-3", label: "Factories and Machinery Act 1967 legacy requirements where still relevant during transition" },
      { id: "malaysia-law-4", label: "Solid Waste and Public Cleansing Management Act 2007 (Act 672), where adopted/applicable" },
      { id: "malaysia-law-5", label: "Renewable Energy Act 2011" },
      { id: "malaysia-law-6", label: "Sustainable Energy Development Authority Act 2011" },
      { id: "malaysia-law-7", label: "Efficient Management of Electrical Energy Regulations / Energy Efficiency and Conservation Act framework as applicable" },
      { id: "malaysia-law-8", label: "Water Services Industry Act 2006" },
      { id: "malaysia-law-9", label: "National Forestry Act 1984, subject to State adoption/amendment" },
      { id: "malaysia-law-10", label: "Wildlife Conservation Act 2010 (Peninsular Malaysia)" },
      { id: "malaysia-law-11", label: "International Trade in Endangered Species Act 2008" },
      { id: "malaysia-law-12", label: "Biosafety Act 2007" },
      { id: "malaysia-law-13", label: "Atomic Energy Licensing Act 1984 where applicable" },
      { id: "malaysia-law-14", label: "Environmental Quality / natural resources legislation applicable specifically in Sabah" },
      { id: "malaysia-law-15", label: "Natural Resources and Environment Ordinance / environmental requirements applicable in Sarawak" },
      { id: "malaysia-law-16", label: "Companies Act 2016 and capital-market sustainability disclosure requirements" },
    ],
  },
];

export const PROVISIONAL_TERRITORY_MALAYSIA = [
  {
    heading: "Malaysia Regulations & Subsidiary Legislation",
    description: "Subsidiary regulations, orders, notifications, and decrees applicable in Malaysia.",
    items: [
      { id: "malaysia-reg-1", label: "Environmental Quality (Prescribed Activities) (Environmental Impact Assessment) Order 2015" },
      { id: "malaysia-reg-2", label: "Environmental Quality (Clean Air) Regulations 2014" },
      { id: "malaysia-reg-3", label: "Environmental Quality (Industrial Effluent) Regulations 2009" },
      { id: "malaysia-reg-4", label: "Environmental Quality (Sewage) Regulations 2009" },
      { id: "malaysia-reg-5", label: "Environmental Quality (Scheduled Wastes) Regulations 2005" },
      { id: "malaysia-reg-6", label: "Environmental Quality (Control of Pollution from Solid Waste Transfer Station and Landfill) Regulations 2009" },
      { id: "malaysia-reg-7", label: "Environmental Quality (Refrigerant Management) Regulations 2020" },
      { id: "malaysia-reg-8", label: "Environmental Quality (Prescribed Premises) regulations relevant to scheduled wastes, crude palm oil and raw natural rubber" },
      { id: "malaysia-reg-9", label: "Occupational Safety and Health (Use and Standards of Exposure of Chemicals Hazardous to Health) Regulations 2000" },
      { id: "malaysia-reg-10", label: "Occupational Safety and Health (Classification, Labelling and Safety Data Sheet of Hazardous Chemicals) Regulations 2013" },
      { id: "malaysia-reg-11", label: "Occupational Safety and Health (Noise Exposure) Regulations 2019" },
      { id: "malaysia-reg-12", label: "Occupational Safety and Health (Notification of Accident, Dangerous Occurrence, Occupational Poisoning and Occupational Disease) Regulations 2004" },
      { id: "malaysia-reg-13", label: "Occupational Safety and Health (Safety and Health Committee) Regulations 1996" },
      { id: "malaysia-reg-14", label: "Occupational Safety and Health (Safety and Health Officer) Regulations 1997" },
      { id: "malaysia-reg-15", label: "Occupational Safety and Health (Construction Work) (Design and Management) Regulations 2024" },
      { id: "malaysia-reg-16", label: "Applicable plant / machinery registration, inspection and certificate requirements" },
      { id: "malaysia-reg-17", label: "Solid Waste and Public Cleansing Management subsidiary regulations where Act 672 applies" },
      { id: "malaysia-reg-18", label: "Water Services Industry subsidiary regulations and discharge/sewerage requirements" },
      { id: "malaysia-reg-19", label: "State water enactments and regulations" },
      { id: "malaysia-reg-20", label: "Sabah Environment Protection / EIA subsidiary requirements" },
      { id: "malaysia-reg-21", label: "Sarawak Natural Resources and Environment subsidiary requirements" },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_MALAYSIA = [
  {
    heading: "Malaysia ESHS Standards, Codes & Guidelines",
    description: "Sector standards, codes of practice, environmental guidelines, and ESG disclosure requirements for Malaysia.",
    items: [
      { id: "malaysia-eshs-1", label: "DOE Environmental Impact Assessment Guidelines and sector-specific EIA guidelines" },
      { id: "malaysia-eshs-2", label: "DOE Guidance Document for preparation of EIA reports" },
      { id: "malaysia-eshs-3", label: "DOE Malaysia Ambient Air Quality Standard" },
      { id: "malaysia-eshs-4", label: "DOE industrial effluent and sewage discharge standards" },
      { id: "malaysia-eshs-5", label: "DOE scheduled-waste management guidance, inventory, consignment and eSWIS requirements" },
      { id: "malaysia-eshs-6", label: "DOE Guidance on Environmental Mainstreaming Tools / environmental self-regulation, where applicable" },
      { id: "malaysia-eshs-7", label: "DOSH Industry Code of Practice on Indoor Air Quality 2010" },
      { id: "malaysia-eshs-8", label: "DOSH Guidelines for Hazard Identification, Risk Assessment and Risk Control (HIRARC)" },
      { id: "malaysia-eshs-9", label: "DOSH Chemical Health Risk Assessment (CHRA) requirements/guidance" },
      { id: "malaysia-eshs-10", label: "DOSH medical surveillance requirements for chemicals hazardous to health" },
      { id: "malaysia-eshs-11", label: "DOSH Guidelines on Occupational Safety and Health Management Systems" },
      { id: "malaysia-eshs-12", label: "DOSH guidance supporting CDM Regulations 2024" },
      { id: "malaysia-eshs-13", label: "National Policy on Biological Diversity 2022\u20132030 and related biodiversity implementation guidance" },
      { id: "malaysia-eshs-14", label: "Bursa Malaysia Main Market / ACE Market Listing Requirements on sustainability statements" },
      { id: "malaysia-eshs-15", label: "Bursa Malaysia Sustainability Reporting Guide and toolkits" },
      { id: "malaysia-eshs-16", label: "National Sustainability Reporting Framework (NSRF)" },
      { id: "malaysia-eshs-17", label: "IFRS S1 and IFRS S2 as incorporated through Malaysia's NSRF roadmap" },
      { id: "malaysia-eshs-18", label: "National Taxonomy / sustainable finance taxonomy requirements where applicable" },
      { id: "malaysia-eshs-19", label: "Bank Negara Malaysia Climate Change and Principle-based Taxonomy, where relevant to financial institutions" },
      { id: "malaysia-eshs-20", label: "Securities Commission Malaysia Sustainable and Responsible Investment guidance where applicable" },
      { id: "malaysia-eshs-21", label: "Greenhouse gas accounting / climate reporting guidance used under NSRF and sector programmes" },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_INDONESIA = [
  {
    heading: "Indonesia Primary Laws / Acts",
    description: "Primary legislative frameworks and acts governing environmental, climate, OHS, and sustainability in Indonesia.",
    items: [
      { id: "indonesia-law-1", label: "Law No. 32/2009 on Environmental Protection and Management, as amended" },
      { id: "indonesia-law-2", label: "Job Creation legal framework and environmental amendments" },
      { id: "indonesia-law-3", label: "Law No. 1/1970 on Work Safety" },
      { id: "indonesia-law-4", label: "Law No. 13/2003 on Manpower, as amended" },
      { id: "indonesia-law-5", label: "Law No. 30/2007 on Energy" },
      { id: "indonesia-law-6", label: "Law No. 18/2008 on Waste Management" },
      { id: "indonesia-law-7", label: "Law No. 3/2020 on Mineral and Coal Mining where applicable" },
      { id: "indonesia-law-8", label: "Law No. 41/1999 on Forestry, as amended" },
      { id: "indonesia-law-9", label: "Law No. 5/1990 on Conservation of Living Natural Resources and Ecosystems, as amended" },
      { id: "indonesia-law-10", label: "Law No. 17/2019 on Water Resources" },
      { id: "indonesia-law-11", label: "Company / capital-market laws supporting OJK sustainability obligations" },
    ],
  },
];

export const PROVISIONAL_TERRITORY_INDONESIA = [
  {
    heading: "Indonesia Regulations & Subsidiary Legislation",
    description: "Subsidiary regulations, orders, notifications, and decrees applicable in Indonesia.",
    items: [
      { id: "indonesia-reg-1", label: "Government Regulation No. 22/2021 on Environmental Protection and Management" },
      { id: "indonesia-reg-2", label: "Environmental approval / AMDAL / UKL-UPL / SPPL requirements" },
      { id: "indonesia-reg-3", label: "Government Regulation No. 50/2012 on SMK3" },
      { id: "indonesia-reg-4", label: "B3 hazardous waste technical requirements under PP 22/2021 and ministerial rules" },
      { id: "indonesia-reg-5", label: "Air emission and wastewater quality standards issued by the Ministry of Environment" },
      { id: "indonesia-reg-6", label: "PROPER environmental performance requirements for covered entities" },
      { id: "indonesia-reg-7", label: "Presidential Regulation No. 98/2021 on Carbon Economic Value" },
      { id: "indonesia-reg-8", label: "OJK Regulation POJK 51/POJK.03/2017 on Sustainable Finance" },
      { id: "indonesia-reg-9", label: "OJK sustainability-report requirements and implementing circulars" },
      { id: "indonesia-reg-10", label: "Sectoral energy, mining, forestry and plantation environmental regulations" },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_INDONESIA = [
  {
    heading: "Indonesia ESHS Standards, Codes & Guidelines",
    description: "Sector standards, codes of practice, environmental guidelines, and ESG disclosure requirements for Indonesia.",
    items: [
      { id: "indonesia-eshs-1", label: "AMDAL preparation and environmental approval guidance" },
      { id: "indonesia-eshs-2", label: "Environmental monitoring and management plan requirements" },
      { id: "indonesia-eshs-3", label: "PROPER assessment criteria" },
      { id: "indonesia-eshs-4", label: "SMK3 occupational safety and health management guidance" },
      { id: "indonesia-eshs-5", label: "Indonesia Green Taxonomy / Sustainable Finance Taxonomy (TKBI) current version" },
      { id: "indonesia-eshs-6", label: "OJK Sustainable Finance Roadmap and reporting guidance" },
      { id: "indonesia-eshs-7", label: "GHG inventory, MRV and carbon economic value implementation guidance" },
      { id: "indonesia-eshs-8", label: "Sector-specific emission/wastewater technical standards" },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_VIETNAM = [
  {
    heading: "Vietnam Primary Laws / Acts",
    description: "Primary legislative frameworks and acts governing environmental, climate, OHS, and sustainability in Vietnam.",
    items: [
      { id: "vietnam-law-1", label: "Law on Environmental Protection 2020" },
      { id: "vietnam-law-2", label: "Law on Occupational Safety and Health 2015" },
      { id: "vietnam-law-3", label: "Labour Code 2019" },
      { id: "vietnam-law-4", label: "Law on Chemicals 2007, as amended" },
      { id: "vietnam-law-5", label: "Law on Biodiversity 2008" },
      { id: "vietnam-law-6", label: "Law on Forestry 2017" },
      { id: "vietnam-law-7", label: "Law on Water Resources current framework" },
      { id: "vietnam-law-8", label: "Law on Economical and Efficient Use of Energy" },
      { id: "vietnam-law-9", label: "Law on Fire Prevention and Fighting, as amended" },
      { id: "vietnam-law-10", label: "Securities and corporate disclosure laws relevant to ESG reporting" },
    ],
  },
];

export const PROVISIONAL_TERRITORY_VIETNAM = [
  {
    heading: "Vietnam Regulations & Subsidiary Legislation",
    description: "Subsidiary regulations, orders, notifications, and decrees applicable in Vietnam.",
    items: [
      { id: "vietnam-reg-1", label: "Decree 08/2022/ND-CP detailing the Law on Environmental Protection, as amended" },
      { id: "vietnam-reg-2", label: "Decree 05/2025/ND-CP amending environmental implementation provisions" },
      { id: "vietnam-reg-3", label: "Environmental Impact Assessment requirements" },
      { id: "vietnam-reg-4", label: "Environmental Licence requirements" },
      { id: "vietnam-reg-5", label: "Environmental Registration requirements" },
      { id: "vietnam-reg-6", label: "Extended Producer Responsibility requirements" },
      { id: "vietnam-reg-7", label: "Decree 06/2022/ND-CP on GHG mitigation and ozone layer protection, as amended" },
      { id: "vietnam-reg-8", label: "GHG inventory list and sector implementation decisions" },
      { id: "vietnam-reg-9", label: "Hazardous waste and domestic/industrial solid-waste requirements" },
      { id: "vietnam-reg-10", label: "Occupational safety technical regulations and inspection requirements" },
      { id: "vietnam-reg-11", label: "Chemical declaration, storage and emergency-response requirements" },
      { id: "vietnam-reg-12", label: "Fire appraisal, acceptance and inspection requirements" },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_VIETNAM = [
  {
    heading: "Vietnam ESHS Standards, Codes & Guidelines",
    description: "Sector standards, codes of practice, environmental guidelines, and ESG disclosure requirements for Vietnam.",
    items: [
      { id: "vietnam-eshs-1", label: "Applicable QCVN ambient air and emission standards" },
      { id: "vietnam-eshs-2", label: "Applicable QCVN wastewater standards by sector" },
      { id: "vietnam-eshs-3", label: "Environmental monitoring technical guidance" },
      { id: "vietnam-eshs-4", label: "EIA and Environmental Licence dossier guidance" },
      { id: "vietnam-eshs-5", label: "EPR recycling / financial contribution guidance" },
      { id: "vietnam-eshs-6", label: "GHG inventory and mitigation guidance" },
      { id: "vietnam-eshs-7", label: "Energy audit and key-energy-user requirements" },
      { id: "vietnam-eshs-8", label: "Securities sustainability / ESG disclosure guidance for public and listed companies" },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_THAILAND = [
  {
    heading: "Thailand Primary Laws / Acts",
    description: "Primary legislative frameworks and acts governing environmental, climate, OHS, and sustainability in Thailand.",
    items: [
      { id: "thailand-law-1", label: "Enhancement and Conservation of National Environmental Quality Act B.E. 2535 (1992), as amended" },
      { id: "thailand-law-2", label: "Factory Act B.E. 2535 (1992), as amended" },
      { id: "thailand-law-3", label: "Hazardous Substance Act B.E. 2535 (1992), as amended" },
      { id: "thailand-law-4", label: "Occupational Safety, Health and Environment Act B.E. 2554 (2011)" },
      { id: "thailand-law-5", label: "Energy Conservation Promotion Act B.E. 2535 (1992), as amended" },
      { id: "thailand-law-6", label: "Public Health Act B.E. 2535 (1992)" },
      { id: "thailand-law-7", label: "National Park Act current framework" },
      { id: "thailand-law-8", label: "Wildlife Conservation and Protection Act current framework" },
      { id: "thailand-law-9", label: "Labour Protection Act and related worker requirements" },
      { id: "thailand-law-10", label: "Securities and Exchange Act / SEC disclosure requirements" },
    ],
  },
];

export const PROVISIONAL_TERRITORY_THAILAND = [
  {
    heading: "Thailand Regulations & Subsidiary Legislation",
    description: "Subsidiary regulations, orders, notifications, and decrees applicable in Thailand.",
    items: [
      { id: "thailand-reg-1", label: "EIA notification and prescribed project requirements" },
      { id: "thailand-reg-2", label: "EHIA requirements for projects with potentially severe impacts" },
      { id: "thailand-reg-3", label: "Factory licence / notification requirements" },
      { id: "thailand-reg-4", label: "DIW industrial wastewater, air pollution and waste controls" },
      { id: "thailand-reg-5", label: "Hazardous substance classification, notification and licensing rules" },
      { id: "thailand-reg-6", label: "Occupational safety ministerial regulations for machinery, electricity, construction, confined space, work at height, fire and chemicals" },
      { id: "thailand-reg-7", label: "Designated factory/building energy-management requirements" },
      { id: "thailand-reg-8", label: "Waste manifest and industrial waste management requirements" },
      { id: "thailand-reg-9", label: "Environmental monitoring and reporting requirements attached to EIA approvals" },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_THAILAND = [
  {
    heading: "Thailand ESHS Standards, Codes & Guidelines",
    description: "Sector standards, codes of practice, environmental guidelines, and ESG disclosure requirements for Thailand.",
    items: [
      { id: "thailand-eshs-1", label: "ONEP EIA/EHIA guidelines" },
      { id: "thailand-eshs-2", label: "Pollution Control Department ambient air, water and noise standards/guidance" },
      { id: "thailand-eshs-3", label: "Department of Industrial Works environmental requirements and manuals" },
      { id: "thailand-eshs-4", label: "Industrial waste management guidance" },
      { id: "thailand-eshs-5", label: "OSH standards and ministerial guidance" },
      { id: "thailand-eshs-6", label: "SET/SEC sustainability reporting guidance" },
      { id: "thailand-eshs-7", label: "Form 56-1 One Report sustainability disclosure requirements" },
      { id: "thailand-eshs-8", label: "Thailand ISSB-aligned sustainability disclosure roadmap / effective requirements by issuer group" },
      { id: "thailand-eshs-9", label: "SET ESG implementation guidance where applicable" },
    ],
  },
];

export const FEDRAL_LAW_REGULATION_PHILIPPINES = [
  {
    heading: "Philippines Primary Laws / Acts",
    description: "Primary legislative frameworks and acts governing environmental, climate, OHS, and sustainability in Philippines.",
    items: [
      { id: "philippines-law-1", label: "Presidential Decree No. 1586 establishing the Philippine Environmental Impact Statement System" },
      { id: "philippines-law-2", label: "Republic Act No. 8749 Philippine Clean Air Act of 1999" },
      { id: "philippines-law-3", label: "Republic Act No. 9275 Philippine Clean Water Act of 2004" },
      { id: "philippines-law-4", label: "Republic Act No. 9003 Ecological Solid Waste Management Act of 2000" },
      { id: "philippines-law-5", label: "Republic Act No. 6969 Toxic Substances and Hazardous and Nuclear Wastes Control Act of 1990" },
      { id: "philippines-law-6", label: "Republic Act No. 11898 Extended Producer Responsibility Act of 2022" },
      { id: "philippines-law-7", label: "Republic Act No. 11058 Occupational Safety and Health Standards Law" },
      { id: "philippines-law-8", label: "Republic Act No. 9513 Renewable Energy Act of 2008" },
      { id: "philippines-law-9", label: "Republic Act No. 11285 Energy Efficiency and Conservation Act" },
      { id: "philippines-law-10", label: "Republic Act No. 7586 / 11038 NIPAS / Expanded NIPAS" },
      { id: "philippines-law-11", label: "Republic Act No. 8371 Indigenous Peoples' Rights Act" },
      { id: "philippines-law-12", label: "Republic Act No. 10121 Disaster Risk Reduction and Management Act" },
      { id: "philippines-law-13", label: "Fire Code of the Philippines" },
      { id: "philippines-law-14", label: "Corporation / securities requirements relevant to sustainability reporting" },
    ],
  },
];

export const PROVISIONAL_TERRITORY_PHILIPPINES = [
  {
    heading: "Philippines Regulations & Subsidiary Legislation",
    description: "Subsidiary regulations, orders, notifications, and decrees applicable in Philippines.",
    items: [
      { id: "philippines-reg-1", label: "DENR PEISS implementing rules and ECC/CNC requirements" },
      { id: "philippines-reg-2", label: "DENR DAO 2016-08 Water Quality Guidelines and General Effluent Standards, as amended" },
      { id: "philippines-reg-3", label: "Clean Air Act implementing rules and Permit to Operate requirements" },
      { id: "philippines-reg-4", label: "Hazardous waste generator registration, manifest and transporter/TSD requirements" },
      { id: "philippines-reg-5", label: "EPR implementing rules for plastic packaging obligations" },
      { id: "philippines-reg-6", label: "DOLE Department Order 198-18 implementing RA 11058" },
      { id: "philippines-reg-7", label: "Construction Safety and Health Program requirements" },
      { id: "philippines-reg-8", label: "Energy Efficiency and Conservation implementing rules" },
      { id: "philippines-reg-9", label: "Protected area / wildlife permitting requirements" },
      { id: "philippines-reg-10", label: "Environmental monitoring, self-monitoring report and compliance monitoring report requirements" },
    ],
  },
];

export const FEDRAL_PROVINCIAL_REQ_PHILIPPINES = [
  {
    heading: "Philippines ESHS Standards, Codes & Guidelines",
    description: "Sector standards, codes of practice, environmental guidelines, and ESG disclosure requirements for Philippines.",
    items: [
      { id: "philippines-eshs-1", label: "DENR/EMB EIA Procedural Manual" },
      { id: "philippines-eshs-2", label: "Air pollution source permitting and emission-testing guidance" },
      { id: "philippines-eshs-3", label: "Water discharge permitting and monitoring guidance" },
      { id: "philippines-eshs-4", label: "Hazardous waste manifest and registration guidance" },
      { id: "philippines-eshs-5", label: "EPR compliance reporting guidance" },
      { id: "philippines-eshs-6", label: "DOLE Occupational Safety and Health Standards" },
      { id: "philippines-eshs-7", label: "Construction safety guidance" },
      { id: "philippines-eshs-8", label: "DOE energy audit / designated establishment guidance" },
      { id: "philippines-eshs-9", label: "SEC Sustainability Reporting Guidelines for Publicly Listed Companies" },
      { id: "philippines-eshs-10", label: "Current SEC sustainability reporting / IFRS sustainability disclosure transition requirements where effective" },
    ],
  },
];


export const ESG_AUTO_SYNCED_SUSTAIN_DASHBOARD = [
  {
    heading: "🛰️ Auto-Synced to ESG Vision Dashboard",
    items: [],
  },
  {
    heading: "🧾Detail Reporting",
    items: [],
  },
  {
    heading: "🌐Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd-esrs", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "World Bank (WB)" },
      { id: "ifc-pss", label: "IFC Performance Standards (PSs)" },
      { id: "equator-principles", label: "Equator Principles" },
      { id: "iso-standards", label: "ISO Standards" },
      { id: "oecd-guidelines", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000-series", label: "AA1000 Series" },
      { id: "pri-principles", label: "PRI Principles" },
      { id: "iris-plus", label: "IRIS+ (GIIN)" },
    ],
  },
  {
    heading: "🌦️Climate & Carbon Compliance",
    items: [
      { id: "ghg-emissions", label: "GHG Emissions Management" },
      { id: "climate-impact", label: "Climate Impact Assessment" },
      { id: "sustainable-finance", label: "Sustainable Finance & Bond Standards" },
      {
        id: "carbon-credit-trading",
        label: "Carbon Credit, Offset & Emission Trading",
      },
    ],
  },
  {
    heading: "⚙️Operational ESG Systems & Reporting",
    items: [
      { id: "environmental-compliance", label: "Environmental Compliance Reporting" },
      { id: "social-compliance", label: "Social Compliance Reporting" },
      {
        id: "legal-standards-mapping",
        label: "E&S Legal & Applicable Standards Mapping",
      },
      {
        id: "es-system-management",
        label: "Environmental & Social System Management",
      },
    ],
  },
  {
    heading: "🏭Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector-standard", label: "Sector / Industrial-Specific Standard" },
      { id: "country-compliance", label: "Country-Specific ESG Compliance" },
      {
        id: "operational-compliance-reporting",
        label: "Operational Compliance ESG Reporting",
      },
      {
        id: "es-due-diligence",
        label: "E&S Due Diligence for ESG Compliance",
      },
    ],
  },
  {
    heading: "📊Data Analytics",
    items: [
      { id: "esg-analytics", label: "ESG Analytics" },
      { id: "esg-benchmarking", label: "ESG Benchmarking" },
    ],
  },
  {
    heading: "🤝Supplier Selection & Compliance",
    items: [
      { id: "supplier-assessment", label: "Supplier Assessment & Compliance" },
    ],
  },
  {
    heading: "🚀Capacity & Future Development",
    items: [
      {
        id: "training-programs",
        label: "Training & Capacity Building Programs",
      },
      { id: "upcoming-features", label: "Upcoming Features" },
    ],
  },
];






export const ENVIRONMENTAL_MONITORING_Synchronized = [
  // DETAIL REPORTING – Hamesha top pe
  {
    heading: "Detail Reporting",
    items: [
      { id: "detail_reporting", label: "Detail Reporting" }
    ]
  },

  // GLOBAL ESG REPORTING
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" }
    ]
  },

  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      { id: "sustainable_finance", label: "Sustainable Finance & Bond Standards" },
      { id: "carbon_credit", label: "Carbon Credit, Offset & Emission Trading" }
    ]
  },

  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" }
    ]
  },

  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" }
    ]
  },

  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" }
    ]
  },

  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" }
    ]
  },

  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" }
    ]
  }
];